var Ul = Object.defineProperty;
var Hl = (e, t, r) => t in e ? Ul(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Nr = (e, t, r) => Hl(e, typeof t != "symbol" ? t + "" : t, r);
import * as x from "react";
import Vr, { forwardRef as ql, useContext as Gl, isValidElement as En, cloneElement as On, Children as Yl } from "react";
import { jsx as W, jsxs as bt } from "react/jsx-runtime";
import we from "clsx";
import * as Kl from "react-dom";
const Ur = {
  black: "#000",
  white: "#fff"
}, fr = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, pr = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, dr = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, mr = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, gr = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, Mr = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Xl = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function jt(e, ...t) {
  const r = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((n) => r.searchParams.append("args[]", n)), `Minified MUI error #${e}; visit ${r} for the full message.`;
}
const ri = "$$material";
function ce() {
  return ce = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ce.apply(null, arguments);
}
function Jl(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Ql(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Zl = /* @__PURE__ */ (function() {
  function e(r) {
    var n = this;
    this._insertTag = function(o) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, i), n.tags.push(o);
    }, this.isSpeedy = r.speedy === void 0 ? !0 : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Ql(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = Jl(o);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var o;
      return (o = n.parentNode) == null ? void 0 : o.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
})(), We = "-ms-", kn = "-moz-", me = "-webkit-", ys = "comm", ni = "rule", oi = "decl", ec = "@import", bs = "@keyframes", tc = "@layer", rc = Math.abs, Un = String.fromCharCode, nc = Object.assign;
function oc(e, t) {
  return je(e, 0) ^ 45 ? (((t << 2 ^ je(e, 0)) << 2 ^ je(e, 1)) << 2 ^ je(e, 2)) << 2 ^ je(e, 3) : 0;
}
function vs(e) {
  return e.trim();
}
function ic(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ge(e, t, r) {
  return e.replace(t, r);
}
function Vo(e, t) {
  return e.indexOf(t);
}
function je(e, t) {
  return e.charCodeAt(t) | 0;
}
function Hr(e, t, r) {
  return e.slice(t, r);
}
function Tt(e) {
  return e.length;
}
function ii(e) {
  return e.length;
}
function gn(e, t) {
  return t.push(e), e;
}
function ac(e, t) {
  return e.map(t).join("");
}
var Hn = 1, Cr = 1, Cs = 0, Je = 0, Me = 0, Tr = "";
function qn(e, t, r, n, o, i, s) {
  return { value: e, root: t, parent: r, type: n, props: o, children: i, line: Hn, column: Cr, length: s, return: "" };
}
function Dr(e, t) {
  return nc(qn("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function sc() {
  return Me;
}
function lc() {
  return Me = Je > 0 ? je(Tr, --Je) : 0, Cr--, Me === 10 && (Cr = 1, Hn--), Me;
}
function nt() {
  return Me = Je < Cs ? je(Tr, Je++) : 0, Cr++, Me === 10 && (Cr = 1, Hn++), Me;
}
function $t() {
  return je(Tr, Je);
}
function Tn() {
  return Je;
}
function Zr(e, t) {
  return Hr(Tr, e, t);
}
function qr(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Ss(e) {
  return Hn = Cr = 1, Cs = Tt(Tr = e), Je = 0, [];
}
function ws(e) {
  return Tr = "", e;
}
function Rn(e) {
  return vs(Zr(Je - 1, Lo(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function cc(e) {
  for (; (Me = $t()) && Me < 33; )
    nt();
  return qr(e) > 2 || qr(Me) > 3 ? "" : " ";
}
function uc(e, t) {
  for (; --t && nt() && !(Me < 48 || Me > 102 || Me > 57 && Me < 65 || Me > 70 && Me < 97); )
    ;
  return Zr(e, Tn() + (t < 6 && $t() == 32 && nt() == 32));
}
function Lo(e) {
  for (; nt(); )
    switch (Me) {
      // ] ) " '
      case e:
        return Je;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Lo(Me);
        break;
      // (
      case 40:
        e === 41 && Lo(e);
        break;
      // \
      case 92:
        nt();
        break;
    }
  return Je;
}
function fc(e, t) {
  for (; nt() && e + Me !== 57; )
    if (e + Me === 84 && $t() === 47)
      break;
  return "/*" + Zr(t, Je - 1) + "*" + Un(e === 47 ? e : nt());
}
function pc(e) {
  for (; !qr($t()); )
    nt();
  return Zr(e, Je);
}
function dc(e) {
  return ws(Pn("", null, null, null, [""], e = Ss(e), 0, [0], e));
}
function Pn(e, t, r, n, o, i, s, l, c) {
  for (var u = 0, f = 0, d = s, m = 0, h = 0, y = 0, p = 1, v = 1, w = 1, O = 0, C = "", b = o, S = i, E = n, P = C; v; )
    switch (y = O, O = nt()) {
      // (
      case 40:
        if (y != 108 && je(P, d - 1) == 58) {
          Vo(P += ge(Rn(O), "&", "&\f"), "&\f") != -1 && (w = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        P += Rn(O);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        P += cc(y);
        break;
      // \
      case 92:
        P += uc(Tn() - 1, 7);
        continue;
      // /
      case 47:
        switch ($t()) {
          case 42:
          case 47:
            gn(mc(fc(nt(), Tn()), t, r), c);
            break;
          default:
            P += "/";
        }
        break;
      // {
      case 123 * p:
        l[u++] = Tt(P) * w;
      // } ; \0
      case 125 * p:
      case 59:
      case 0:
        switch (O) {
          // \0 }
          case 0:
          case 125:
            v = 0;
          // ;
          case 59 + f:
            w == -1 && (P = ge(P, /\f/g, "")), h > 0 && Tt(P) - d && gn(h > 32 ? Ui(P + ";", n, r, d - 1) : Ui(ge(P, " ", "") + ";", n, r, d - 2), c);
            break;
          // @ ;
          case 59:
            P += ";";
          // { rule/at-rule
          default:
            if (gn(E = Wi(P, t, r, u, f, o, l, C, b = [], S = [], d), i), O === 123)
              if (f === 0)
                Pn(P, t, E, E, b, i, d, l, S);
              else
                switch (m === 99 && je(P, 3) === 110 ? 100 : m) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Pn(e, E, E, n && gn(Wi(e, E, E, 0, 0, o, l, C, o, b = [], d), S), o, S, d, l, n ? b : S);
                    break;
                  default:
                    Pn(P, E, E, E, [""], S, 0, l, S);
                }
        }
        u = f = h = 0, p = w = 1, C = P = "", d = s;
        break;
      // :
      case 58:
        d = 1 + Tt(P), h = y;
      default:
        if (p < 1) {
          if (O == 123)
            --p;
          else if (O == 125 && p++ == 0 && lc() == 125)
            continue;
        }
        switch (P += Un(O), O * p) {
          // &
          case 38:
            w = f > 0 ? 1 : (P += "\f", -1);
            break;
          // ,
          case 44:
            l[u++] = (Tt(P) - 1) * w, w = 1;
            break;
          // @
          case 64:
            $t() === 45 && (P += Rn(nt())), m = $t(), f = d = Tt(C = P += pc(Tn())), O++;
            break;
          // -
          case 45:
            y === 45 && Tt(P) == 2 && (p = 0);
        }
    }
  return i;
}
function Wi(e, t, r, n, o, i, s, l, c, u, f) {
  for (var d = o - 1, m = o === 0 ? i : [""], h = ii(m), y = 0, p = 0, v = 0; y < n; ++y)
    for (var w = 0, O = Hr(e, d + 1, d = rc(p = s[y])), C = e; w < h; ++w)
      (C = vs(p > 0 ? m[w] + " " + O : ge(O, /&\f/g, m[w]))) && (c[v++] = C);
  return qn(e, t, r, o === 0 ? ni : l, c, u, f);
}
function mc(e, t, r) {
  return qn(e, t, r, ys, Un(sc()), Hr(e, 2, -2), 0);
}
function Ui(e, t, r, n) {
  return qn(e, t, r, oi, Hr(e, 0, n), Hr(e, n + 1, -1), n);
}
function br(e, t) {
  for (var r = "", n = ii(e), o = 0; o < n; o++)
    r += t(e[o], o, e, t) || "";
  return r;
}
function gc(e, t, r, n) {
  switch (e.type) {
    case tc:
      if (e.children.length) break;
    case ec:
    case oi:
      return e.return = e.return || e.value;
    case ys:
      return "";
    case bs:
      return e.return = e.value + "{" + br(e.children, n) + "}";
    case ni:
      e.value = e.props.join(",");
  }
  return Tt(r = br(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function hc(e) {
  var t = ii(e);
  return function(r, n, o, i) {
    for (var s = "", l = 0; l < t; l++)
      s += e[l](r, n, o, i) || "";
    return s;
  };
}
function yc(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function xs(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var bc = function(t, r, n) {
  for (var o = 0, i = 0; o = i, i = $t(), o === 38 && i === 12 && (r[n] = 1), !qr(i); )
    nt();
  return Zr(t, Je);
}, vc = function(t, r) {
  var n = -1, o = 44;
  do
    switch (qr(o)) {
      case 0:
        o === 38 && $t() === 12 && (r[n] = 1), t[n] += bc(Je - 1, r, n);
        break;
      case 2:
        t[n] += Rn(o);
        break;
      case 4:
        if (o === 44) {
          t[++n] = $t() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      // fallthrough
      default:
        t[n] += Un(o);
    }
  while (o = nt());
  return t;
}, Cc = function(t, r) {
  return ws(vc(Ss(t), r));
}, Hi = /* @__PURE__ */ new WeakMap(), Sc = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, o = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !Hi.get(n)) && !o) {
      Hi.set(t, !0);
      for (var i = [], s = Cc(r, i), l = n.props, c = 0, u = 0; c < s.length; c++)
        for (var f = 0; f < l.length; f++, u++)
          t.props[u] = i[c] ? s[c].replace(/&\f/g, l[f]) : l[f] + " " + s[c];
    }
  }
}, wc = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Es(e, t) {
  switch (oc(e, t)) {
    // color-adjust
    case 5103:
      return me + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return me + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return me + e + kn + e + We + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return me + e + We + e + e;
    // order
    case 6165:
      return me + e + We + "flex-" + e + e;
    // align-items
    case 5187:
      return me + e + ge(e, /(\w+).+(:[^]+)/, me + "box-$1$2" + We + "flex-$1$2") + e;
    // align-self
    case 5443:
      return me + e + We + "flex-item-" + ge(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return me + e + We + "flex-line-pack" + ge(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return me + e + We + ge(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return me + e + We + ge(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return me + "box-" + ge(e, "-grow", "") + me + e + We + ge(e, "grow", "positive") + e;
    // transition
    case 4554:
      return me + ge(e, /([^-])(transform)/g, "$1" + me + "$2") + e;
    // cursor
    case 6187:
      return ge(ge(ge(e, /(zoom-|grab)/, me + "$1"), /(image-set)/, me + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return ge(e, /(image-set\([^]*)/, me + "$1$`$1");
    // justify-content
    case 4968:
      return ge(ge(e, /(.+:)(flex-)?(.*)/, me + "box-pack:$3" + We + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + me + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ge(e, /(.+)-inline(.+)/, me + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Tt(e) - 1 - t > 6) switch (je(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (je(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return ge(e, /(.+:)(.+)-([^]+)/, "$1" + me + "$2-$3$1" + kn + (je(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~Vo(e, "stretch") ? Es(ge(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (je(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (je(e, Tt(e) - 3 - (~Vo(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return ge(e, ":", ":" + me) + e;
        // (inline-)?fl(e)x
        case 101:
          return ge(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + me + (je(e, 14) === 45 ? "inline-" : "") + "box$3$1" + me + "$2$3$1" + We + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (je(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return me + e + We + ge(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return me + e + We + ge(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return me + e + We + ge(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return me + e + We + e + e;
  }
  return e;
}
var xc = function(t, r, n, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case oi:
      t.return = Es(t.value, t.length);
      break;
    case bs:
      return br([Dr(t, {
        value: ge(t.value, "@", "@" + me)
      })], o);
    case ni:
      if (t.length) return ac(t.props, function(i) {
        switch (ic(i, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return br([Dr(t, {
              props: [ge(i, /:(read-\w+)/, ":" + kn + "$1")]
            })], o);
          // :placeholder
          case "::placeholder":
            return br([Dr(t, {
              props: [ge(i, /:(plac\w+)/, ":" + me + "input-$1")]
            }), Dr(t, {
              props: [ge(i, /:(plac\w+)/, ":" + kn + "$1")]
            }), Dr(t, {
              props: [ge(i, /:(plac\w+)/, We + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, Ec = [xc], Oc = function(t) {
  var r = t.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(p) {
      var v = p.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || Ec, i = {}, s, l = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(p) {
      for (var v = p.getAttribute("data-emotion").split(" "), w = 1; w < v.length; w++)
        i[v[w]] = !0;
      l.push(p);
    }
  );
  var c, u = [Sc, wc];
  {
    var f, d = [gc, yc(function(p) {
      f.insert(p);
    })], m = hc(u.concat(o, d)), h = function(v) {
      return br(dc(v), m);
    };
    c = function(v, w, O, C) {
      f = O, h(v ? v + "{" + w.styles + "}" : w.styles), C && (y.inserted[w.name] = !0);
    };
  }
  var y = {
    key: r,
    sheet: new Zl({
      key: r,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return y.sheet.hydrate(l), y;
}, Ih = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Tc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function kh(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      var o = !1;
      try {
        o = this instanceof n;
      } catch {
      }
      return o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var hn = { exports: {} }, he = {};
var qi;
function Rc() {
  if (qi) return he;
  qi = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, r = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, n = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, o = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, i = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, s = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, l = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, c = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, u = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, f = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, d = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, m = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, h = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, y = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, p = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, v = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, w = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, O = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function C(S) {
    if (typeof S == "object" && S !== null) {
      var E = S.$$typeof;
      switch (E) {
        case t:
          switch (S = S.type, S) {
            case c:
            case u:
            case n:
            case i:
            case o:
            case d:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case l:
                case f:
                case y:
                case h:
                case s:
                  return S;
                default:
                  return E;
              }
          }
        case r:
          return E;
      }
    }
  }
  function b(S) {
    return C(S) === u;
  }
  return he.AsyncMode = c, he.ConcurrentMode = u, he.ContextConsumer = l, he.ContextProvider = s, he.Element = t, he.ForwardRef = f, he.Fragment = n, he.Lazy = y, he.Memo = h, he.Portal = r, he.Profiler = i, he.StrictMode = o, he.Suspense = d, he.isAsyncMode = function(S) {
    return b(S) || C(S) === c;
  }, he.isConcurrentMode = b, he.isContextConsumer = function(S) {
    return C(S) === l;
  }, he.isContextProvider = function(S) {
    return C(S) === s;
  }, he.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, he.isForwardRef = function(S) {
    return C(S) === f;
  }, he.isFragment = function(S) {
    return C(S) === n;
  }, he.isLazy = function(S) {
    return C(S) === y;
  }, he.isMemo = function(S) {
    return C(S) === h;
  }, he.isPortal = function(S) {
    return C(S) === r;
  }, he.isProfiler = function(S) {
    return C(S) === i;
  }, he.isStrictMode = function(S) {
    return C(S) === o;
  }, he.isSuspense = function(S) {
    return C(S) === d;
  }, he.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === u || S === i || S === o || S === d || S === m || typeof S == "object" && S !== null && (S.$$typeof === y || S.$$typeof === h || S.$$typeof === s || S.$$typeof === l || S.$$typeof === f || S.$$typeof === v || S.$$typeof === w || S.$$typeof === O || S.$$typeof === p);
  }, he.typeOf = C, he;
}
var ye = {};
var Gi;
function Pc() {
  return Gi || (Gi = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, r = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, n = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, o = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, i = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, s = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, l = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, c = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, u = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, f = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, d = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, m = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, h = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, y = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, p = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, v = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, w = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, O = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
    function C(N) {
      return typeof N == "string" || typeof N == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      N === n || N === u || N === i || N === o || N === d || N === m || typeof N == "object" && N !== null && (N.$$typeof === y || N.$$typeof === h || N.$$typeof === s || N.$$typeof === l || N.$$typeof === f || N.$$typeof === v || N.$$typeof === w || N.$$typeof === O || N.$$typeof === p);
    }
    function b(N) {
      if (typeof N == "object" && N !== null) {
        var Re = N.$$typeof;
        switch (Re) {
          case t:
            var ae = N.type;
            switch (ae) {
              case c:
              case u:
              case n:
              case i:
              case o:
              case d:
                return ae;
              default:
                var ue = ae && ae.$$typeof;
                switch (ue) {
                  case l:
                  case f:
                  case y:
                  case h:
                  case s:
                    return ue;
                  default:
                    return Re;
                }
            }
          case r:
            return Re;
        }
      }
    }
    var S = c, E = u, P = l, V = s, D = t, g = f, $ = n, k = y, _ = h, G = r, te = i, Y = o, Z = d, pe = !1;
    function B(N) {
      return pe || (pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(N) || b(N) === c;
    }
    function A(N) {
      return b(N) === u;
    }
    function M(N) {
      return b(N) === l;
    }
    function H(N) {
      return b(N) === s;
    }
    function K(N) {
      return typeof N == "object" && N !== null && N.$$typeof === t;
    }
    function j(N) {
      return b(N) === f;
    }
    function z(N) {
      return b(N) === n;
    }
    function J(N) {
      return b(N) === y;
    }
    function X(N) {
      return b(N) === h;
    }
    function L(N) {
      return b(N) === r;
    }
    function q(N) {
      return b(N) === i;
    }
    function re(N) {
      return b(N) === o;
    }
    function Te(N) {
      return b(N) === d;
    }
    ye.AsyncMode = S, ye.ConcurrentMode = E, ye.ContextConsumer = P, ye.ContextProvider = V, ye.Element = D, ye.ForwardRef = g, ye.Fragment = $, ye.Lazy = k, ye.Memo = _, ye.Portal = G, ye.Profiler = te, ye.StrictMode = Y, ye.Suspense = Z, ye.isAsyncMode = B, ye.isConcurrentMode = A, ye.isContextConsumer = M, ye.isContextProvider = H, ye.isElement = K, ye.isForwardRef = j, ye.isFragment = z, ye.isLazy = J, ye.isMemo = X, ye.isPortal = L, ye.isProfiler = q, ye.isStrictMode = re, ye.isSuspense = Te, ye.isValidElementType = C, ye.typeOf = b;
  })()), ye;
}
var Yi;
function ai() {
  return Yi || (Yi = 1, process.env.NODE_ENV === "production" ? hn.exports = Rc() : hn.exports = Pc()), hn.exports;
}
var Co, Ki;
function $c() {
  if (Ki) return Co;
  Ki = 1;
  var e = ai(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, r = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, n = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = n, i[e.Memo] = o;
  function s(y) {
    return e.isMemo(y) ? o : i[y.$$typeof] || t;
  }
  var l = Object.defineProperty, c = Object.getOwnPropertyNames, u = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, d = Object.getPrototypeOf, m = Object.prototype;
  function h(y, p, v) {
    if (typeof p != "string") {
      if (m) {
        var w = d(p);
        w && w !== m && h(y, w, v);
      }
      var O = c(p);
      u && (O = O.concat(u(p)));
      for (var C = s(y), b = s(p), S = 0; S < O.length; ++S) {
        var E = O[S];
        if (!r[E] && !(v && v[E]) && !(b && b[E]) && !(C && C[E])) {
          var P = f(p, E);
          try {
            l(y, E, P);
          } catch {
          }
        }
      }
    }
    return y;
  }
  return Co = h, Co;
}
$c();
var Ic = !0;
function Os(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : o && (n += o + " ");
  }), n;
}
var si = function(t, r, n) {
  var o = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Ic === !1) && t.registered[o] === void 0 && (t.registered[o] = r.styles);
}, li = function(t, r, n) {
  si(t, r, n);
  var o = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var i = r;
    do
      t.insert(r === i ? "." + o : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function kc(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Ac = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Nc = /[A-Z]|^ms/g, Mc = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Ts = function(t) {
  return t.charCodeAt(1) === 45;
}, Xi = function(t) {
  return t != null && typeof t != "boolean";
}, So = /* @__PURE__ */ xs(function(e) {
  return Ts(e) ? e : e.replace(Nc, "-$&").toLowerCase();
}), Ji = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(Mc, function(n, o, i) {
          return Rt = {
            name: o,
            styles: i,
            next: Rt
          }, o;
        });
  }
  return Ac[t] !== 1 && !Ts(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
function Gr(e, t, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var o = r;
      if (o.anim === 1)
        return Rt = {
          name: o.name,
          styles: o.styles,
          next: Rt
        }, o.name;
      var i = r;
      if (i.styles !== void 0) {
        var s = i.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Rt = {
              name: s.name,
              styles: s.styles,
              next: Rt
            }, s = s.next;
        var l = i.styles + ";";
        return l;
      }
      return Dc(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var c = Rt, u = r(e);
        return Rt = c, Gr(e, t, u);
      }
      break;
    }
  }
  var f = r;
  if (t == null)
    return f;
  var d = t[f];
  return d !== void 0 ? d : f;
}
function Dc(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var o = 0; o < r.length; o++)
      n += Gr(e, t, r[o]) + ";";
  else
    for (var i in r) {
      var s = r[i];
      if (typeof s != "object") {
        var l = s;
        t != null && t[l] !== void 0 ? n += i + "{" + t[l] + "}" : Xi(l) && (n += So(i) + ":" + Ji(i, l) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var c = 0; c < s.length; c++)
          Xi(s[c]) && (n += So(i) + ":" + Ji(i, s[c]) + ";");
      else {
        var u = Gr(e, t, s);
        switch (i) {
          case "animation":
          case "animationName": {
            n += So(i) + ":" + u + ";";
            break;
          }
          default:
            n += i + "{" + u + "}";
        }
      }
    }
  return n;
}
var Qi = /label:\s*([^\s;{]+)\s*(;|$)/g, Rt;
function en(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, o = "";
  Rt = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    n = !1, o += Gr(r, t, i);
  else {
    var s = i;
    o += s[0];
  }
  for (var l = 1; l < e.length; l++)
    if (o += Gr(r, t, e[l]), n) {
      var c = i;
      o += c[l];
    }
  Qi.lastIndex = 0;
  for (var u = "", f; (f = Qi.exec(o)) !== null; )
    u += "-" + f[1];
  var d = kc(o) + u;
  return {
    name: d,
    styles: o,
    next: Rt
  };
}
var _c = function(t) {
  return t();
}, Rs = x.useInsertionEffect ? x.useInsertionEffect : !1, Ps = Rs || _c, Zi = Rs || x.useLayoutEffect, $s = /* @__PURE__ */ x.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ Oc({
    key: "css"
  }) : null
);
$s.Provider;
var ci = function(t) {
  return /* @__PURE__ */ ql(function(r, n) {
    var o = Gl($s);
    return t(r, o, n);
  });
}, Gn = /* @__PURE__ */ x.createContext({}), ui = {}.hasOwnProperty, jo = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Fc = function(t, r) {
  var n = {};
  for (var o in r)
    ui.call(r, o) && (n[o] = r[o]);
  return n[jo] = t, n;
}, Vc = function(t) {
  var r = t.cache, n = t.serialized, o = t.isStringTag;
  return si(r, n, o), Ps(function() {
    return li(r, n, o);
  }), null;
}, Lc = /* @__PURE__ */ ci(function(e, t, r) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var o = e[jo], i = [n], s = "";
  typeof e.className == "string" ? s = Os(t.registered, i, e.className) : e.className != null && (s = e.className + " ");
  var l = en(i, void 0, x.useContext(Gn));
  s += t.key + "-" + l.name;
  var c = {};
  for (var u in e)
    ui.call(e, u) && u !== "css" && u !== jo && (c[u] = e[u]);
  return c.className = s, r && (c.ref = r), /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(Vc, {
    cache: t,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ x.createElement(o, c));
}), jc = Lc, ea = function(t, r) {
  var n = arguments;
  if (r == null || !ui.call(r, "css"))
    return x.createElement.apply(void 0, n);
  var o = n.length, i = new Array(o);
  i[0] = jc, i[1] = Fc(t, r);
  for (var s = 2; s < o; s++)
    i[s] = n[s];
  return x.createElement.apply(null, i);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(ea || (ea = {}));
var Bc = /* @__PURE__ */ ci(function(e, t) {
  var r = e.styles, n = en([r], void 0, x.useContext(Gn)), o = x.useRef();
  return Zi(function() {
    var i = t.key + "-global", s = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), l = !1, c = document.querySelector('style[data-emotion="' + i + " " + n.name + '"]');
    return t.sheet.tags.length && (s.before = t.sheet.tags[0]), c !== null && (l = !0, c.setAttribute("data-emotion", i), s.hydrate([c])), o.current = [s, l], function() {
      s.flush();
    };
  }, [t]), Zi(function() {
    var i = o.current, s = i[0], l = i[1];
    if (l) {
      i[1] = !1;
      return;
    }
    if (n.next !== void 0 && li(t, n.next, !0), s.tags.length) {
      var c = s.tags[s.tags.length - 1].nextElementSibling;
      s.before = c, s.flush();
    }
    t.insert("", n, s, !1);
  }, [t, n.name]), null;
});
function fi() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return en(t);
}
function tn() {
  var e = fi.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var zc = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Wc = /* @__PURE__ */ xs(
  function(e) {
    return zc.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Uc = Wc, Hc = function(t) {
  return t !== "theme";
}, ta = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? Uc : Hc;
}, ra = function(t, r, n) {
  var o;
  if (r) {
    var i = r.shouldForwardProp;
    o = t.__emotion_forwardProp && i ? function(s) {
      return t.__emotion_forwardProp(s) && i(s);
    } : i;
  }
  return typeof o != "function" && n && (o = t.__emotion_forwardProp), o;
}, qc = function(t) {
  var r = t.cache, n = t.serialized, o = t.isStringTag;
  return si(r, n, o), Ps(function() {
    return li(r, n, o);
  }), null;
}, Gc = function e(t, r) {
  var n = t.__emotion_real === t, o = n && t.__emotion_base || t, i, s;
  r !== void 0 && (i = r.label, s = r.target);
  var l = ra(t, r, n), c = l || ta(o), u = !c("as");
  return function() {
    var f = arguments, d = n && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && d.push("label:" + i + ";"), f[0] == null || f[0].raw === void 0)
      d.push.apply(d, f);
    else {
      var m = f[0];
      d.push(m[0]);
      for (var h = f.length, y = 1; y < h; y++)
        d.push(f[y], m[y]);
    }
    var p = ci(function(v, w, O) {
      var C = u && v.as || o, b = "", S = [], E = v;
      if (v.theme == null) {
        E = {};
        for (var P in v)
          E[P] = v[P];
        E.theme = x.useContext(Gn);
      }
      typeof v.className == "string" ? b = Os(w.registered, S, v.className) : v.className != null && (b = v.className + " ");
      var V = en(d.concat(S), w.registered, E);
      b += w.key + "-" + V.name, s !== void 0 && (b += " " + s);
      var D = u && l === void 0 ? ta(C) : c, g = {};
      for (var $ in v)
        u && $ === "as" || D($) && (g[$] = v[$]);
      return g.className = b, O && (g.ref = O), /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(qc, {
        cache: w,
        serialized: V,
        isStringTag: typeof C == "string"
      }), /* @__PURE__ */ x.createElement(C, g));
    });
    return p.displayName = i !== void 0 ? i : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", p.defaultProps = t.defaultProps, p.__emotion_real = p, p.__emotion_base = o, p.__emotion_styles = d, p.__emotion_forwardProp = l, Object.defineProperty(p, "toString", {
      value: function() {
        return "." + s;
      }
    }), p.withComponent = function(v, w) {
      var O = e(v, ce({}, r, w, {
        shouldForwardProp: ra(p, w, !0)
      }));
      return O.apply(void 0, d);
    }, p;
  };
}, Yc = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Bo = Gc.bind(null);
Yc.forEach(function(e) {
  Bo[e] = Bo(e);
});
var yn = { exports: {} };
var wo, na;
function Kc() {
  if (na) return wo;
  na = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, l = 0; l < 10; l++)
        s["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(s).map(function(f) {
        return s[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        u[f] = f;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return wo = o() ? Object.assign : function(i, s) {
    for (var l, c = n(i), u, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var d in l)
        t.call(l, d) && (c[d] = l[d]);
      if (e) {
        u = e(l);
        for (var m = 0; m < u.length; m++)
          r.call(l, u[m]) && (c[u[m]] = l[u[m]]);
      }
    }
    return c;
  }, wo;
}
var xo, oa;
function pi() {
  if (oa) return xo;
  oa = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return xo = e, xo;
}
var Eo, ia;
function Is() {
  return ia || (ia = 1, Eo = Function.call.bind(Object.prototype.hasOwnProperty)), Eo;
}
var Oo, aa;
function Xc() {
  if (aa) return Oo;
  aa = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ pi(), r = {}, n = /* @__PURE__ */ Is();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console != "undefined" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, l, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (n(i, f)) {
          var d;
          try {
            if (typeof i[f] != "function") {
              var m = Error(
                (c || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            d = i[f](s, f, c, l, null, t);
          } catch (y) {
            d = y;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in r)) {
            r[d.message] = !0;
            var h = u ? u() : "";
            e(
              "Failed " + l + " type: " + d.message + (h != null ? h : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Oo = o, Oo;
}
var To, sa;
function Jc() {
  if (sa) return To;
  sa = 1;
  var e = ai(), t = Kc(), r = /* @__PURE__ */ pi(), n = /* @__PURE__ */ Is(), o = /* @__PURE__ */ Xc(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var c = "Warning: " + l;
    typeof console != "undefined" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return To = function(l, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function d(A) {
      var M = A && (u && A[u] || A[f]);
      if (typeof M == "function")
        return M;
    }
    var m = "<<anonymous>>", h = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: O(),
      arrayOf: C,
      element: b(),
      elementType: S(),
      instanceOf: E,
      node: g(),
      objectOf: V,
      oneOf: P,
      oneOfType: D,
      shape: k,
      exact: _
    };
    function y(A, M) {
      return A === M ? A !== 0 || 1 / A === 1 / M : A !== A && M !== M;
    }
    function p(A, M) {
      this.message = A, this.data = M && typeof M == "object" ? M : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function v(A) {
      if (process.env.NODE_ENV !== "production")
        var M = {}, H = 0;
      function K(z, J, X, L, q, re, Te) {
        if (L = L || m, re = re || X, Te !== r) {
          if (c) {
            var N = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw N.name = "Invariant Violation", N;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var Re = L + ":" + X;
            !M[Re] && // Avoid spamming the console because they are often not actionable except for lib authors
            H < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + re + "` prop on `" + L + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), M[Re] = !0, H++);
          }
        }
        return J[X] == null ? z ? J[X] === null ? new p("The " + q + " `" + re + "` is marked as required " + ("in `" + L + "`, but its value is `null`.")) : new p("The " + q + " `" + re + "` is marked as required in " + ("`" + L + "`, but its value is `undefined`.")) : null : A(J, X, L, q, re);
      }
      var j = K.bind(null, !1);
      return j.isRequired = K.bind(null, !0), j;
    }
    function w(A) {
      function M(H, K, j, z, J, X) {
        var L = H[K], q = Y(L);
        if (q !== A) {
          var re = Z(L);
          return new p(
            "Invalid " + z + " `" + J + "` of type " + ("`" + re + "` supplied to `" + j + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return v(M);
    }
    function O() {
      return v(s);
    }
    function C(A) {
      function M(H, K, j, z, J) {
        if (typeof A != "function")
          return new p("Property `" + J + "` of component `" + j + "` has invalid PropType notation inside arrayOf.");
        var X = H[K];
        if (!Array.isArray(X)) {
          var L = Y(X);
          return new p("Invalid " + z + " `" + J + "` of type " + ("`" + L + "` supplied to `" + j + "`, expected an array."));
        }
        for (var q = 0; q < X.length; q++) {
          var re = A(X, q, j, z, J + "[" + q + "]", r);
          if (re instanceof Error)
            return re;
        }
        return null;
      }
      return v(M);
    }
    function b() {
      function A(M, H, K, j, z) {
        var J = M[H];
        if (!l(J)) {
          var X = Y(J);
          return new p("Invalid " + j + " `" + z + "` of type " + ("`" + X + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(A);
    }
    function S() {
      function A(M, H, K, j, z) {
        var J = M[H];
        if (!e.isValidElementType(J)) {
          var X = Y(J);
          return new p("Invalid " + j + " `" + z + "` of type " + ("`" + X + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(A);
    }
    function E(A) {
      function M(H, K, j, z, J) {
        if (!(H[K] instanceof A)) {
          var X = A.name || m, L = B(H[K]);
          return new p("Invalid " + z + " `" + J + "` of type " + ("`" + L + "` supplied to `" + j + "`, expected ") + ("instance of `" + X + "`."));
        }
        return null;
      }
      return v(M);
    }
    function P(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function M(H, K, j, z, J) {
        for (var X = H[K], L = 0; L < A.length; L++)
          if (y(X, A[L]))
            return null;
        var q = JSON.stringify(A, function(Te, N) {
          var Re = Z(N);
          return Re === "symbol" ? String(N) : N;
        });
        return new p("Invalid " + z + " `" + J + "` of value `" + String(X) + "` " + ("supplied to `" + j + "`, expected one of " + q + "."));
      }
      return v(M);
    }
    function V(A) {
      function M(H, K, j, z, J) {
        if (typeof A != "function")
          return new p("Property `" + J + "` of component `" + j + "` has invalid PropType notation inside objectOf.");
        var X = H[K], L = Y(X);
        if (L !== "object")
          return new p("Invalid " + z + " `" + J + "` of type " + ("`" + L + "` supplied to `" + j + "`, expected an object."));
        for (var q in X)
          if (n(X, q)) {
            var re = A(X, q, j, z, J + "." + q, r);
            if (re instanceof Error)
              return re;
          }
        return null;
      }
      return v(M);
    }
    function D(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var M = 0; M < A.length; M++) {
        var H = A[M];
        if (typeof H != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + pe(H) + " at index " + M + "."
          ), s;
      }
      function K(j, z, J, X, L) {
        for (var q = [], re = 0; re < A.length; re++) {
          var Te = A[re], N = Te(j, z, J, X, L, r);
          if (N == null)
            return null;
          N.data && n(N.data, "expectedType") && q.push(N.data.expectedType);
        }
        var Re = q.length > 0 ? ", expected one of type [" + q.join(", ") + "]" : "";
        return new p("Invalid " + X + " `" + L + "` supplied to " + ("`" + J + "`" + Re + "."));
      }
      return v(K);
    }
    function g() {
      function A(M, H, K, j, z) {
        return G(M[H]) ? null : new p("Invalid " + j + " `" + z + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return v(A);
    }
    function $(A, M, H, K, j) {
      return new p(
        (A || "React class") + ": " + M + " type `" + H + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + j + "`."
      );
    }
    function k(A) {
      function M(H, K, j, z, J) {
        var X = H[K], L = Y(X);
        if (L !== "object")
          return new p("Invalid " + z + " `" + J + "` of type `" + L + "` " + ("supplied to `" + j + "`, expected `object`."));
        for (var q in A) {
          var re = A[q];
          if (typeof re != "function")
            return $(j, z, J, q, Z(re));
          var Te = re(X, q, j, z, J + "." + q, r);
          if (Te)
            return Te;
        }
        return null;
      }
      return v(M);
    }
    function _(A) {
      function M(H, K, j, z, J) {
        var X = H[K], L = Y(X);
        if (L !== "object")
          return new p("Invalid " + z + " `" + J + "` of type `" + L + "` " + ("supplied to `" + j + "`, expected `object`."));
        var q = t({}, H[K], A);
        for (var re in q) {
          var Te = A[re];
          if (n(A, re) && typeof Te != "function")
            return $(j, z, J, re, Z(Te));
          if (!Te)
            return new p(
              "Invalid " + z + " `" + J + "` key `" + re + "` supplied to `" + j + "`.\nBad object: " + JSON.stringify(H[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var N = Te(X, re, j, z, J + "." + re, r);
          if (N)
            return N;
        }
        return null;
      }
      return v(M);
    }
    function G(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(G);
          if (A === null || l(A))
            return !0;
          var M = d(A);
          if (M) {
            var H = M.call(A), K;
            if (M !== A.entries) {
              for (; !(K = H.next()).done; )
                if (!G(K.value))
                  return !1;
            } else
              for (; !(K = H.next()).done; ) {
                var j = K.value;
                if (j && !G(j[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function te(A, M) {
      return A === "symbol" ? !0 : M ? M["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && M instanceof Symbol : !1;
    }
    function Y(A) {
      var M = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : te(M, A) ? "symbol" : M;
    }
    function Z(A) {
      if (typeof A == "undefined" || A === null)
        return "" + A;
      var M = Y(A);
      if (M === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return M;
    }
    function pe(A) {
      var M = Z(A);
      switch (M) {
        case "array":
        case "object":
          return "an " + M;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + M;
        default:
          return M;
      }
    }
    function B(A) {
      return !A.constructor || !A.constructor.name ? m : A.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, To;
}
var Ro, la;
function Qc() {
  if (la) return Ro;
  la = 1;
  var e = /* @__PURE__ */ pi();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Ro = function() {
    function n(s, l, c, u, f, d) {
      if (d !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Ro;
}
var ca;
function Zc() {
  if (ca) return yn.exports;
  if (ca = 1, process.env.NODE_ENV !== "production") {
    var e = ai(), t = !0;
    yn.exports = /* @__PURE__ */ Jc()(e.isElement, t);
  } else
    yn.exports = /* @__PURE__ */ Qc()();
  return yn.exports;
}
var eu = /* @__PURE__ */ Zc();
const a = /* @__PURE__ */ Tc(eu);
function tu(e) {
  return e == null || Object.keys(e).length === 0;
}
function ks(e) {
  const {
    styles: t,
    defaultTheme: r = {}
  } = e;
  return /* @__PURE__ */ W(Bc, {
    styles: typeof t == "function" ? (o) => t(tu(o) ? r : o) : t
  });
}
process.env.NODE_ENV !== "production" && (ks.propTypes = {
  defaultTheme: a.object,
  styles: a.oneOfType([a.array, a.string, a.object, a.func])
});
function ru(e, t) {
  const r = Bo(e, t);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), r(...n);
  } : r;
}
function nu(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const ua = [];
function qt(e) {
  return ua[0] = e, en(ua);
}
var bn = { exports: {} }, Ce = {};
var fa;
function ou() {
  if (fa) return Ce;
  fa = 1;
  var e = /* @__PURE__ */ Symbol.for("react.transitional.element"), t = /* @__PURE__ */ Symbol.for("react.portal"), r = /* @__PURE__ */ Symbol.for("react.fragment"), n = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), i = /* @__PURE__ */ Symbol.for("react.consumer"), s = /* @__PURE__ */ Symbol.for("react.context"), l = /* @__PURE__ */ Symbol.for("react.forward_ref"), c = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), d = /* @__PURE__ */ Symbol.for("react.lazy"), m = /* @__PURE__ */ Symbol.for("react.view_transition"), h = /* @__PURE__ */ Symbol.for("react.client.reference");
  function y(p) {
    if (typeof p == "object" && p !== null) {
      var v = p.$$typeof;
      switch (v) {
        case e:
          switch (p = p.type, p) {
            case r:
            case o:
            case n:
            case c:
            case u:
            case m:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case s:
                case l:
                case d:
                case f:
                  return p;
                case i:
                  return p;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return Ce.ContextConsumer = i, Ce.ContextProvider = s, Ce.Element = e, Ce.ForwardRef = l, Ce.Fragment = r, Ce.Lazy = d, Ce.Memo = f, Ce.Portal = t, Ce.Profiler = o, Ce.StrictMode = n, Ce.Suspense = c, Ce.SuspenseList = u, Ce.isContextConsumer = function(p) {
    return y(p) === i;
  }, Ce.isContextProvider = function(p) {
    return y(p) === s;
  }, Ce.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === e;
  }, Ce.isForwardRef = function(p) {
    return y(p) === l;
  }, Ce.isFragment = function(p) {
    return y(p) === r;
  }, Ce.isLazy = function(p) {
    return y(p) === d;
  }, Ce.isMemo = function(p) {
    return y(p) === f;
  }, Ce.isPortal = function(p) {
    return y(p) === t;
  }, Ce.isProfiler = function(p) {
    return y(p) === o;
  }, Ce.isStrictMode = function(p) {
    return y(p) === n;
  }, Ce.isSuspense = function(p) {
    return y(p) === c;
  }, Ce.isSuspenseList = function(p) {
    return y(p) === u;
  }, Ce.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === o || p === n || p === c || p === u || typeof p == "object" && p !== null && (p.$$typeof === d || p.$$typeof === f || p.$$typeof === s || p.$$typeof === i || p.$$typeof === l || p.$$typeof === h || p.getModuleId !== void 0);
  }, Ce.typeOf = y, Ce;
}
var Se = {};
var pa;
function iu() {
  return pa || (pa = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(p) {
      if (typeof p == "object" && p !== null) {
        var v = p.$$typeof;
        switch (v) {
          case t:
            switch (p = p.type, p) {
              case n:
              case i:
              case o:
              case u:
              case f:
              case h:
                return p;
              default:
                switch (p = p && p.$$typeof, p) {
                  case l:
                  case c:
                  case m:
                  case d:
                    return p;
                  case s:
                    return p;
                  default:
                    return v;
                }
            }
          case r:
            return v;
        }
      }
    }
    var t = /* @__PURE__ */ Symbol.for("react.transitional.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), o = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.consumer"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), u = /* @__PURE__ */ Symbol.for("react.suspense"), f = /* @__PURE__ */ Symbol.for("react.suspense_list"), d = /* @__PURE__ */ Symbol.for("react.memo"), m = /* @__PURE__ */ Symbol.for("react.lazy"), h = /* @__PURE__ */ Symbol.for("react.view_transition"), y = /* @__PURE__ */ Symbol.for("react.client.reference");
    Se.ContextConsumer = s, Se.ContextProvider = l, Se.Element = t, Se.ForwardRef = c, Se.Fragment = n, Se.Lazy = m, Se.Memo = d, Se.Portal = r, Se.Profiler = i, Se.StrictMode = o, Se.Suspense = u, Se.SuspenseList = f, Se.isContextConsumer = function(p) {
      return e(p) === s;
    }, Se.isContextProvider = function(p) {
      return e(p) === l;
    }, Se.isElement = function(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }, Se.isForwardRef = function(p) {
      return e(p) === c;
    }, Se.isFragment = function(p) {
      return e(p) === n;
    }, Se.isLazy = function(p) {
      return e(p) === m;
    }, Se.isMemo = function(p) {
      return e(p) === d;
    }, Se.isPortal = function(p) {
      return e(p) === r;
    }, Se.isProfiler = function(p) {
      return e(p) === i;
    }, Se.isStrictMode = function(p) {
      return e(p) === o;
    }, Se.isSuspense = function(p) {
      return e(p) === u;
    }, Se.isSuspenseList = function(p) {
      return e(p) === f;
    }, Se.isValidElementType = function(p) {
      return typeof p == "string" || typeof p == "function" || p === n || p === i || p === o || p === u || p === f || typeof p == "object" && p !== null && (p.$$typeof === m || p.$$typeof === d || p.$$typeof === l || p.$$typeof === s || p.$$typeof === c || p.$$typeof === y || p.getModuleId !== void 0);
    }, Se.typeOf = e;
  })()), Se;
}
var da;
function au() {
  return da || (da = 1, process.env.NODE_ENV === "production" ? bn.exports = /* @__PURE__ */ ou() : bn.exports = /* @__PURE__ */ iu()), bn.exports;
}
var An = /* @__PURE__ */ au();
function Pt(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function As(e) {
  if (/* @__PURE__ */ x.isValidElement(e) || An.isValidElementType(e) || !Pt(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[r] = As(e[r]);
  }), t;
}
function ot(e, t, r = {
  clone: !0
}) {
  const n = r.clone ? {
    ...e
  } : e;
  return Pt(e) && Pt(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ x.isValidElement(t[o]) || An.isValidElementType(t[o]) ? n[o] = t[o] : Pt(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && Pt(e[o]) ? n[o] = ot(e[o], t[o], r) : r.clone ? n[o] = Pt(t[o]) ? As(t[o]) : t[o] : n[o] = t[o];
  }), n;
}
const su = (e) => {
  const t = Object.keys(e).map((r) => ({
    key: r,
    val: e[r]
  })) || [];
  return t.sort((r, n) => r.val - n.val), t.reduce((r, n) => ({
    ...r,
    [n.key]: n.val
  }), {});
};
function lu(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: n = 5,
    ...o
  } = e, i = su(t), s = Object.keys(i);
  function l(m) {
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${r})`;
  }
  function c(m) {
    return `@media (max-width:${(typeof t[m] == "number" ? t[m] : m) - n / 100}${r})`;
  }
  function u(m, h) {
    const y = s.indexOf(h);
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${r}) and (max-width:${(y !== -1 && typeof t[s[y]] == "number" ? t[s[y]] : h) - n / 100}${r})`;
  }
  function f(m) {
    return s.indexOf(m) + 1 < s.length ? u(m, s[s.indexOf(m) + 1]) : l(m);
  }
  function d(m) {
    const h = s.indexOf(m);
    return h === 0 ? l(s[1]) : h === s.length - 1 ? c(s[h]) : u(m, s[s.indexOf(m) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: i,
    up: l,
    down: c,
    between: u,
    only: f,
    not: d,
    unit: r,
    ...o
  };
}
function ma(e, t) {
  if (!e.containerQueries)
    return t;
  const r = Object.keys(t).filter((n) => n.startsWith("@container")).sort((n, o) => {
    var s, l;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((s = n.match(i)) == null ? void 0 : s[1]) || 0) - +(((l = o.match(i)) == null ? void 0 : l[1]) || 0);
  });
  return r.length ? r.reduce((n, o) => {
    const i = t[o];
    return delete n[o], n[o] = i, n;
  }, {
    ...t
  }) : t;
}
function cu(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((r) => t.startsWith(`@${r}`)) || !!t.match(/^@\d/));
}
function uu(e, t) {
  const r = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!r) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : jt(18, `(${t})`));
    return null;
  }
  const [, n, o] = r, i = Number.isNaN(+n) ? n || 0 : +n;
  return e.containerQueries(o).up(i);
}
function fu(e) {
  const t = (i, s) => i.replace("@media", s ? `@container ${s}` : "@container");
  function r(i, s) {
    i.up = (...l) => t(e.breakpoints.up(...l), s), i.down = (...l) => t(e.breakpoints.down(...l), s), i.between = (...l) => t(e.breakpoints.between(...l), s), i.only = (...l) => t(e.breakpoints.only(...l), s), i.not = (...l) => {
      const c = t(e.breakpoints.not(...l), s);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const n = {}, o = (i) => (r(n, i), n);
  return r(o), {
    ...e,
    containerQueries: o
  };
}
const pu = {
  borderRadius: 4
}, Yt = process.env.NODE_ENV !== "production" ? a.oneOfType([a.number, a.string, a.object, a.array]) : {};
function Br(e, t) {
  return t ? ot(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Yn = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, ga = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Yn[e]}px)`
}, du = {
  containerQueries: (e) => ({
    up: (t) => {
      let r = typeof t == "number" ? t : Yn[t] || t;
      return typeof r == "number" && (r = `${r}px`), e ? `@container ${e} (min-width:${r})` : `@container (min-width:${r})`;
    }
  })
};
function Bt(e, t, r) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const i = n.breakpoints || ga;
    return t.reduce((s, l, c) => (s[i.up(i.keys[c])] = r(t[c]), s), {});
  }
  if (typeof t == "object") {
    const i = n.breakpoints || ga;
    return Object.keys(t).reduce((s, l) => {
      if (cu(i.keys, l)) {
        const c = uu(n.containerQueries ? n : du, l);
        c && (s[c] = r(t[l], l));
      } else if (Object.keys(i.values || Yn).includes(l)) {
        const c = i.up(l);
        s[c] = r(t[l], l);
      } else {
        const c = l;
        s[c] = t[c];
      }
      return s;
    }, {});
  }
  return r(t);
}
function mu(e = {}) {
  var r;
  return ((r = e.keys) == null ? void 0 : r.reduce((n, o) => {
    const i = e.up(o);
    return n[i] = {}, n;
  }, {})) || {};
}
function ha(e, t) {
  return e.reduce((r, n) => {
    const o = r[n];
    return (!o || Object.keys(o).length === 0) && delete r[n], r;
  }, t);
}
function Q(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : jt(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Kn(e, t, r = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && r) {
    const n = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function Nn(e, t, r, n = r) {
  let o;
  return typeof e == "function" ? o = e(r) : Array.isArray(e) ? o = e[r] || n : o = Kn(e, r) || n, t && (o = t(o, n, e)), o;
}
function Ae(e) {
  const {
    prop: t,
    cssProperty: r = e.prop,
    themeKey: n,
    transform: o
  } = e, i = (s) => {
    if (s[t] == null)
      return null;
    const l = s[t], c = s.theme, u = Kn(c, n) || {};
    return Bt(s, l, (d) => {
      let m = Nn(u, o, d);
      return d === m && typeof d == "string" && (m = Nn(u, o, `${t}${d === "default" ? "" : Q(d)}`, d)), r === !1 ? m : {
        [r]: m
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Yt
  } : {}, i.filterProps = [t], i;
}
function gu(e) {
  const t = {};
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
const hu = {
  m: "margin",
  p: "padding"
}, yu = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, ya = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, bu = gu((e) => {
  if (e.length > 2)
    if (ya[e])
      e = ya[e];
    else
      return [e];
  const [t, r] = e.split(""), n = hu[t], o = yu[r] || "";
  return Array.isArray(o) ? o.map((i) => n + i) : [n + o];
}), Xn = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Jn = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], vu = [...Xn, ...Jn];
function rn(e, t, r, n) {
  var i;
  const o = (i = Kn(e, t, !0)) != null ? i : r;
  return typeof o == "number" || typeof o == "string" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${s}.`), typeof o == "string" ? `calc(${s} * ${o})` : o * s) : Array.isArray(o) ? (s) => {
    if (typeof s == "string")
      return s;
    const l = Math.abs(s);
    process.env.NODE_ENV !== "production" && (Number.isInteger(l) ? l > o.length - 1 && console.error([`MUI: The value provided (${l}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${l} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const c = o[l];
    return s >= 0 ? c : typeof c == "number" ? -c : `-${c}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function di(e) {
  return rn(e, "spacing", 8, "spacing");
}
function nn(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function Cu(e, t) {
  return (r) => e.reduce((n, o) => (n[o] = nn(t, r), n), {});
}
function Su(e, t, r, n) {
  if (!t.includes(r))
    return null;
  const o = bu(r), i = Cu(o, n), s = e[r];
  return Bt(e, s, i);
}
function Ns(e, t) {
  const r = di(e.theme);
  return Object.keys(e).map((n) => Su(e, t, n, r)).reduce(Br, {});
}
function Ie(e) {
  return Ns(e, Xn);
}
Ie.propTypes = process.env.NODE_ENV !== "production" ? Xn.reduce((e, t) => (e[t] = Yt, e), {}) : {};
Ie.filterProps = Xn;
function ke(e) {
  return Ns(e, Jn);
}
ke.propTypes = process.env.NODE_ENV !== "production" ? Jn.reduce((e, t) => (e[t] = Yt, e), {}) : {};
ke.filterProps = Jn;
process.env.NODE_ENV !== "production" && vu.reduce((e, t) => (e[t] = Yt, e), {});
function Ms(e = 8, t = di({
  spacing: e
})) {
  if (e.mui)
    return e;
  const r = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((i) => {
    const s = t(i);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return r.mui = !0, r;
}
function Qn(...e) {
  const t = e.reduce((n, o) => (o.filterProps.forEach((i) => {
    n[i] = o;
  }), n), {}), r = (n) => Object.keys(n).reduce((o, i) => t[i] ? Br(o, t[i](n)) : o, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, o) => Object.assign(n, o.propTypes), {}) : {}, r.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), r;
}
function lt(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function mt(e, t) {
  return Ae({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const wu = mt("border", lt), xu = mt("borderTop", lt), Eu = mt("borderRight", lt), Ou = mt("borderBottom", lt), Tu = mt("borderLeft", lt), Ru = mt("borderColor"), Pu = mt("borderTopColor"), $u = mt("borderRightColor"), Iu = mt("borderBottomColor"), ku = mt("borderLeftColor"), Au = mt("outline", lt), Nu = mt("outlineColor"), Zn = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = rn(e.theme, "shape.borderRadius", 4, "borderRadius"), r = (n) => ({
      borderRadius: nn(t, n)
    });
    return Bt(e, e.borderRadius, r);
  }
  return null;
};
Zn.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Yt
} : {};
Zn.filterProps = ["borderRadius"];
Qn(wu, xu, Eu, Ou, Tu, Ru, Pu, $u, Iu, ku, Zn, Au, Nu);
const eo = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = rn(e.theme, "spacing", 8, "gap"), r = (n) => ({
      gap: nn(t, n)
    });
    return Bt(e, e.gap, r);
  }
  return null;
};
eo.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Yt
} : {};
eo.filterProps = ["gap"];
const to = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = rn(e.theme, "spacing", 8, "columnGap"), r = (n) => ({
      columnGap: nn(t, n)
    });
    return Bt(e, e.columnGap, r);
  }
  return null;
};
to.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Yt
} : {};
to.filterProps = ["columnGap"];
const ro = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = rn(e.theme, "spacing", 8, "rowGap"), r = (n) => ({
      rowGap: nn(t, n)
    });
    return Bt(e, e.rowGap, r);
  }
  return null;
};
ro.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Yt
} : {};
ro.filterProps = ["rowGap"];
const Mu = Ae({
  prop: "gridColumn"
}), Du = Ae({
  prop: "gridRow"
}), _u = Ae({
  prop: "gridAutoFlow"
}), Fu = Ae({
  prop: "gridAutoColumns"
}), Vu = Ae({
  prop: "gridAutoRows"
}), Lu = Ae({
  prop: "gridTemplateColumns"
}), ju = Ae({
  prop: "gridTemplateRows"
}), Bu = Ae({
  prop: "gridTemplateAreas"
}), zu = Ae({
  prop: "gridArea"
});
Qn(eo, to, ro, Mu, Du, _u, Fu, Vu, Lu, ju, Bu, zu);
function vr(e, t) {
  return t === "grey" ? t : e;
}
const Wu = Ae({
  prop: "color",
  themeKey: "palette",
  transform: vr
}), Uu = Ae({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: vr
}), Hu = Ae({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: vr
});
Qn(Wu, Uu, Hu);
function rt(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const qu = Ae({
  prop: "width",
  transform: rt
}), mi = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (r) => {
      var o, i, s, l, c;
      const n = ((s = (i = (o = e.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : i.values) == null ? void 0 : s[r]) || Yn[r];
      return n ? ((c = (l = e.theme) == null ? void 0 : l.breakpoints) == null ? void 0 : c.unit) !== "px" ? {
        maxWidth: `${n}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: n
      } : {
        maxWidth: rt(r)
      };
    };
    return Bt(e, e.maxWidth, t);
  }
  return null;
};
mi.filterProps = ["maxWidth"];
const Gu = Ae({
  prop: "minWidth",
  transform: rt
}), Yu = Ae({
  prop: "height",
  transform: rt
}), Ku = Ae({
  prop: "maxHeight",
  transform: rt
}), Xu = Ae({
  prop: "minHeight",
  transform: rt
});
Ae({
  prop: "size",
  cssProperty: "width",
  transform: rt
});
Ae({
  prop: "size",
  cssProperty: "height",
  transform: rt
});
const Ju = Ae({
  prop: "boxSizing"
});
Qn(qu, mi, Gu, Yu, Ku, Xu, Ju);
const on = {
  // borders
  border: {
    themeKey: "borders",
    transform: lt
  },
  borderTop: {
    themeKey: "borders",
    transform: lt
  },
  borderRight: {
    themeKey: "borders",
    transform: lt
  },
  borderBottom: {
    themeKey: "borders",
    transform: lt
  },
  borderLeft: {
    themeKey: "borders",
    transform: lt
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: lt
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Zn
  },
  // palette
  color: {
    themeKey: "palette",
    transform: vr
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: vr
  },
  backgroundColor: {
    themeKey: "palette",
    transform: vr
  },
  // spacing
  p: {
    style: ke
  },
  pt: {
    style: ke
  },
  pr: {
    style: ke
  },
  pb: {
    style: ke
  },
  pl: {
    style: ke
  },
  px: {
    style: ke
  },
  py: {
    style: ke
  },
  padding: {
    style: ke
  },
  paddingTop: {
    style: ke
  },
  paddingRight: {
    style: ke
  },
  paddingBottom: {
    style: ke
  },
  paddingLeft: {
    style: ke
  },
  paddingX: {
    style: ke
  },
  paddingY: {
    style: ke
  },
  paddingInline: {
    style: ke
  },
  paddingInlineStart: {
    style: ke
  },
  paddingInlineEnd: {
    style: ke
  },
  paddingBlock: {
    style: ke
  },
  paddingBlockStart: {
    style: ke
  },
  paddingBlockEnd: {
    style: ke
  },
  m: {
    style: Ie
  },
  mt: {
    style: Ie
  },
  mr: {
    style: Ie
  },
  mb: {
    style: Ie
  },
  ml: {
    style: Ie
  },
  mx: {
    style: Ie
  },
  my: {
    style: Ie
  },
  margin: {
    style: Ie
  },
  marginTop: {
    style: Ie
  },
  marginRight: {
    style: Ie
  },
  marginBottom: {
    style: Ie
  },
  marginLeft: {
    style: Ie
  },
  marginX: {
    style: Ie
  },
  marginY: {
    style: Ie
  },
  marginInline: {
    style: Ie
  },
  marginInlineStart: {
    style: Ie
  },
  marginInlineEnd: {
    style: Ie
  },
  marginBlock: {
    style: Ie
  },
  marginBlockStart: {
    style: Ie
  },
  marginBlockEnd: {
    style: Ie
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: eo
  },
  rowGap: {
    style: ro
  },
  columnGap: {
    style: to
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: rt
  },
  maxWidth: {
    style: mi
  },
  minWidth: {
    transform: rt
  },
  height: {
    transform: rt
  },
  maxHeight: {
    transform: rt
  },
  minHeight: {
    transform: rt
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function Qu(...e) {
  const t = e.reduce((n, o) => n.concat(Object.keys(o)), []), r = new Set(t);
  return e.every((n) => r.size === Object.keys(n).length);
}
function Zu(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ef() {
  function e(r, n, o, i) {
    const s = {
      [r]: n,
      theme: o
    }, l = i[r];
    if (!l)
      return {
        [r]: n
      };
    const {
      cssProperty: c = r,
      themeKey: u,
      transform: f,
      style: d
    } = l;
    if (n == null)
      return null;
    if (u === "typography" && n === "inherit")
      return {
        [r]: n
      };
    const m = Kn(o, u) || {};
    return d ? d(s) : Bt(s, n, (y) => {
      let p = Nn(m, f, y);
      return y === p && typeof y == "string" && (p = Nn(m, f, `${r}${y === "default" ? "" : Q(y)}`, y)), c === !1 ? p : {
        [c]: p
      };
    });
  }
  function t(r) {
    var c;
    const {
      sx: n,
      theme: o = {},
      nested: i
    } = r || {};
    if (!n)
      return null;
    const s = (c = o.unstable_sxConfig) != null ? c : on;
    function l(u) {
      let f = u;
      if (typeof u == "function")
        f = u(o);
      else if (typeof u != "object")
        return u;
      if (!f)
        return null;
      const d = mu(o.breakpoints), m = Object.keys(d);
      let h = d;
      return Object.keys(f).forEach((y) => {
        const p = Zu(f[y], o);
        if (p != null)
          if (typeof p == "object")
            if (s[y])
              h = Br(h, e(y, p, o, s));
            else {
              const v = Bt({
                theme: o
              }, p, (w) => ({
                [y]: w
              }));
              Qu(v, p) ? h[y] = t({
                sx: p,
                theme: o,
                nested: !0
              }) : h = Br(h, v);
            }
          else
            h = Br(h, e(y, p, o, s));
      }), !i && o.modularCssLayers ? {
        "@layer sx": ma(o, ha(m, h))
      } : ma(o, ha(m, h));
    }
    return Array.isArray(n) ? n.map(l) : l(n);
  }
  return t;
}
const Sr = ef();
Sr.filterProps = ["sx"];
function tf(e, t) {
  var n;
  const r = this;
  if (r.vars) {
    if (!((n = r.colorSchemes) != null && n[e]) || typeof r.getColorSchemeSelector != "function")
      return {};
    let o = r.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return r.palette.mode === e ? t : {};
}
function gi(e = {}, ...t) {
  const {
    breakpoints: r = {},
    palette: n = {},
    spacing: o,
    shape: i = {},
    ...s
  } = e, l = lu(r), c = Ms(o);
  let u = ot({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...n
    },
    spacing: c,
    shape: {
      ...pu,
      ...i
    }
  }, s);
  return u = fu(u), u.applyStyles = tf, u = t.reduce((f, d) => ot(f, d), u), u.unstable_sxConfig = {
    ...on,
    ...s == null ? void 0 : s.unstable_sxConfig
  }, u.unstable_sx = function(d) {
    return Sr({
      sx: d,
      theme: this
    });
  }, u;
}
function rf(e) {
  return Object.keys(e).length === 0;
}
function nf(e = null) {
  const t = x.useContext(Gn);
  return !t || rf(t) ? e : t;
}
const of = gi();
function Ds(e = of) {
  return nf(e);
}
function Po(e) {
  const t = qt(e);
  return e !== t && t.styles ? (t.styles.match(/^@layer\s+[^{]*$/) || (t.styles = `@layer global{${t.styles}}`), t) : e;
}
function _s({
  styles: e,
  themeId: t,
  defaultTheme: r = {}
}) {
  const n = Ds(r), o = t && n[t] || n;
  let i = typeof e == "function" ? e(o) : e;
  return o.modularCssLayers && (Array.isArray(i) ? i = i.map((s) => Po(typeof s == "function" ? s(o) : s)) : i = Po(i)), /* @__PURE__ */ W(ks, {
    styles: i
  });
}
process.env.NODE_ENV !== "production" && (_s.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: a.object,
  /**
   * @ignore
   */
  styles: a.oneOfType([a.array, a.func, a.number, a.object, a.string, a.bool]),
  /**
   * @ignore
   */
  themeId: a.string
});
const af = (e) => {
  var n, o;
  const t = {
    systemProps: {},
    otherProps: {}
  }, r = (o = (n = e == null ? void 0 : e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? o : on;
  return Object.keys(e).forEach((i) => {
    r[i] ? t.systemProps[i] = e[i] : t.otherProps[i] = e[i];
  }), t;
};
function sf(e) {
  const {
    sx: t,
    ...r
  } = e, {
    systemProps: n,
    otherProps: o
  } = af(r);
  let i;
  return Array.isArray(t) ? i = [n, ...t] : typeof t == "function" ? i = (...s) => {
    const l = t(...s);
    return Pt(l) ? {
      ...n,
      ...l
    } : n;
  } : i = {
    ...n,
    ...t
  }, {
    ...o,
    sx: i
  };
}
const ba = (e) => e, lf = () => {
  let e = ba;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = ba;
    }
  };
}, cf = lf(), uf = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function He(e, t, r = "Mui") {
  const n = uf[t];
  return n ? `${r}-${n}` : `${cf.generate(e)}-${t}`;
}
function Ge(e, t, r = "Mui") {
  const n = {};
  return t.forEach((o) => {
    n[o] = He(e, o, r);
  }), n;
}
function Fs(e, t = "") {
  return e.displayName || e.name || t;
}
function va(e, t, r) {
  const n = Fs(t);
  return e.displayName || (n !== "" ? `${r}(${n})` : r);
}
function ff(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return Fs(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case An.ForwardRef:
          return va(e, e.render, "ForwardRef");
        case An.Memo:
          return va(e, e.type, "memo");
        default:
          return;
      }
  }
}
function Vs(e) {
  const {
    variants: t,
    ...r
  } = e, n = {
    variants: t,
    style: qt(r),
    isProcessed: !0
  };
  return n.style === r || t && t.forEach((o) => {
    typeof o.style != "function" && (o.style = qt(o.style));
  }), n;
}
const pf = gi();
function $o(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function rr(e, t) {
  return t && e && typeof e == "object" && e.styles && !e.styles.startsWith("@layer") && (e.styles = `@layer ${t}{${String(e.styles)}}`), e;
}
function df(e) {
  return e ? (t, r) => r[e] : null;
}
function mf(e, t, r) {
  e.theme = bf(e.theme) ? r : e.theme[t] || e.theme;
}
function $n(e, t, r) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((o) => $n(e, o, r));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let o;
    if (n.isProcessed)
      o = r ? rr(n.style, r) : n.style;
    else {
      const {
        variants: i,
        ...s
      } = n;
      o = r ? rr(qt(s), r) : s;
    }
    return Ls(e, n.variants, [o], r);
  }
  return n != null && n.isProcessed ? r ? rr(qt(n.style), r) : n.style : r ? rr(qt(n), r) : n;
}
function Ls(e, t, r = [], n = void 0) {
  var i;
  let o;
  e: for (let s = 0; s < t.length; s += 1) {
    const l = t[s];
    if (typeof l.props == "function") {
      if (o != null || (o = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !l.props(o))
        continue;
    } else
      for (const c in l.props)
        if (e[c] !== l.props[c] && ((i = e.ownerState) == null ? void 0 : i[c]) !== l.props[c])
          continue e;
    typeof l.style == "function" ? (o != null || (o = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), r.push(n ? rr(qt(l.style(o)), n) : l.style(o))) : r.push(n ? rr(qt(l.style), n) : l.style);
  }
  return r;
}
function gf(e = {}) {
  const {
    themeId: t,
    defaultTheme: r = pf,
    rootShouldForwardProp: n = $o,
    slotShouldForwardProp: o = $o
  } = e;
  function i(l) {
    mf(l, t, r);
  }
  return (l, c = {}) => {
    nu(l, (E) => E.filter((P) => P !== Sr));
    const {
      name: u,
      slot: f,
      skipVariantsResolver: d,
      skipSx: m,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = df(js(f)),
      ...y
    } = c, p = u && u.startsWith("Mui") || f ? "components" : "custom", v = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      f && f !== "Root" && f !== "root" || !1
    ), w = m || !1;
    let O = $o;
    f === "Root" || f === "root" ? O = n : f ? O = o : vf(l) && (O = void 0);
    const C = ru(l, {
      shouldForwardProp: O,
      label: yf(u, f),
      ...y
    }), b = (E) => {
      if (E.__emotion_real === E)
        return E;
      if (typeof E == "function")
        return function(V) {
          return $n(V, E, V.theme.modularCssLayers ? p : void 0);
        };
      if (Pt(E)) {
        const P = Vs(E);
        return function(D) {
          return P.variants ? $n(D, P, D.theme.modularCssLayers ? p : void 0) : D.theme.modularCssLayers ? rr(P.style, p) : P.style;
        };
      }
      return E;
    }, S = (...E) => {
      const P = [], V = E.map(b), D = [];
      if (P.push(i), u && h && D.push(function(_) {
        var Z, pe;
        const te = (pe = (Z = _.theme.components) == null ? void 0 : Z[u]) == null ? void 0 : pe.styleOverrides;
        if (!te)
          return null;
        const Y = {};
        for (const B in te)
          Y[B] = $n(_, te[B], _.theme.modularCssLayers ? "theme" : void 0);
        return h(_, Y);
      }), u && !v && D.push(function(_) {
        var Y, Z;
        const G = _.theme, te = (Z = (Y = G == null ? void 0 : G.components) == null ? void 0 : Y[u]) == null ? void 0 : Z.variants;
        return te ? Ls(_, te, [], _.theme.modularCssLayers ? "theme" : void 0) : null;
      }), w || D.push(Sr), Array.isArray(V[0])) {
        const k = V.shift(), _ = new Array(P.length).fill(""), G = new Array(D.length).fill("");
        let te;
        te = [..._, ...k, ...G], te.raw = [..._, ...k.raw, ...G], P.unshift(te);
      }
      const g = [...P, ...V, ...D], $ = C(...g);
      return l.muiName && ($.muiName = l.muiName), process.env.NODE_ENV !== "production" && ($.displayName = hf(u, f, l)), $;
    };
    return C.withConfig && (S.withConfig = C.withConfig), S;
  };
}
function hf(e, t, r) {
  return e ? `${e}${Q(t || "")}` : `Styled(${ff(r)})`;
}
function yf(e, t) {
  let r;
  return process.env.NODE_ENV !== "production" && e && (r = `${e}-${js(t || "Root")}`), r;
}
function bf(e) {
  for (const t in e)
    return !1;
  return !0;
}
function vf(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function js(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function zo(e, t) {
  const r = {
    ...t
  };
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      const o = n;
      if (o === "components" || o === "slots")
        r[o] = {
          ...e[o],
          ...r[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const i = e[o], s = t[o];
        if (!s)
          r[o] = i || {};
        else if (!i)
          r[o] = s;
        else {
          r[o] = {
            ...s
          };
          for (const l in i)
            if (Object.prototype.hasOwnProperty.call(i, l)) {
              const c = l;
              r[o][c] = zo(i[c], s[c]);
            }
        }
      } else r[o] === void 0 && (r[o] = e[o]);
    }
  return r;
}
const At = typeof window != "undefined" ? x.useLayoutEffect : x.useEffect;
function Cf(e, t = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, r));
}
function hi(e, t = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${r}].`), Cf(e, t, r);
}
function Sf(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Gt(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Gt(Sf(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(r))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : jt(9, e));
  let n = e.substring(t + 1, e.length - 1), o;
  if (r === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : jt(10, o));
  } else
    n = n.split(",");
  return n = n.map((i) => parseFloat(i)), {
    type: r,
    values: n,
    colorSpace: o
  };
}
const wf = (e) => {
  const t = Gt(e);
  return t.values.slice(0, 3).map((r, n) => t.type.includes("hsl") && n !== 0 ? `${r}%` : r).join(" ");
}, Lr = (e, t) => {
  try {
    return wf(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function no(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: n
  } = e;
  return t.includes("rgb") ? n = n.map((o, i) => i < 3 ? parseInt(o, 10) : o) : t.includes("hsl") && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.includes("color") ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function Bs(e) {
  e = Gt(e);
  const {
    values: t
  } = e, r = t[0], n = t[1] / 100, o = t[2] / 100, i = n * Math.min(o, 1 - o), s = (u, f = (u + r / 30) % 12) => o - i * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  let l = "rgb";
  const c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), no({
    type: l,
    values: c
  });
}
function Wo(e) {
  e = Gt(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Gt(Bs(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function Ca(e, t) {
  const r = Wo(e), n = Wo(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function Ve(e, t) {
  return e = Gt(e), t = hi(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, no(e);
}
function vn(e, t, r) {
  try {
    return Ve(e, t);
  } catch {
    return e;
  }
}
function yi(e, t) {
  if (e = Gt(e), t = hi(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return no(e);
}
function xe(e, t, r) {
  try {
    return yi(e, t);
  } catch {
    return e;
  }
}
function bi(e, t) {
  if (e = Gt(e), t = hi(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.includes("color"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return no(e);
}
function Ee(e, t, r) {
  try {
    return bi(e, t);
  } catch {
    return e;
  }
}
function xf(e, t = 0.15) {
  return Wo(e) > 0.5 ? yi(e, t) : bi(e, t);
}
function Cn(e, t, r) {
  try {
    return xf(e, t);
  } catch {
    return e;
  }
}
function ar(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || t(...n);
  };
}
function Ef(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Of(e, t, r, n, o) {
  const i = e[t], s = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let l;
  return typeof i == "function" && !Ef(i) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const zs = ar(a.elementType, Of), Tf = "exact-prop: ​";
function Rf(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [Tf]: (t) => {
      const r = Object.keys(t).filter((n) => !e.hasOwnProperty(n));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function Yr(e, t, r, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], s = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
const oo = a.oneOfType([a.func, a.object]);
function Pf(e, t = 166) {
  let r;
  function n(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(r), r = setTimeout(i, t);
  }
  return n.clear = () => {
    clearTimeout(r);
  }, n;
}
function Uo(e) {
  return e && e.ownerDocument || document;
}
function Sa(e) {
  return Uo(e).defaultView || window;
}
function Ho(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let wa = 0;
function $f(e) {
  const [t, r] = x.useState(e), n = e || t;
  return x.useEffect(() => {
    t == null && (wa += 1, r(`mui-${wa}`));
  }, [t]), n;
}
const If = {
  ...x
}, xa = If.useId;
function an(e) {
  if (xa !== void 0) {
    const t = xa();
    return e != null ? e : t;
  }
  return $f(e);
}
function kf(e, t, r, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = o || t;
  return typeof e[t] != "undefined" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function Io({
  controlled: e,
  default: t,
  name: r,
  state: n = "value"
}) {
  const {
    current: o
  } = x.useRef(e !== void 0), [i, s] = x.useState(t), l = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    x.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${n} state of ${r} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${r} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [n, r, e]);
    const {
      current: u
    } = x.useRef(t);
    x.useEffect(() => {
      !o && !Object.is(u, t) && console.error([`MUI: A component is changing the default ${n} state of an uncontrolled ${r} after being initialized. To suppress this warning opt to use a controlled ${r}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = x.useCallback((u) => {
    o || s(u);
  }, []);
  return [l, c];
}
function Lt(e) {
  const t = x.useRef(e);
  return At(() => {
    t.current = e;
  }), x.useRef((...r) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...r)
  )).current;
}
function Nt(...e) {
  const t = x.useRef(void 0), r = x.useCallback((n) => {
    const o = e.map((i) => {
      if (i == null)
        return null;
      if (typeof i == "function") {
        const s = i, l = s(n);
        return typeof l == "function" ? l : () => {
          s(null);
        };
      }
      return i.current = n, () => {
        i.current = null;
      };
    });
    return () => {
      o.forEach((i) => i == null ? void 0 : i());
    };
  }, e);
  return x.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    t.current && (t.current(), t.current = void 0), n != null && (t.current = r(n));
  }, e);
}
const Ea = {};
function io(e, t) {
  const r = x.useRef(Ea);
  return r.current === Ea && (r.current = e(t)), r;
}
const Af = [];
function vi(e) {
  x.useEffect(e, Af);
}
class Ci {
  constructor() {
    Nr(this, "currentId", null);
    Nr(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    Nr(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Ci();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, r) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, r();
    }, t);
  }
}
function Si() {
  const e = io(Ci.create).current;
  return vi(e.disposeEffect), e;
}
function Oa(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
const Nf = (e) => {
  const t = x.useRef({});
  return x.useEffect(() => {
    t.current = e;
  }), t.current;
};
function Mf(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function Ws(e, t, r, n) {
  const o = e[t];
  if (o == null || !Number.isInteger(o)) {
    const i = Mf(o);
    return new RangeError(`Invalid ${n} \`${t}\` of type \`${i}\` supplied to \`${r}\`, expected \`integer\`.`);
  }
  return null;
}
function Us(e, t, ...r) {
  return e[t] === void 0 ? null : Ws(e, t, ...r);
}
function qo() {
  return null;
}
Us.isRequired = Ws;
qo.isRequired = qo;
const Hs = process.env.NODE_ENV === "production" ? qo : Us;
function gt(e, t, r = void 0) {
  const n = {};
  for (const o in e) {
    const i = e[o];
    let s = "", l = !0;
    for (let c = 0; c < i.length; c += 1) {
      const u = i[c];
      u && (s += (l === !0 ? "" : " ") + t(u), l = !1, r && r[u] && (s += " " + r[u]));
    }
    n[o] = s;
  }
  return n;
}
function Df(e) {
  return typeof e == "string";
}
function qs(e, t, r) {
  return e === void 0 || Df(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...r
    }
  };
}
function _f(e, t = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    r[n] = e[n];
  }), r;
}
function Ta(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    t[r] = e[r];
  }), t;
}
function Gs(e) {
  const {
    getSlotProps: t,
    additionalProps: r,
    externalSlotProps: n,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const h = we(r == null ? void 0 : r.className, i, o == null ? void 0 : o.className, n == null ? void 0 : n.className), y = {
      ...r == null ? void 0 : r.style,
      ...o == null ? void 0 : o.style,
      ...n == null ? void 0 : n.style
    }, p = {
      ...r,
      ...o,
      ...n
    };
    return h.length > 0 && (p.className = h), Object.keys(y).length > 0 && (p.style = y), {
      props: p,
      internalRef: void 0
    };
  }
  const s = _f({
    ...o,
    ...n
  }), l = Ta(n), c = Ta(o), u = t(s), f = we(u == null ? void 0 : u.className, r == null ? void 0 : r.className, i, o == null ? void 0 : o.className, n == null ? void 0 : n.className), d = {
    ...u == null ? void 0 : u.style,
    ...r == null ? void 0 : r.style,
    ...o == null ? void 0 : o.style,
    ...n == null ? void 0 : n.style
  }, m = {
    ...u,
    ...r,
    ...c,
    ...l
  };
  return f.length > 0 && (m.className = f), Object.keys(d).length > 0 && (m.style = d), {
    props: m,
    internalRef: u.ref
  };
}
function Ys(e, t, r) {
  return typeof e == "function" ? e(t, r) : e;
}
function Ff(e) {
  var d;
  const {
    elementType: t,
    externalSlotProps: r,
    ownerState: n,
    skipResolvingSlotProps: o = !1,
    ...i
  } = e, s = o ? {} : Ys(r, n), {
    props: l,
    internalRef: c
  } = Gs({
    ...i,
    externalSlotProps: s
  }), u = Nt(c, s == null ? void 0 : s.ref, (d = e.additionalProps) == null ? void 0 : d.ref);
  return qs(t, {
    ...l,
    ref: u
  }, n);
}
function Vf(e) {
  var t;
  return parseInt(x.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const Lf = /* @__PURE__ */ x.createContext();
process.env.NODE_ENV !== "production" && (a.node, a.bool);
const jf = () => {
  const e = x.useContext(Lf);
  return e != null ? e : !1;
}, Bf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (a.node, a.object);
function zf(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  if (!t || !t.components || !t.components[r])
    return n;
  const o = t.components[r];
  return o.defaultProps ? zo(o.defaultProps, n) : !o.styleOverrides && !o.variants ? zo(o, n) : n;
}
function Wf({
  props: e,
  name: t
}) {
  const r = x.useContext(Bf);
  return zf({
    props: e,
    name: t,
    theme: {
      components: r
    }
  });
}
const Ra = {
  theme: void 0
};
function Uf(e) {
  let t, r;
  return function(o) {
    let i = t;
    return (i === void 0 || o.theme !== r) && (Ra.theme = o.theme, i = Vs(e(Ra)), t = i, r = o.theme), i;
  };
}
function Hf(e = "") {
  function t(...n) {
    if (!n.length)
      return "";
    const o = n[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${t(...n.slice(1))})` : `, ${o}`;
  }
  return (n, ...o) => `var(--${e ? `${e}-` : ""}${n}${t(...o)})`;
}
const Pa = (e, t, r, n = []) => {
  let o = e;
  t.forEach((i, s) => {
    s === t.length - 1 ? Array.isArray(o) ? o[Number(i)] = r : o && typeof o == "object" && (o[i] = r) : o && typeof o == "object" && (o[i] || (o[i] = n.includes(i) ? [] : {}), o = o[i]);
  });
}, qf = (e, t, r) => {
  function n(o, i = [], s = []) {
    Object.entries(o).forEach(([l, c]) => {
      (!r || r && !r([...i, l])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? n(c, [...i, l], Array.isArray(c) ? [...s, l] : s) : t([...i, l], c, s));
    });
  }
  n(e);
}, Gf = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function ko(e, t) {
  const {
    prefix: r,
    shouldSkipGeneratingVar: n
  } = t || {}, o = {}, i = {}, s = {};
  return qf(
    e,
    (l, c, u) => {
      if ((typeof c == "string" || typeof c == "number") && (!n || !n(l, c))) {
        const f = `--${r ? `${r}-` : ""}${l.join("-")}`, d = Gf(l, c);
        Object.assign(o, {
          [f]: d
        }), Pa(i, l, `var(${f})`, u), Pa(s, l, `var(${f}, ${d})`, u);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: i,
    varsWithDefaults: s
  };
}
function Yf(e, t = {}) {
  const {
    getSelector: r = v,
    disableCssColorScheme: n,
    colorSchemeSelector: o
  } = t, {
    colorSchemes: i = {},
    components: s,
    defaultColorScheme: l = "light",
    ...c
  } = e, {
    vars: u,
    css: f,
    varsWithDefaults: d
  } = ko(c, t);
  let m = d;
  const h = {}, {
    [l]: y,
    ...p
  } = i;
  if (Object.entries(p || {}).forEach(([C, b]) => {
    const {
      vars: S,
      css: E,
      varsWithDefaults: P
    } = ko(b, t);
    m = ot(m, P), h[C] = {
      css: E,
      vars: S
    };
  }), y) {
    const {
      css: C,
      vars: b,
      varsWithDefaults: S
    } = ko(y, t);
    m = ot(m, S), h[l] = {
      css: C,
      vars: b
    };
  }
  function v(C, b) {
    var E, P;
    let S = o;
    if (o === "class" && (S = ".%s"), o === "data" && (S = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (S = `[${o}="%s"]`), C) {
      if (S === "media")
        return e.defaultColorScheme === C ? ":root" : {
          [`@media (prefers-color-scheme: ${((P = (E = i[C]) == null ? void 0 : E.palette) == null ? void 0 : P.mode) || C})`]: {
            ":root": b
          }
        };
      if (S)
        return e.defaultColorScheme === C ? `:root, ${S.replace("%s", String(C))}` : S.replace("%s", String(C));
    }
    return ":root";
  }
  return {
    vars: m,
    generateThemeVars: () => {
      let C = {
        ...u
      };
      return Object.entries(h).forEach(([, {
        vars: b
      }]) => {
        C = ot(C, b);
      }), C;
    },
    generateStyleSheets: () => {
      var V, D;
      const C = [], b = e.defaultColorScheme || "light";
      function S(g, $) {
        Object.keys($).length && C.push(typeof g == "string" ? {
          [g]: {
            ...$
          }
        } : g);
      }
      S(r(void 0, {
        ...f
      }), f);
      const {
        [b]: E,
        ...P
      } = h;
      if (E) {
        const {
          css: g
        } = E, $ = (D = (V = i[b]) == null ? void 0 : V.palette) == null ? void 0 : D.mode, k = !n && $ ? {
          colorScheme: $,
          ...g
        } : {
          ...g
        };
        S(r(b, {
          ...k
        }), k);
      }
      return Object.entries(P).forEach(([g, {
        css: $
      }]) => {
        var G, te;
        const k = (te = (G = i[g]) == null ? void 0 : G.palette) == null ? void 0 : te.mode, _ = !n && k ? {
          colorScheme: k,
          ...$
        } : {
          ...$
        };
        S(r(g, {
          ..._
        }), _);
      }), C;
    }
  };
}
function Kf(e) {
  return function(r) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && r !== "light" && r !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${r}'.`), `@media (prefers-color-scheme: ${r})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${r}"] &` : e === "class" ? `.${r} &` : e === "data" ? `[data-${r}] &` : `${e.replace("%s", r)} &` : "&";
  };
}
function Ks() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Ur.white,
      default: Ur.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const Xf = Ks();
function Xs() {
  return {
    text: {
      primary: Ur.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Ur.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const $a = Xs();
function Ia(e, t, r, n) {
  const o = n.light || n, i = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = bi(e.main, o) : t === "dark" && (e.dark = yi(e.main, i)));
}
function Jf(e = "light") {
  return e === "dark" ? {
    main: dr[200],
    light: dr[50],
    dark: dr[400]
  } : {
    main: dr[700],
    light: dr[400],
    dark: dr[800]
  };
}
function Qf(e = "light") {
  return e === "dark" ? {
    main: pr[200],
    light: pr[50],
    dark: pr[400]
  } : {
    main: pr[500],
    light: pr[300],
    dark: pr[700]
  };
}
function Zf(e = "light") {
  return e === "dark" ? {
    main: fr[500],
    light: fr[300],
    dark: fr[700]
  } : {
    main: fr[700],
    light: fr[400],
    dark: fr[800]
  };
}
function ep(e = "light") {
  return e === "dark" ? {
    main: mr[400],
    light: mr[300],
    dark: mr[700]
  } : {
    main: mr[700],
    light: mr[500],
    dark: mr[900]
  };
}
function tp(e = "light") {
  return e === "dark" ? {
    main: gr[400],
    light: gr[300],
    dark: gr[700]
  } : {
    main: gr[800],
    light: gr[500],
    dark: gr[900]
  };
}
function rp(e = "light") {
  return e === "dark" ? {
    main: Mr[400],
    light: Mr[300],
    dark: Mr[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Mr[500],
    dark: Mr[900]
  };
}
function wi(e) {
  const {
    mode: t = "light",
    contrastThreshold: r = 3,
    tonalOffset: n = 0.2,
    ...o
  } = e, i = e.primary || Jf(t), s = e.secondary || Qf(t), l = e.error || Zf(t), c = e.info || ep(t), u = e.success || tp(t), f = e.warning || rp(t);
  function d(p) {
    const v = Ca(p, $a.text.primary) >= r ? $a.text.primary : Xf.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const w = Ca(p, v);
      w < 3 && console.error([`MUI: The contrast ratio of ${w}:1 for ${v} on ${p}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return v;
  }
  const m = ({
    color: p,
    name: v,
    mainShade: w = 500,
    lightShade: O = 300,
    darkShade: C = 700
  }) => {
    if (p = {
      ...p
    }, !p.main && p[w] && (p.main = p[w]), !p.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${v ? ` (${v})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${w}\` property.` : jt(11, v ? ` (${v})` : "", w));
    if (typeof p.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${v ? ` (${v})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(p.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : jt(12, v ? ` (${v})` : "", JSON.stringify(p.main)));
    return Ia(p, "light", O, n), Ia(p, "dark", C, n), p.contrastText || (p.contrastText = d(p.main)), p;
  };
  let h;
  return t === "light" ? h = Ks() : t === "dark" && (h = Xs()), process.env.NODE_ENV !== "production" && (h || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), ot({
    // A collection of common colors.
    common: {
      ...Ur
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: m({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: m({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: m({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: m({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: m({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: m({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: Xl,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: m,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n,
    // The light and dark mode object.
    ...h
  }, o);
}
function np(e) {
  const t = {};
  return Object.entries(e).forEach((n) => {
    const [o, i] = n;
    typeof i == "object" && (t[o] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function op(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function ip(e) {
  return Math.round(e * 1e5) / 1e5;
}
const ka = {
  textTransform: "uppercase"
}, Aa = '"Roboto", "Helvetica", "Arial", sans-serif';
function ap(e, t) {
  const {
    fontFamily: r = Aa,
    // The default font size of the Material Specification.
    fontSize: n = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: f,
    ...d
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof n != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const m = n / 14, h = f || ((v) => `${v / c * m}rem`), y = (v, w, O, C, b) => ({
    fontFamily: r,
    fontWeight: v,
    fontSize: h(w),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: O,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...r === Aa ? {
      letterSpacing: `${ip(C / w)}em`
    } : {},
    ...b,
    ...u
  }), p = {
    h1: y(o, 96, 1.167, -1.5),
    h2: y(o, 60, 1.2, -0.5),
    h3: y(i, 48, 1.167, 0),
    h4: y(i, 34, 1.235, 0.25),
    h5: y(i, 24, 1.334, 0),
    h6: y(s, 20, 1.6, 0.15),
    subtitle1: y(i, 16, 1.75, 0.15),
    subtitle2: y(s, 14, 1.57, 0.1),
    body1: y(i, 16, 1.5, 0.15),
    body2: y(i, 14, 1.43, 0.15),
    button: y(s, 14, 1.75, 0.4, ka),
    caption: y(i, 12, 1.66, 0.4),
    overline: y(i, 12, 2.66, 1, ka),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return ot({
    htmlFontSize: c,
    pxToRem: h,
    fontFamily: r,
    fontSize: n,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: s,
    fontWeightBold: l,
    ...p
  }, d, {
    clone: !1
    // No need to clone deep
  });
}
const sp = 0.2, lp = 0.14, cp = 0.12;
function Pe(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${sp})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${lp})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${cp})`].join(",");
}
const up = ["none", Pe(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Pe(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Pe(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Pe(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Pe(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Pe(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Pe(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Pe(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Pe(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Pe(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Pe(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Pe(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Pe(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Pe(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Pe(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Pe(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Pe(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Pe(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Pe(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Pe(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Pe(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Pe(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Pe(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Pe(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], fp = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, pp = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Na(e) {
  return `${Math.round(e)}ms`;
}
function dp(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function mp(e) {
  const t = {
    ...fp,
    ...e.easing
  }, r = {
    ...pp,
    ...e.duration
  };
  return {
    getAutoHeightDuration: dp,
    create: (o = ["all"], i = {}) => {
      const {
        duration: s = r.standard,
        easing: l = t.easeInOut,
        delay: c = 0,
        ...u
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const f = (m) => typeof m == "string", d = (m) => !Number.isNaN(parseFloat(m));
        !f(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !d(s) && !f(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), f(l) || console.error('MUI: Argument "easing" must be a string.'), !d(c) && !f(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((f) => `${f} ${typeof s == "string" ? s : Na(s)} ${l} ${typeof c == "string" ? c : Na(c)}`).join(",");
    },
    ...e,
    easing: t,
    duration: r
  };
}
const gp = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function hp(e) {
  return Pt(e) || typeof e == "undefined" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Js(e = {}) {
  const t = {
    ...e
  };
  function r(n) {
    const o = Object.entries(n);
    for (let i = 0; i < o.length; i++) {
      const [s, l] = o[i];
      !hp(l) || s.startsWith("unstable_") ? delete n[s] : Pt(l) && (n[s] = {
        ...l
      }, r(n[s]));
    }
  }
  return r(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Go(e = {}, ...t) {
  const {
    breakpoints: r,
    mixins: n = {},
    spacing: o,
    palette: i = {},
    transitions: s = {},
    typography: l = {},
    shape: c,
    ...u
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : jt(20));
  const f = wi(i), d = gi(e);
  let m = ot(d, {
    mixins: op(d.breakpoints, n),
    palette: f,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: up.slice(),
    typography: ap(f, l),
    transitions: mp(s),
    zIndex: {
      ...gp
    }
  });
  if (m = ot(m, u), m = t.reduce((h, y) => ot(h, y), m), process.env.NODE_ENV !== "production") {
    const h = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], y = (p, v) => {
      let w;
      for (w in p) {
        const O = p[w];
        if (h.includes(w) && Object.keys(O).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const C = He("", w);
            console.error([`MUI: The \`${v}\` component increases the CSS specificity of the \`${w}\` internal state.`, "You can not override it like this: ", JSON.stringify(p, null, 2), "", `Instead, you need to use the '&.${C}' syntax:`, JSON.stringify({
              root: {
                [`&.${C}`]: O
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          p[w] = {};
        }
      }
    };
    Object.keys(m.components).forEach((p) => {
      const v = m.components[p].styleOverrides;
      v && p.startsWith("Mui") && y(v, p);
    });
  }
  return m.unstable_sxConfig = {
    ...on,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, m.unstable_sx = function(y) {
    return Sr({
      sx: y,
      theme: this
    });
  }, m.toRuntimeSource = Js, m;
}
function Yo(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const yp = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const r = Yo(t);
  return `linear-gradient(rgba(255 255 255 / ${r}), rgba(255 255 255 / ${r}))`;
});
function Qs(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Zs(e) {
  return e === "dark" ? yp : [];
}
function bp(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: r,
    overlays: n,
    ...o
  } = e, i = wi(t);
  return {
    palette: i,
    opacity: {
      ...Qs(i.mode),
      ...r
    },
    overlays: n || Zs(i.mode),
    ...o
  };
}
function vp(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Cp = (e) => [...[...Array(25)].map((t, r) => `--${e ? `${e}-` : ""}overlays-${r}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], Sp = (e) => (t, r) => {
  const n = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let i = o;
  if (o === "class" && (i = ".%s"), o === "data" && (i = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (i = `[${o}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return Cp(e.cssVarPrefix).forEach((l) => {
        s[l] = r[l], delete r[l];
      }), i === "media" ? {
        [n]: r,
        "@media (prefers-color-scheme: dark)": {
          [n]: s
        }
      } : i ? {
        [i.replace("%s", t)]: s,
        [`${n}, ${i.replace("%s", t)}`]: r
      } : {
        [n]: {
          ...r,
          ...s
        }
      };
    }
    if (i && i !== "media")
      return `${n}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [n]: r
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return n;
};
function wp(e, t) {
  t.forEach((r) => {
    e[r] || (e[r] = {});
  });
}
function R(e, t, r) {
  !e[t] && r && (e[t] = r);
}
function jr(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : Bs(e);
}
function Ft(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Lr(jr(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function xp(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Ot = (e) => {
  try {
    return e();
  } catch {
  }
}, Ep = (e = "mui") => Hf(e);
function Ao(e, t, r, n) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const o = n === "dark" ? "dark" : "light";
  if (!r) {
    e[n] = bp({
      ...t,
      palette: {
        mode: o,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...s
  } = Go({
    ...r,
    palette: {
      mode: o,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[n] = {
    ...t,
    palette: i,
    opacity: {
      ...Qs(o),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || Zs(o)
  }, s;
}
function Op(e = {}, ...t) {
  const {
    colorSchemes: r = {
      light: !0
    },
    defaultColorScheme: n,
    disableCssColorScheme: o = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: s = vp,
    colorSchemeSelector: l = r.light && r.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...u
  } = e, f = Object.keys(r)[0], d = n || (r.light && f !== "light" ? "light" : f), m = Ep(i), {
    [d]: h,
    light: y,
    dark: p,
    ...v
  } = r, w = {
    ...v
  };
  let O = h;
  if ((d === "dark" && !("dark" in r) || d === "light" && !("light" in r)) && (O = !0), !O)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${d}\` option is either missing or invalid.` : jt(21, d));
  const C = Ao(w, O, u, d);
  y && !w.light && Ao(w, y, void 0, "light"), p && !w.dark && Ao(w, p, void 0, "dark");
  let b = {
    defaultColorScheme: d,
    ...C,
    cssVarPrefix: i,
    colorSchemeSelector: l,
    rootSelector: c,
    getCssVar: m,
    colorSchemes: w,
    font: {
      ...np(C.typography),
      ...C.font
    },
    spacing: xp(u.spacing)
  };
  Object.keys(b.colorSchemes).forEach((D) => {
    const g = b.colorSchemes[D].palette, $ = (k) => {
      const _ = k.split("-"), G = _[1], te = _[2];
      return m(k, g[G][te]);
    };
    if (g.mode === "light" && (R(g.common, "background", "#fff"), R(g.common, "onBackground", "#000")), g.mode === "dark" && (R(g.common, "background", "#000"), R(g.common, "onBackground", "#fff")), wp(g, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), g.mode === "light") {
      R(g.Alert, "errorColor", xe(g.error.light, 0.6)), R(g.Alert, "infoColor", xe(g.info.light, 0.6)), R(g.Alert, "successColor", xe(g.success.light, 0.6)), R(g.Alert, "warningColor", xe(g.warning.light, 0.6)), R(g.Alert, "errorFilledBg", $("palette-error-main")), R(g.Alert, "infoFilledBg", $("palette-info-main")), R(g.Alert, "successFilledBg", $("palette-success-main")), R(g.Alert, "warningFilledBg", $("palette-warning-main")), R(g.Alert, "errorFilledColor", Ot(() => g.getContrastText(g.error.main))), R(g.Alert, "infoFilledColor", Ot(() => g.getContrastText(g.info.main))), R(g.Alert, "successFilledColor", Ot(() => g.getContrastText(g.success.main))), R(g.Alert, "warningFilledColor", Ot(() => g.getContrastText(g.warning.main))), R(g.Alert, "errorStandardBg", Ee(g.error.light, 0.9)), R(g.Alert, "infoStandardBg", Ee(g.info.light, 0.9)), R(g.Alert, "successStandardBg", Ee(g.success.light, 0.9)), R(g.Alert, "warningStandardBg", Ee(g.warning.light, 0.9)), R(g.Alert, "errorIconColor", $("palette-error-main")), R(g.Alert, "infoIconColor", $("palette-info-main")), R(g.Alert, "successIconColor", $("palette-success-main")), R(g.Alert, "warningIconColor", $("palette-warning-main")), R(g.AppBar, "defaultBg", $("palette-grey-100")), R(g.Avatar, "defaultBg", $("palette-grey-400")), R(g.Button, "inheritContainedBg", $("palette-grey-300")), R(g.Button, "inheritContainedHoverBg", $("palette-grey-A100")), R(g.Chip, "defaultBorder", $("palette-grey-400")), R(g.Chip, "defaultAvatarColor", $("palette-grey-700")), R(g.Chip, "defaultIconColor", $("palette-grey-700")), R(g.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), R(g.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), R(g.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), R(g.LinearProgress, "primaryBg", Ee(g.primary.main, 0.62)), R(g.LinearProgress, "secondaryBg", Ee(g.secondary.main, 0.62)), R(g.LinearProgress, "errorBg", Ee(g.error.main, 0.62)), R(g.LinearProgress, "infoBg", Ee(g.info.main, 0.62)), R(g.LinearProgress, "successBg", Ee(g.success.main, 0.62)), R(g.LinearProgress, "warningBg", Ee(g.warning.main, 0.62)), R(g.Skeleton, "bg", `rgba(${$("palette-text-primaryChannel")} / 0.11)`), R(g.Slider, "primaryTrack", Ee(g.primary.main, 0.62)), R(g.Slider, "secondaryTrack", Ee(g.secondary.main, 0.62)), R(g.Slider, "errorTrack", Ee(g.error.main, 0.62)), R(g.Slider, "infoTrack", Ee(g.info.main, 0.62)), R(g.Slider, "successTrack", Ee(g.success.main, 0.62)), R(g.Slider, "warningTrack", Ee(g.warning.main, 0.62));
      const k = Cn(g.background.default, 0.8);
      R(g.SnackbarContent, "bg", k), R(g.SnackbarContent, "color", Ot(() => g.getContrastText(k))), R(g.SpeedDialAction, "fabHoverBg", Cn(g.background.paper, 0.15)), R(g.StepConnector, "border", $("palette-grey-400")), R(g.StepContent, "border", $("palette-grey-400")), R(g.Switch, "defaultColor", $("palette-common-white")), R(g.Switch, "defaultDisabledColor", $("palette-grey-100")), R(g.Switch, "primaryDisabledColor", Ee(g.primary.main, 0.62)), R(g.Switch, "secondaryDisabledColor", Ee(g.secondary.main, 0.62)), R(g.Switch, "errorDisabledColor", Ee(g.error.main, 0.62)), R(g.Switch, "infoDisabledColor", Ee(g.info.main, 0.62)), R(g.Switch, "successDisabledColor", Ee(g.success.main, 0.62)), R(g.Switch, "warningDisabledColor", Ee(g.warning.main, 0.62)), R(g.TableCell, "border", Ee(vn(g.divider, 1), 0.88)), R(g.Tooltip, "bg", vn(g.grey[700], 0.92));
    }
    if (g.mode === "dark") {
      R(g.Alert, "errorColor", Ee(g.error.light, 0.6)), R(g.Alert, "infoColor", Ee(g.info.light, 0.6)), R(g.Alert, "successColor", Ee(g.success.light, 0.6)), R(g.Alert, "warningColor", Ee(g.warning.light, 0.6)), R(g.Alert, "errorFilledBg", $("palette-error-dark")), R(g.Alert, "infoFilledBg", $("palette-info-dark")), R(g.Alert, "successFilledBg", $("palette-success-dark")), R(g.Alert, "warningFilledBg", $("palette-warning-dark")), R(g.Alert, "errorFilledColor", Ot(() => g.getContrastText(g.error.dark))), R(g.Alert, "infoFilledColor", Ot(() => g.getContrastText(g.info.dark))), R(g.Alert, "successFilledColor", Ot(() => g.getContrastText(g.success.dark))), R(g.Alert, "warningFilledColor", Ot(() => g.getContrastText(g.warning.dark))), R(g.Alert, "errorStandardBg", xe(g.error.light, 0.9)), R(g.Alert, "infoStandardBg", xe(g.info.light, 0.9)), R(g.Alert, "successStandardBg", xe(g.success.light, 0.9)), R(g.Alert, "warningStandardBg", xe(g.warning.light, 0.9)), R(g.Alert, "errorIconColor", $("palette-error-main")), R(g.Alert, "infoIconColor", $("palette-info-main")), R(g.Alert, "successIconColor", $("palette-success-main")), R(g.Alert, "warningIconColor", $("palette-warning-main")), R(g.AppBar, "defaultBg", $("palette-grey-900")), R(g.AppBar, "darkBg", $("palette-background-paper")), R(g.AppBar, "darkColor", $("palette-text-primary")), R(g.Avatar, "defaultBg", $("palette-grey-600")), R(g.Button, "inheritContainedBg", $("palette-grey-800")), R(g.Button, "inheritContainedHoverBg", $("palette-grey-700")), R(g.Chip, "defaultBorder", $("palette-grey-700")), R(g.Chip, "defaultAvatarColor", $("palette-grey-300")), R(g.Chip, "defaultIconColor", $("palette-grey-300")), R(g.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), R(g.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), R(g.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), R(g.LinearProgress, "primaryBg", xe(g.primary.main, 0.5)), R(g.LinearProgress, "secondaryBg", xe(g.secondary.main, 0.5)), R(g.LinearProgress, "errorBg", xe(g.error.main, 0.5)), R(g.LinearProgress, "infoBg", xe(g.info.main, 0.5)), R(g.LinearProgress, "successBg", xe(g.success.main, 0.5)), R(g.LinearProgress, "warningBg", xe(g.warning.main, 0.5)), R(g.Skeleton, "bg", `rgba(${$("palette-text-primaryChannel")} / 0.13)`), R(g.Slider, "primaryTrack", xe(g.primary.main, 0.5)), R(g.Slider, "secondaryTrack", xe(g.secondary.main, 0.5)), R(g.Slider, "errorTrack", xe(g.error.main, 0.5)), R(g.Slider, "infoTrack", xe(g.info.main, 0.5)), R(g.Slider, "successTrack", xe(g.success.main, 0.5)), R(g.Slider, "warningTrack", xe(g.warning.main, 0.5));
      const k = Cn(g.background.default, 0.98);
      R(g.SnackbarContent, "bg", k), R(g.SnackbarContent, "color", Ot(() => g.getContrastText(k))), R(g.SpeedDialAction, "fabHoverBg", Cn(g.background.paper, 0.15)), R(g.StepConnector, "border", $("palette-grey-600")), R(g.StepContent, "border", $("palette-grey-600")), R(g.Switch, "defaultColor", $("palette-grey-300")), R(g.Switch, "defaultDisabledColor", $("palette-grey-600")), R(g.Switch, "primaryDisabledColor", xe(g.primary.main, 0.55)), R(g.Switch, "secondaryDisabledColor", xe(g.secondary.main, 0.55)), R(g.Switch, "errorDisabledColor", xe(g.error.main, 0.55)), R(g.Switch, "infoDisabledColor", xe(g.info.main, 0.55)), R(g.Switch, "successDisabledColor", xe(g.success.main, 0.55)), R(g.Switch, "warningDisabledColor", xe(g.warning.main, 0.55)), R(g.TableCell, "border", xe(vn(g.divider, 1), 0.68)), R(g.Tooltip, "bg", vn(g.grey[700], 0.92));
    }
    Ft(g.background, "default"), Ft(g.background, "paper"), Ft(g.common, "background"), Ft(g.common, "onBackground"), Ft(g, "divider"), Object.keys(g).forEach((k) => {
      const _ = g[k];
      k !== "tonalOffset" && _ && typeof _ == "object" && (_.main && R(g[k], "mainChannel", Lr(jr(_.main))), _.light && R(g[k], "lightChannel", Lr(jr(_.light))), _.dark && R(g[k], "darkChannel", Lr(jr(_.dark))), _.contrastText && R(g[k], "contrastTextChannel", Lr(jr(_.contrastText))), k === "text" && (Ft(g[k], "primary"), Ft(g[k], "secondary")), k === "action" && (_.active && Ft(g[k], "active"), _.selected && Ft(g[k], "selected")));
    });
  }), b = t.reduce((D, g) => ot(D, g), b);
  const S = {
    prefix: i,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: s,
    getSelector: Sp(b)
  }, {
    vars: E,
    generateThemeVars: P,
    generateStyleSheets: V
  } = Yf(b, S);
  return b.vars = E, Object.entries(b.colorSchemes[b.defaultColorScheme]).forEach(([D, g]) => {
    b[D] = g;
  }), b.generateThemeVars = P, b.generateStyleSheets = V, b.generateSpacing = function() {
    return Ms(u.spacing, di(this));
  }, b.getColorSchemeSelector = Kf(l), b.spacing = b.generateSpacing(), b.shouldSkipGeneratingVar = s, b.unstable_sxConfig = {
    ...on,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, b.unstable_sx = function(g) {
    return Sr({
      sx: g,
      theme: this
    });
  }, b.toRuntimeSource = Js, b;
}
function Ma(e, t, r) {
  e.colorSchemes && r && (e.colorSchemes[t] = {
    ...r !== !0 && r,
    palette: wi({
      ...r === !0 ? {} : r.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function Tp(e = {}, ...t) {
  const {
    palette: r,
    cssVariables: n = !1,
    colorSchemes: o = r ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = r == null ? void 0 : r.mode,
    ...s
  } = e, l = i || "light", c = o == null ? void 0 : o[l], u = {
    ...o,
    ...r ? {
      [l]: {
        ...typeof c != "boolean" && c,
        palette: r
      }
    } : void 0
  };
  if (n === !1) {
    if (!("colorSchemes" in e))
      return Go(e, ...t);
    let f = r;
    "palette" in e || u[l] && (u[l] !== !0 ? f = u[l].palette : l === "dark" && (f = {
      mode: "dark"
    }));
    const d = Go({
      ...e,
      palette: f
    }, ...t);
    return d.defaultColorScheme = l, d.colorSchemes = u, d.palette.mode === "light" && (d.colorSchemes.light = {
      ...u.light !== !0 && u.light,
      palette: d.palette
    }, Ma(d, "dark", u.dark)), d.palette.mode === "dark" && (d.colorSchemes.dark = {
      ...u.dark !== !0 && u.dark,
      palette: d.palette
    }, Ma(d, "light", u.light)), d;
  }
  return !r && !("light" in u) && l === "light" && (u.light = !0), Op({
    ...s,
    colorSchemes: u,
    defaultColorScheme: l,
    ...typeof n != "boolean" && n
  }, ...t);
}
const xi = Tp();
function Rp() {
  const e = Ds(xi);
  return process.env.NODE_ENV !== "production" && x.useDebugValue(e), e[ri] || e;
}
function Pp(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const $p = (e) => Pp(e) && e !== "classes", be = gf({
  themeId: ri,
  defaultTheme: xi,
  rootShouldForwardProp: $p
});
function el(e) {
  return /* @__PURE__ */ W(_s, {
    ...e,
    defaultTheme: xi,
    themeId: ri
  });
}
process.env.NODE_ENV !== "production" && (el.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: a.oneOfType([a.array, a.func, a.number, a.object, a.string, a.bool])
});
function Ip(e) {
  return function(r) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ W(el, {
        styles: typeof e == "function" ? (n) => e({
          theme: n,
          ...r
        }) : e
      })
    );
  };
}
function Ah() {
  return sf;
}
const Ue = Uf;
process.env.NODE_ENV !== "production" && (a.node, a.object.isRequired);
function vt(e) {
  return Wf(e);
}
function kp(e) {
  return He("MuiSvgIcon", e);
}
Ge("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Ap = (e) => {
  const {
    color: t,
    fontSize: r,
    classes: n
  } = e, o = {
    root: ["root", t !== "inherit" && `color${Q(t)}`, `fontSize${Q(r)}`]
  };
  return gt(o, kp, n);
}, Np = be("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "inherit" && t[`color${Q(r.color)}`], t[`fontSize${Q(r.fontSize)}`]];
  }
})(Ue(({
  theme: e
}) => {
  var t, r, n, o, i, s, l, c, u, f, d, m, h, y, p, v, w, O;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (i = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : i.call(t, "fill", {
      duration: (o = (n = ((r = e.vars) != null ? r : e).transitions) == null ? void 0 : n.duration) == null ? void 0 : o.shorter
    }),
    variants: [
      {
        props: (C) => !C.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((l = (s = e.typography) == null ? void 0 : s.pxToRem) == null ? void 0 : l.call(s, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((u = (c = e.typography) == null ? void 0 : c.pxToRem) == null ? void 0 : u.call(c, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((d = (f = e.typography) == null ? void 0 : f.pxToRem) == null ? void 0 : d.call(f, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries(((m = e.vars) != null ? m : e).palette).filter(([, C]) => C && C.main).map(([C]) => {
        var b, S, E;
        return {
          props: {
            color: C
          },
          style: {
            color: (E = (S = ((b = e.vars) != null ? b : e).palette) == null ? void 0 : S[C]) == null ? void 0 : E.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (p = (y = ((h = e.vars) != null ? h : e).palette) == null ? void 0 : y.action) == null ? void 0 : p.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (O = (w = ((v = e.vars) != null ? v : e).palette) == null ? void 0 : w.action) == null ? void 0 : O.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), Mn = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = vt({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: s = "inherit",
    component: l = "svg",
    fontSize: c = "medium",
    htmlColor: u,
    inheritViewBox: f = !1,
    titleAccess: d,
    viewBox: m = "0 0 24 24",
    ...h
  } = n, y = /* @__PURE__ */ x.isValidElement(o) && o.type === "svg", p = {
    ...n,
    color: s,
    component: l,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: f,
    viewBox: m,
    hasSvgAsChild: y
  }, v = {};
  f || (v.viewBox = m);
  const w = Ap(p);
  return /* @__PURE__ */ bt(Np, {
    as: l,
    className: we(w.root, i),
    focusable: "false",
    color: u,
    "aria-hidden": d ? void 0 : !0,
    role: d ? "img" : void 0,
    ref: r,
    ...v,
    ...h,
    ...y && o.props,
    ownerState: p,
    children: [y ? o.props.children : o, d ? /* @__PURE__ */ W("title", {
      children: d
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Mn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: a.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: a.oneOfType([a.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), a.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: a.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: a.oneOfType([a.oneOf(["inherit", "large", "medium", "small"]), a.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: a.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: a.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: a.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: a.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: a.string
});
Mn.muiName = "SvgIcon";
function Ei(e, t) {
  function r(n, o) {
    return /* @__PURE__ */ W(Mn, {
      "data-testid": `${t}Icon`,
      ref: o,
      ...n,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (r.displayName = `${t}Icon`), r.muiName = Mn.muiName, /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(r));
}
function sr(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Ko(e, t) {
  return Ko = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Ko(e, t);
}
function Mp(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Ko(e, t);
}
const Da = Vr.createContext(null);
function Dp(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Oi(e, t) {
  var r = function(i) {
    return t && En(i) ? t(i) : i;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && Yl.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    n[o.key] = r(o);
  }), n;
}
function _p(e, t) {
  e = e || {}, t = t || {};
  function r(f) {
    return f in t ? t[f] : e[f];
  }
  var n = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (n[i] = o, o = []) : o.push(i);
  var s, l = {};
  for (var c in t) {
    if (n[c])
      for (s = 0; s < n[c].length; s++) {
        var u = n[c][s];
        l[n[c][s]] = r(u);
      }
    l[c] = r(c);
  }
  for (s = 0; s < o.length; s++)
    l[o[s]] = r(o[s]);
  return l;
}
function nr(e, t, r) {
  return r[t] != null ? r[t] : e.props[t];
}
function Fp(e, t) {
  return Oi(e.children, function(r) {
    return On(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: nr(r, "appear", e),
      enter: nr(r, "enter", e),
      exit: nr(r, "exit", e)
    });
  });
}
function Vp(e, t, r) {
  var n = Oi(e.children), o = _p(t, n);
  return Object.keys(o).forEach(function(i) {
    var s = o[i];
    if (En(s)) {
      var l = i in t, c = i in n, u = t[i], f = En(u) && !u.props.in;
      c && (!l || f) ? o[i] = On(s, {
        onExited: r.bind(null, s),
        in: !0,
        exit: nr(s, "exit", e),
        enter: nr(s, "enter", e)
      }) : !c && l && !f ? o[i] = On(s, {
        in: !1
      }) : c && l && En(u) && (o[i] = On(s, {
        onExited: r.bind(null, s),
        in: u.props.in,
        exit: nr(s, "exit", e),
        enter: nr(s, "enter", e)
      }));
    }
  }), o;
}
var Lp = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, jp = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Ti = /* @__PURE__ */ (function(e) {
  Mp(t, e);
  function t(n, o) {
    var i;
    i = e.call(this, n, o) || this;
    var s = i.handleExited.bind(Dp(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, i;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var s = i.children, l = i.handleExited, c = i.firstRender;
    return {
      children: c ? Fp(o, l) : Vp(o, s, l),
      firstRender: !1
    };
  }, r.handleExited = function(o, i) {
    var s = Oi(this.props.children);
    o.key in s || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(l) {
      var c = ce({}, l.children);
      return delete c[o.key], {
        children: c
      };
    }));
  }, r.render = function() {
    var o = this.props, i = o.component, s = o.childFactory, l = sr(o, ["component", "childFactory"]), c = this.state.contextValue, u = Lp(this.state.children).map(s);
    return delete l.appear, delete l.enter, delete l.exit, i === null ? /* @__PURE__ */ Vr.createElement(Da.Provider, {
      value: c
    }, u) : /* @__PURE__ */ Vr.createElement(Da.Provider, {
      value: c
    }, /* @__PURE__ */ Vr.createElement(i, l, u));
  }, t;
})(Vr.Component);
Ti.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: a.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: a.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: a.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: a.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: a.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: a.func
} : {};
Ti.defaultProps = jp;
function Bp(e) {
  return He("MuiPaper", e);
}
Ge("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const zp = (e) => {
  const {
    square: t,
    elevation: r,
    variant: n,
    classes: o
  } = e, i = {
    root: ["root", n, !t && "rounded", n === "elevation" && `elevation${r}`]
  };
  return gt(i, Bp, o);
}, Wp = be("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], !r.square && t.rounded, r.variant === "elevation" && t[`elevation${r.elevation}`]];
  }
})(Ue(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Ri = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var h;
  const n = vt({
    props: t,
    name: "MuiPaper"
  }), o = Rp(), {
    className: i,
    component: s = "div",
    elevation: l = 1,
    square: c = !1,
    variant: u = "elevation",
    ...f
  } = n, d = {
    ...n,
    component: s,
    elevation: l,
    square: c,
    variant: u
  }, m = zp(d);
  return process.env.NODE_ENV !== "production" && o.shadows[l] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${l}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${l}]\` is defined.`].join(`
`)), /* @__PURE__ */ W(Wp, {
    as: s,
    ownerState: d,
    className: we(m.root, i),
    ref: r,
    ...f,
    style: {
      ...u === "elevation" && {
        "--Paper-shadow": (o.vars || o).shadows[l],
        ...o.vars && {
          "--Paper-overlay": (h = o.vars.overlays) == null ? void 0 : h[l]
        },
        ...!o.vars && o.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${Ve("#fff", Yo(l))}, ${Ve("#fff", Yo(l))})`
        }
      },
      ...f.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Ri.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: a.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: a.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: ar(Hs, (e) => {
    const {
      elevation: t,
      variant: r
    } = e;
    return t > 0 && r === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${r}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: a.bool,
  /**
   * @ignore
   */
  style: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: a.oneOfType([a.oneOf(["elevation", "outlined"]), a.string])
});
function No(e, t) {
  const {
    className: r,
    elementType: n,
    ownerState: o,
    externalForwardedProps: i,
    internalForwardedProps: s,
    shouldForwardComponentProp: l = !1,
    ...c
  } = t, {
    component: u,
    slots: f = {
      [e]: void 0
    },
    slotProps: d = {
      [e]: void 0
    },
    ...m
  } = i, h = f[e] || n, y = Ys(d[e], o), {
    props: {
      component: p,
      ...v
    },
    internalRef: w
  } = Gs({
    className: r,
    ...c,
    externalForwardedProps: e === "root" ? m : void 0,
    externalSlotProps: y
  }), O = Nt(w, y == null ? void 0 : y.ref, t.ref), C = e === "root" ? p || u : p, b = qs(h, {
    ...e === "root" && !u && !f[e] && s,
    ...e !== "root" && !f[e] && s,
    ...v,
    ...C && !l && {
      as: C
    },
    ...C && l && {
      component: C
    },
    ref: O
  }, o);
  return [h, b];
}
class Dn {
  constructor() {
    Nr(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new Dn();
  }
  static use() {
    const t = io(Dn.create).current, [r, n] = x.useState(!1);
    return t.shouldMount = r, t.setShouldMount = n, x.useEffect(t.mountEffect, [r]), t;
  }
  mount() {
    return this.mounted || (this.mounted = Hp(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.pulsate(...t);
    });
  }
}
function Up() {
  return Dn.use();
}
function Hp() {
  let e, t;
  const r = new Promise((n, o) => {
    e = n, t = o;
  });
  return r.resolve = e, r.reject = t, r;
}
function tl(e) {
  const {
    className: t,
    classes: r,
    pulsate: n = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: s,
    in: l,
    onExited: c,
    timeout: u
  } = e, [f, d] = x.useState(!1), m = we(t, r.ripple, r.rippleVisible, n && r.ripplePulsate), h = {
    width: s,
    height: s,
    top: -(s / 2) + i,
    left: -(s / 2) + o
  }, y = we(r.child, f && r.childLeaving, n && r.childPulsate);
  return !l && !f && d(!0), x.useEffect(() => {
    if (!l && c != null) {
      const p = setTimeout(c, u);
      return () => {
        clearTimeout(p);
      };
    }
  }, [c, l, u]), /* @__PURE__ */ W("span", {
    className: m,
    style: h,
    children: /* @__PURE__ */ W("span", {
      className: y
    })
  });
}
process.env.NODE_ENV !== "production" && (tl.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object.isRequired,
  className: a.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: a.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: a.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: a.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: a.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: a.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: a.number,
  /**
   * exit delay
   */
  timeout: a.number.isRequired
});
const st = Ge("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Xo = 550, qp = 80, Gp = tn`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, Yp = tn`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, Kp = tn`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, Xp = be("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Jp = be(tl, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${st.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${Gp};
    animation-duration: ${Xo}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${st.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${st.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${st.childLeaving} {
    opacity: 0;
    animation-name: ${Yp};
    animation-duration: ${Xo}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${st.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${Kp};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, rl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = vt({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: s,
    ...l
  } = n, [c, u] = x.useState([]), f = x.useRef(0), d = x.useRef(null);
  x.useEffect(() => {
    d.current && (d.current(), d.current = null);
  }, [c]);
  const m = x.useRef(!1), h = Si(), y = x.useRef(null), p = x.useRef(null), v = x.useCallback((b) => {
    const {
      pulsate: S,
      rippleX: E,
      rippleY: P,
      rippleSize: V,
      cb: D
    } = b;
    u((g) => [...g, /* @__PURE__ */ W(Jp, {
      classes: {
        ripple: we(i.ripple, st.ripple),
        rippleVisible: we(i.rippleVisible, st.rippleVisible),
        ripplePulsate: we(i.ripplePulsate, st.ripplePulsate),
        child: we(i.child, st.child),
        childLeaving: we(i.childLeaving, st.childLeaving),
        childPulsate: we(i.childPulsate, st.childPulsate)
      },
      timeout: Xo,
      pulsate: S,
      rippleX: E,
      rippleY: P,
      rippleSize: V
    }, f.current)]), f.current += 1, d.current = D;
  }, [i]), w = x.useCallback((b = {}, S = {}, E = () => {
  }) => {
    const {
      pulsate: P = !1,
      center: V = o || S.pulsate,
      fakeElement: D = !1
      // For test purposes
    } = S;
    if ((b == null ? void 0 : b.type) === "mousedown" && m.current) {
      m.current = !1;
      return;
    }
    (b == null ? void 0 : b.type) === "touchstart" && (m.current = !0);
    const g = D ? null : p.current, $ = g ? g.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let k, _, G;
    if (V || b === void 0 || b.clientX === 0 && b.clientY === 0 || !b.clientX && !b.touches)
      k = Math.round($.width / 2), _ = Math.round($.height / 2);
    else {
      const {
        clientX: te,
        clientY: Y
      } = b.touches && b.touches.length > 0 ? b.touches[0] : b;
      k = Math.round(te - $.left), _ = Math.round(Y - $.top);
    }
    if (V)
      G = Math.sqrt((2 * $.width ** 2 + $.height ** 2) / 3), G % 2 === 0 && (G += 1);
    else {
      const te = Math.max(Math.abs((g ? g.clientWidth : 0) - k), k) * 2 + 2, Y = Math.max(Math.abs((g ? g.clientHeight : 0) - _), _) * 2 + 2;
      G = Math.sqrt(te ** 2 + Y ** 2);
    }
    b != null && b.touches ? y.current === null && (y.current = () => {
      v({
        pulsate: P,
        rippleX: k,
        rippleY: _,
        rippleSize: G,
        cb: E
      });
    }, h.start(qp, () => {
      y.current && (y.current(), y.current = null);
    })) : v({
      pulsate: P,
      rippleX: k,
      rippleY: _,
      rippleSize: G,
      cb: E
    });
  }, [o, v, h]), O = x.useCallback(() => {
    w({}, {
      pulsate: !0
    });
  }, [w]), C = x.useCallback((b, S) => {
    if (h.clear(), (b == null ? void 0 : b.type) === "touchend" && y.current) {
      y.current(), y.current = null, h.start(0, () => {
        C(b, S);
      });
      return;
    }
    y.current = null, u((E) => E.length > 0 ? E.slice(1) : E), d.current = S;
  }, [h]);
  return x.useImperativeHandle(r, () => ({
    pulsate: O,
    start: w,
    stop: C
  }), [O, w, C]), /* @__PURE__ */ W(Xp, {
    className: we(st.root, i.root, s),
    ref: p,
    ...l,
    children: /* @__PURE__ */ W(Ti, {
      component: null,
      exit: !0,
      children: c
    })
  });
});
process.env.NODE_ENV !== "production" && (rl.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string
});
function Qp(e) {
  return He("MuiButtonBase", e);
}
const Zp = Ge("MuiButtonBase", ["root", "disabled", "focusVisible"]), ed = (e) => {
  const {
    disabled: t,
    focusVisible: r,
    focusVisibleClassName: n,
    classes: o
  } = e, s = gt({
    root: ["root", t && "disabled", r && "focusVisible"]
  }, Qp, o);
  return r && n && (s.root += ` ${n}`), s;
}, td = be("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Zp.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), _n = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = vt({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: s,
    className: l,
    component: c = "button",
    disabled: u = !1,
    disableRipple: f = !1,
    disableTouchRipple: d = !1,
    focusRipple: m = !1,
    focusVisibleClassName: h,
    LinkComponent: y = "a",
    onBlur: p,
    onClick: v,
    onContextMenu: w,
    onDragLeave: O,
    onFocus: C,
    onFocusVisible: b,
    onKeyDown: S,
    onKeyUp: E,
    onMouseDown: P,
    onMouseLeave: V,
    onMouseUp: D,
    onTouchEnd: g,
    onTouchMove: $,
    onTouchStart: k,
    tabIndex: _ = 0,
    TouchRippleProps: G,
    touchRippleRef: te,
    type: Y,
    ...Z
  } = n, pe = x.useRef(null), B = Up(), A = Nt(B.ref, te), [M, H] = x.useState(!1);
  u && M && H(!1), x.useImperativeHandle(o, () => ({
    focusVisible: () => {
      H(!0), pe.current.focus();
    }
  }), []);
  const K = B.shouldMount && !f && !u;
  x.useEffect(() => {
    M && m && !f && B.pulsate();
  }, [f, m, M, B]);
  const j = Vt(B, "start", P, d), z = Vt(B, "stop", w, d), J = Vt(B, "stop", O, d), X = Vt(B, "stop", D, d), L = Vt(B, "stop", (ee) => {
    M && ee.preventDefault(), V && V(ee);
  }, d), q = Vt(B, "start", k, d), re = Vt(B, "stop", g, d), Te = Vt(B, "stop", $, d), N = Vt(B, "stop", (ee) => {
    Oa(ee.target) || H(!1), p && p(ee);
  }, !1), Re = Lt((ee) => {
    pe.current || (pe.current = ee.currentTarget), Oa(ee.target) && (H(!0), b && b(ee)), C && C(ee);
  }), ae = () => {
    const ee = pe.current;
    return c && c !== "button" && !(ee.tagName === "A" && ee.href);
  }, ue = Lt((ee) => {
    m && !ee.repeat && M && ee.key === " " && B.stop(ee, () => {
      B.start(ee);
    }), ee.target === ee.currentTarget && ae() && ee.key === " " && ee.preventDefault(), S && S(ee), ee.target === ee.currentTarget && ae() && ee.key === "Enter" && !u && (ee.preventDefault(), v && v(ee));
  }), Qe = Lt((ee) => {
    m && ee.key === " " && M && !ee.defaultPrevented && B.stop(ee, () => {
      B.pulsate(ee);
    }), E && E(ee), v && ee.target === ee.currentTarget && ae() && ee.key === " " && !ee.defaultPrevented && v(ee);
  });
  let U = c;
  U === "button" && (Z.href || Z.to) && (U = y);
  const Le = {};
  U === "button" ? (Le.type = Y === void 0 ? "button" : Y, Le.disabled = u) : (!Z.href && !Z.to && (Le.role = "button"), u && (Le["aria-disabled"] = u));
  const fe = Nt(r, pe), De = {
    ...n,
    centerRipple: i,
    component: c,
    disabled: u,
    disableRipple: f,
    disableTouchRipple: d,
    focusRipple: m,
    tabIndex: _,
    focusVisible: M
  }, Be = ed(De);
  return /* @__PURE__ */ bt(td, {
    as: U,
    className: we(Be.root, l),
    ownerState: De,
    onBlur: N,
    onClick: v,
    onContextMenu: z,
    onFocus: Re,
    onKeyDown: ue,
    onKeyUp: Qe,
    onMouseDown: j,
    onMouseLeave: L,
    onMouseUp: X,
    onDragLeave: J,
    onTouchEnd: re,
    onTouchMove: Te,
    onTouchStart: q,
    ref: fe,
    tabIndex: u ? -1 : _,
    type: Y,
    ...Le,
    ...Z,
    children: [s, K ? /* @__PURE__ */ W(rl, {
      ref: A,
      center: i,
      ...G
    }) : null]
  });
});
function Vt(e, t, r, n = !1) {
  return Lt((o) => (r && r(o), n || e[t](o), !0));
}
process.env.NODE_ENV !== "production" && (_n.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: oo,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: a.bool,
  /**
   * The content of the component.
   */
  children: a.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: zs,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: a.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: a.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: a.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: a.string,
  /**
   * @ignore
   */
  href: a.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: a.elementType,
  /**
   * @ignore
   */
  onBlur: a.func,
  /**
   * @ignore
   */
  onClick: a.func,
  /**
   * @ignore
   */
  onContextMenu: a.func,
  /**
   * @ignore
   */
  onDragLeave: a.func,
  /**
   * @ignore
   */
  onFocus: a.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: a.func,
  /**
   * @ignore
   */
  onKeyDown: a.func,
  /**
   * @ignore
   */
  onKeyUp: a.func,
  /**
   * @ignore
   */
  onMouseDown: a.func,
  /**
   * @ignore
   */
  onMouseLeave: a.func,
  /**
   * @ignore
   */
  onMouseUp: a.func,
  /**
   * @ignore
   */
  onTouchEnd: a.func,
  /**
   * @ignore
   */
  onTouchMove: a.func,
  /**
   * @ignore
   */
  onTouchStart: a.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * @default 0
   */
  tabIndex: a.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: a.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: a.oneOfType([a.func, a.shape({
    current: a.shape({
      pulsate: a.func.isRequired,
      start: a.func.isRequired,
      stop: a.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: a.oneOfType([a.oneOf(["button", "reset", "submit"]), a.string])
});
function rd(e) {
  return typeof e.main == "string";
}
function nd(e, t = []) {
  if (!rd(e))
    return !1;
  for (const r of t)
    if (!e.hasOwnProperty(r) || typeof e[r] != "string")
      return !1;
  return !0;
}
function or(e = []) {
  return ([, t]) => t && nd(t, e);
}
function od(e) {
  return He("MuiCircularProgress", e);
}
Ge("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Ht = 44, Jo = tn`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, Qo = tn`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, id = typeof Jo != "string" ? fi`
        animation: ${Jo} 1.4s linear infinite;
      ` : null, ad = typeof Qo != "string" ? fi`
        animation: ${Qo} 1.4s ease-in-out infinite;
      ` : null, sd = (e) => {
  const {
    classes: t,
    variant: r,
    color: n,
    disableShrink: o
  } = e, i = {
    root: ["root", r, `color${Q(n)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Q(r)}`, o && "circleDisableShrink"]
  };
  return gt(i, od, t);
}, ld = be("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`color${Q(r.color)}`]];
  }
})(Ue(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: id || {
      animation: `${Jo} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(or()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), cd = be("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), ud = be("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.circle, t[`circle${Q(r.variant)}`], r.disableShrink && t.circleDisableShrink];
  }
})(Ue(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: ad || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${Qo} 1.4s ease-in-out infinite`
    }
  }]
}))), nl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = vt({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: o,
    color: i = "primary",
    disableShrink: s = !1,
    size: l = 40,
    style: c,
    thickness: u = 3.6,
    value: f = 0,
    variant: d = "indeterminate",
    ...m
  } = n, h = {
    ...n,
    color: i,
    disableShrink: s,
    size: l,
    thickness: u,
    value: f,
    variant: d
  }, y = sd(h), p = {}, v = {}, w = {};
  if (d === "determinate") {
    const O = 2 * Math.PI * ((Ht - u) / 2);
    p.strokeDasharray = O.toFixed(3), w["aria-valuenow"] = Math.round(f), p.strokeDashoffset = `${((100 - f) / 100 * O).toFixed(3)}px`, v.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ W(ld, {
    className: we(y.root, o),
    style: {
      width: l,
      height: l,
      ...v,
      ...c
    },
    ownerState: h,
    ref: r,
    role: "progressbar",
    ...w,
    ...m,
    children: /* @__PURE__ */ W(cd, {
      className: y.svg,
      ownerState: h,
      viewBox: `${Ht / 2} ${Ht / 2} ${Ht} ${Ht}`,
      children: /* @__PURE__ */ W(ud, {
        className: y.circle,
        style: p,
        ownerState: h,
        cx: Ht,
        cy: Ht,
        r: (Ht - u) / 2,
        fill: "none",
        strokeWidth: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (nl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: a.oneOfType([a.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), a.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: ar(a.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: a.oneOfType([a.number, a.string]),
  /**
   * @ignore
   */
  style: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: a.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: a.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: a.oneOf(["determinate", "indeterminate"])
});
function fd(e) {
  return He("MuiIconButton", e);
}
const _a = Ge("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), pd = (e) => {
  const {
    classes: t,
    disabled: r,
    color: n,
    edge: o,
    size: i,
    loading: s
  } = e, l = {
    root: ["root", s && "loading", r && "disabled", n !== "default" && `color${Q(n)}`, o && `edge${Q(o)}`, `size${Q(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return gt(l, fd, t);
}, dd = be(_n, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.loading && t.loading, r.color !== "default" && t[`color${Q(r.color)}`], r.edge && t[`edge${Q(r.edge)}`], t[`size${Q(r.size)}`]];
  }
})(Ue(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Ve(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), Ue(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(or()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(or()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Ve((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${_a.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${_a.loading}`]: {
    color: "transparent"
  }
}))), md = be("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), Pi = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = vt({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: i,
    className: s,
    color: l = "default",
    disabled: c = !1,
    disableFocusRipple: u = !1,
    size: f = "medium",
    id: d,
    loading: m = null,
    loadingIndicator: h,
    ...y
  } = n, p = an(d), v = h != null ? h : /* @__PURE__ */ W(nl, {
    "aria-labelledby": p,
    color: "inherit",
    size: 16
  }), w = {
    ...n,
    edge: o,
    color: l,
    disabled: c,
    disableFocusRipple: u,
    loading: m,
    loadingIndicator: v,
    size: f
  }, O = pd(w);
  return /* @__PURE__ */ bt(dd, {
    id: m ? p : d,
    className: we(O.root, s),
    centerRipple: !0,
    focusRipple: !u,
    disabled: c || m,
    ref: r,
    ...y,
    ownerState: w,
    children: [typeof m == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ W("span", {
      className: O.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ W(md, {
        className: O.loadingIndicator,
        ownerState: w,
        children: m && v
      })
    }), i]
  });
});
process.env.NODE_ENV !== "production" && (Pi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: ar(a.node, (e) => x.Children.toArray(e.children).some((r) => /* @__PURE__ */ x.isValidElement(r) && r.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: a.oneOfType([a.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), a.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: a.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: a.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: a.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: a.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: a.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: a.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: a.oneOfType([a.oneOf(["small", "medium", "large"]), a.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object])
});
const gd = Ei(/* @__PURE__ */ W("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function Fa(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function hd(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: r = !0,
    limit: n,
    matchFrom: o = "any",
    stringify: i,
    trim: s = !1
  } = e;
  return (l, {
    inputValue: c,
    getOptionLabel: u
  }) => {
    let f = s ? c.trim() : c;
    r && (f = f.toLowerCase()), t && (f = Fa(f));
    const d = f ? l.filter((m) => {
      let h = (i || u)(m);
      return r && (h = h.toLowerCase()), t && (h = Fa(h)), o === "start" ? h.startsWith(f) : h.includes(f);
    }) : l;
    return typeof n == "number" ? d.slice(0, n) : d;
  };
}
const yd = hd(), Va = 5, bd = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, vd = [];
function La(e, t, r) {
  if (t || e == null)
    return "";
  const n = r(e);
  return typeof n == "string" ? n : "";
}
function Cd(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = bd,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: r = "Mui",
    autoComplete: n = !1,
    autoHighlight: o = !1,
    autoSelect: i = !1,
    blurOnSelect: s = !1,
    clearOnBlur: l = !e.freeSolo,
    clearOnEscape: c = !1,
    componentName: u = "useAutocomplete",
    defaultValue: f = e.multiple ? vd : null,
    disableClearable: d = !1,
    disableCloseOnSelect: m = !1,
    disabled: h,
    disabledItemsFocusable: y = !1,
    disableListWrap: p = !1,
    filterOptions: v = yd,
    filterSelectedOptions: w = !1,
    freeSolo: O = !1,
    getOptionDisabled: C,
    getOptionKey: b,
    getOptionLabel: S = (I) => {
      var T;
      return (T = I.label) != null ? T : I;
    },
    groupBy: E,
    handleHomeEndKeys: P = !e.freeSolo,
    id: V,
    includeInputInList: D = !1,
    inputValue: g,
    isOptionEqualToValue: $ = (I, T) => I === T,
    multiple: k = !1,
    onChange: _,
    onClose: G,
    onHighlightChange: te,
    onInputChange: Y,
    onOpen: Z,
    open: pe,
    openOnFocus: B = !1,
    options: A,
    readOnly: M = !1,
    selectOnFocus: H = !e.freeSolo,
    value: K
  } = e, j = an(V);
  let z = S;
  z = (I) => {
    const T = S(I);
    if (typeof T != "string") {
      if (process.env.NODE_ENV !== "production") {
        const F = T === void 0 ? "undefined" : `${typeof T} (${T})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${u} returned ${F} instead of a string for ${JSON.stringify(I)}.`);
      }
      return String(T);
    }
    return T;
  };
  const J = x.useRef(!1), X = x.useRef(!0), L = x.useRef(null), q = x.useRef(null), [re, Te] = x.useState(null), [N, Re] = x.useState(-1), ae = o ? 0 : -1, ue = x.useRef(ae), Qe = x.useRef(La(f != null ? f : K, k, z)).current, [U, Le] = Io({
    controlled: K,
    default: f,
    name: u
  }), [fe, De] = Io({
    controlled: g,
    default: Qe,
    name: u,
    state: "inputValue"
  }), [Be, ee] = x.useState(!1), Ze = x.useCallback((I, T, F) => {
    if (!(k ? U.length < T.length : T !== null) && !l)
      return;
    const ie = La(T, k, z);
    fe !== ie && (De(ie), Y && Y(I, ie, F));
  }, [z, fe, k, Y, De, l, U]), [$e, Ct] = Io({
    controlled: pe,
    default: !1,
    name: u,
    state: "open"
  }), [Dt, at] = x.useState(!0), St = !k && U != null && fe === z(U), _e = $e && !M, Oe = _e ? v(
    A.filter((I) => !(w && (k ? U : [U]).some((T) => T !== null && $(I, T)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: St && Dt ? "" : fe,
      getOptionLabel: z
    }
  ) : [], Ye = Nf({
    filteredOptions: Oe,
    value: U,
    inputValue: fe
  });
  x.useEffect(() => {
    const I = U !== Ye.value;
    Be && !I || O && !I || Ze(null, U, "reset");
  }, [U, Ze, Be, Ye.value, O]);
  const ve = $e && Oe.length > 0 && !M, wt = Lt((I) => {
    I === -1 ? L.current.focus() : re.querySelector(`[data-tag-index="${I}"]`).focus();
  });
  x.useEffect(() => {
    k && N > U.length - 1 && (Re(-1), wt(-1));
  }, [U, k, N, wt]);
  function cr(I, T) {
    if (!q.current || I < 0 || I >= Oe.length)
      return -1;
    let F = I;
    for (; ; ) {
      const ne = q.current.querySelector(`[data-option-index="${F}"]`), ie = y ? !1 : !ne || ne.disabled || ne.getAttribute("aria-disabled") === "true";
      if (ne && ne.hasAttribute("tabindex") && !ie)
        return F;
      if (T === "next" ? F = (F + 1) % Oe.length : F = (F - 1 + Oe.length) % Oe.length, F === I)
        return -1;
    }
  }
  const _t = Lt(({
    event: I,
    index: T,
    reason: F
  }) => {
    if (ue.current = T, T === -1 ? L.current.removeAttribute("aria-activedescendant") : L.current.setAttribute("aria-activedescendant", `${j}-option-${T}`), te && ["mouse", "keyboard", "touch"].includes(F) && te(I, T === -1 ? null : Oe[T], F), !q.current)
      return;
    const ne = q.current.querySelector(`[role="option"].${r}-focused`);
    ne && (ne.classList.remove(`${r}-focused`), ne.classList.remove(`${r}-focusVisible`));
    let ie = q.current;
    if (q.current.getAttribute("role") !== "listbox" && (ie = q.current.parentElement.querySelector('[role="listbox"]')), !ie)
      return;
    if (T === -1) {
      ie.scrollTop = 0;
      return;
    }
    const le = q.current.querySelector(`[data-option-index="${T}"]`);
    if (le && (le.classList.add(`${r}-focused`), F === "keyboard" && le.classList.add(`${r}-focusVisible`), ie.scrollHeight > ie.clientHeight && F !== "mouse" && F !== "touch")) {
      const Ne = le, qe = ie.clientHeight + ie.scrollTop, kr = Ne.offsetTop + Ne.offsetHeight;
      kr > qe ? ie.scrollTop = kr - ie.clientHeight : Ne.offsetTop - Ne.offsetHeight * (E ? 1.3 : 0) < ie.scrollTop && (ie.scrollTop = Ne.offsetTop - Ne.offsetHeight * (E ? 1.3 : 0));
    }
  }), ht = Lt(({
    event: I,
    diff: T,
    direction: F = "next",
    reason: ne
  }) => {
    if (!_e)
      return;
    const le = cr((() => {
      const Ne = Oe.length - 1;
      if (T === "reset")
        return ae;
      if (T === "start")
        return 0;
      if (T === "end")
        return Ne;
      const qe = ue.current + T;
      return qe < 0 ? qe === -1 && D ? -1 : p && ue.current !== -1 || Math.abs(T) > 1 ? 0 : Ne : qe > Ne ? qe === Ne + 1 && D ? -1 : p || Math.abs(T) > 1 ? Ne : 0 : qe;
    })(), F);
    if (_t({
      index: le,
      reason: ne,
      event: I
    }), n && T !== "reset")
      if (le === -1)
        L.current.value = fe;
      else {
        const Ne = z(Oe[le]);
        L.current.value = Ne, Ne.toLowerCase().indexOf(fe.toLowerCase()) === 0 && fe.length > 0 && L.current.setSelectionRange(fe.length, Ne.length);
      }
  }), fo = () => {
    const I = (T, F) => {
      const ne = T ? z(T) : "", ie = F ? z(F) : "";
      return ne === ie;
    };
    if (ue.current !== -1 && Ye.filteredOptions && Ye.filteredOptions.length !== Oe.length && Ye.inputValue === fe && (k ? U.length === Ye.value.length && Ye.value.every((T, F) => z(U[F]) === z(T)) : I(Ye.value, U))) {
      const T = Ye.filteredOptions[ue.current];
      if (T)
        return Oe.findIndex((F) => z(F) === z(T));
    }
    return -1;
  }, Rr = x.useCallback(() => {
    if (!_e)
      return;
    const I = fo();
    if (I !== -1) {
      ue.current = I;
      return;
    }
    const T = k ? U[0] : U;
    if (Oe.length === 0 || T == null) {
      ht({
        diff: "reset"
      });
      return;
    }
    if (q.current) {
      if (T != null) {
        const F = Oe[ue.current];
        if (k && F && U.findIndex((ie) => $(F, ie)) !== -1)
          return;
        const ne = Oe.findIndex((ie) => $(ie, T));
        ne === -1 ? ht({
          diff: "reset"
        }) : _t({
          index: ne
        });
        return;
      }
      if (ue.current >= Oe.length - 1) {
        _t({
          index: Oe.length - 1
        });
        return;
      }
      _t({
        index: ue.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Oe.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    k ? !1 : U,
    w,
    ht,
    _t,
    _e,
    fe,
    k
  ]), po = Lt((I) => {
    Ho(q, I), I && Rr();
  });
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    (!L.current || L.current.nodeName !== "INPUT") && (L.current && L.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${u} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${L.current} while an HTMLInputElement was expected.`, `Instead, ${u} expects an input element.`, "", u === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [u]), x.useEffect(() => {
    Rr();
  }, [Rr]);
  const yt = (I) => {
    $e || (Ct(!0), at(!0), Z && Z(I));
  }, Jt = (I, T) => {
    $e && (Ct(!1), G && G(I, T));
  }, Wt = (I, T, F, ne) => {
    if (k) {
      if (U.length === T.length && U.every((ie, le) => ie === T[le]))
        return;
    } else if (U === T)
      return;
    _ && _(I, T, F, ne), Le(T);
  }, ur = x.useRef(!1), xt = (I, T, F = "selectOption", ne = "options") => {
    let ie = F, le = T;
    if (k) {
      if (le = Array.isArray(U) ? U.slice() : [], process.env.NODE_ENV !== "production") {
        const qe = le.filter((kr) => $(T, kr));
        qe.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${u} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${qe.length} matches.`].join(`
`));
      }
      const Ne = le.findIndex((qe) => $(T, qe));
      Ne === -1 ? le.push(T) : ne !== "freeSolo" && (le.splice(Ne, 1), ie = "removeOption");
    }
    Ze(I, le, ie), Wt(I, le, ie, {
      option: T
    }), !m && (!I || !I.ctrlKey && !I.metaKey) && Jt(I, ie), (s === !0 || s === "touch" && ur.current || s === "mouse" && !ur.current) && L.current.blur();
  };
  function un(I, T) {
    if (I === -1)
      return -1;
    let F = I;
    for (; ; ) {
      if (T === "next" && F === U.length || T === "previous" && F === -1)
        return -1;
      const ne = re.querySelector(`[data-tag-index="${F}"]`);
      if (!ne || !ne.hasAttribute("tabindex") || ne.disabled || ne.getAttribute("aria-disabled") === "true")
        F += T === "next" ? 1 : -1;
      else
        return F;
    }
  }
  const fn = (I, T) => {
    if (!k)
      return;
    fe === "" && Jt(I, "toggleInput");
    let F = N;
    N === -1 ? fe === "" && T === "previous" && (F = U.length - 1) : (F += T === "next" ? 1 : -1, F < 0 && (F = 0), F === U.length && (F = -1)), F = un(F, T), Re(F), wt(F);
  }, Qt = (I) => {
    J.current = !0, De(""), Y && Y(I, "", "clear"), Wt(I, k ? [] : null, "clear");
  }, mo = (I) => (T) => {
    if (I.onKeyDown && I.onKeyDown(T), !T.defaultMuiPrevented && (N !== -1 && !["ArrowLeft", "ArrowRight"].includes(T.key) && (Re(-1), wt(-1)), T.which !== 229))
      switch (T.key) {
        case "Home":
          _e && P && (T.preventDefault(), ht({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: T
          }));
          break;
        case "End":
          _e && P && (T.preventDefault(), ht({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: T
          }));
          break;
        case "PageUp":
          T.preventDefault(), ht({
            diff: -Va,
            direction: "previous",
            reason: "keyboard",
            event: T
          }), yt(T);
          break;
        case "PageDown":
          T.preventDefault(), ht({
            diff: Va,
            direction: "next",
            reason: "keyboard",
            event: T
          }), yt(T);
          break;
        case "ArrowDown":
          T.preventDefault(), ht({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: T
          }), yt(T);
          break;
        case "ArrowUp":
          T.preventDefault(), ht({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: T
          }), yt(T);
          break;
        case "ArrowLeft":
          fn(T, "previous");
          break;
        case "ArrowRight":
          fn(T, "next");
          break;
        case "Enter":
          if (ue.current !== -1 && _e) {
            const F = Oe[ue.current], ne = C ? C(F) : !1;
            if (T.preventDefault(), ne)
              return;
            xt(T, F, "selectOption"), n && L.current.setSelectionRange(L.current.value.length, L.current.value.length);
          } else O && fe !== "" && St === !1 && (k && T.preventDefault(), xt(T, fe, "createOption", "freeSolo"));
          break;
        case "Escape":
          _e ? (T.preventDefault(), T.stopPropagation(), Jt(T, "escape")) : c && (fe !== "" || k && U.length > 0) && (T.preventDefault(), T.stopPropagation(), Qt(T));
          break;
        case "Backspace":
          if (k && !M && fe === "" && U.length > 0) {
            const F = N === -1 ? U.length - 1 : N, ne = U.slice();
            ne.splice(F, 1), Wt(T, ne, "removeOption", {
              option: U[F]
            });
          }
          break;
        case "Delete":
          if (k && !M && fe === "" && U.length > 0 && N !== -1) {
            const F = N, ne = U.slice();
            ne.splice(F, 1), Wt(T, ne, "removeOption", {
              option: U[F]
            });
          }
          break;
      }
  }, go = (I) => {
    ee(!0), B && !J.current && yt(I);
  }, Zt = (I) => {
    if (t(q)) {
      L.current.focus();
      return;
    }
    ee(!1), X.current = !0, J.current = !1, i && ue.current !== -1 && _e ? xt(I, Oe[ue.current], "blur") : i && O && fe !== "" ? xt(I, fe, "blur", "freeSolo") : l && Ze(I, U, "blur"), Jt(I, "blur");
  }, Pr = (I) => {
    const T = I.target.value;
    fe !== T && (De(T), at(!1), Y && Y(I, T, "input")), T === "" ? !d && !k && Wt(I, null, "clear") : yt(I);
  }, $r = (I) => {
    const T = Number(I.currentTarget.getAttribute("data-option-index"));
    ue.current !== T && _t({
      event: I,
      index: T,
      reason: "mouse"
    });
  }, ho = (I) => {
    _t({
      event: I,
      index: Number(I.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), ur.current = !0;
  }, yo = (I) => {
    const T = Number(I.currentTarget.getAttribute("data-option-index"));
    xt(I, Oe[T], "selectOption"), ur.current = !1;
  }, bo = (I) => (T) => {
    const F = U.slice();
    F.splice(I, 1), Wt(T, F, "removeOption", {
      option: U[I]
    });
  }, vo = (I) => {
    $e ? Jt(I, "toggleInput") : yt(I);
  }, Ir = (I) => {
    I.currentTarget.contains(I.target) && I.target.getAttribute("id") !== j && I.preventDefault();
  }, ze = (I) => {
    I.currentTarget.contains(I.target) && (L.current.focus(), H && X.current && L.current.selectionEnd - L.current.selectionStart === 0 && L.current.select(), X.current = !1);
  }, Fe = (I) => {
    !h && (fe === "" || !$e) && vo(I);
  };
  let Et = O && fe.length > 0;
  Et = Et || (k ? U.length > 0 : U !== null);
  let pn = Oe;
  if (E) {
    const I = /* @__PURE__ */ new Map();
    let T = !1;
    pn = Oe.reduce((F, ne, ie) => {
      const le = E(ne);
      return F.length > 0 && F[F.length - 1].group === le ? F[F.length - 1].options.push(ne) : (process.env.NODE_ENV !== "production" && (I.get(le) && !T && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${u} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), T = !0), I.set(le, !0)), F.push({
        key: ie,
        index: ie,
        group: le,
        options: [ne]
      })), F;
    }, []);
  }
  return h && Be && Zt(), {
    getRootProps: (I = {}) => ({
      ...I,
      onKeyDown: mo(I),
      onMouseDown: Ir,
      onClick: ze
    }),
    getInputLabelProps: () => ({
      id: `${j}-label`,
      htmlFor: j
    }),
    getInputProps: () => ({
      id: j,
      value: fe,
      onBlur: Zt,
      onFocus: go,
      onChange: Pr,
      onMouseDown: Fe,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": _e ? "" : null,
      "aria-autocomplete": n ? "both" : "list",
      "aria-controls": ve ? `${j}-listbox` : void 0,
      "aria-expanded": ve,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: L,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: h
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Qt
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: vo
    }),
    getTagProps: ({
      index: I
    }) => ({
      key: I,
      "data-tag-index": I,
      tabIndex: -1,
      ...!M && {
        onDelete: bo(I)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${j}-listbox`,
      "aria-labelledby": `${j}-label`,
      ref: po,
      onMouseDown: (I) => {
        I.preventDefault();
      }
    }),
    getOptionProps: ({
      index: I,
      option: T
    }) => {
      var ie;
      const F = (k ? U : [U]).some((le) => le != null && $(T, le)), ne = C ? C(T) : !1;
      return {
        key: (ie = b == null ? void 0 : b(T)) != null ? ie : z(T),
        tabIndex: -1,
        role: "option",
        id: `${j}-option-${I}`,
        onMouseMove: $r,
        onClick: yo,
        onTouchStart: ho,
        "data-option-index": I,
        "aria-disabled": ne,
        "aria-selected": F
      };
    },
    id: j,
    inputValue: fe,
    value: U,
    dirty: Et,
    expanded: _e && re,
    popupOpen: _e,
    focused: Be || N !== -1,
    anchorEl: re,
    setAnchorEl: Te,
    focusedTag: N,
    groupedOptions: pn
  };
}
var Ke = "top", pt = "bottom", dt = "right", Xe = "left", $i = "auto", sn = [Ke, pt, dt, Xe], wr = "start", Kr = "end", Sd = "clippingParents", ol = "viewport", _r = "popper", wd = "reference", ja = /* @__PURE__ */ sn.reduce(function(e, t) {
  return e.concat([t + "-" + wr, t + "-" + Kr]);
}, []), il = /* @__PURE__ */ [].concat(sn, [$i]).reduce(function(e, t) {
  return e.concat([t, t + "-" + wr, t + "-" + Kr]);
}, []), xd = "beforeRead", Ed = "read", Od = "afterRead", Td = "beforeMain", Rd = "main", Pd = "afterMain", $d = "beforeWrite", Id = "write", kd = "afterWrite", Ad = [xd, Ed, Od, Td, Rd, Pd, $d, Id, kd];
function Mt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function it(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function lr(e) {
  var t = it(e).Element;
  return e instanceof t || e instanceof Element;
}
function ft(e) {
  var t = it(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ii(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var t = it(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Nd(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, o = t.attributes[r] || {}, i = t.elements[r];
    !ft(i) || !Mt(i) || (Object.assign(i.style, n), Object.keys(o).forEach(function(s) {
      var l = o[s];
      l === !1 ? i.removeAttribute(s) : i.setAttribute(s, l === !0 ? "" : l);
    }));
  });
}
function Md(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var o = t.elements[n], i = t.attributes[n] || {}, s = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), l = s.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !ft(o) || !Mt(o) || (Object.assign(o.style, l), Object.keys(i).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const Dd = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Nd,
  effect: Md,
  requires: ["computeStyles"]
};
function It(e) {
  return e.split("-")[0];
}
var ir = Math.max, Fn = Math.min, xr = Math.round;
function Zo() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function al() {
  return !/^((?!chrome|android).)*safari/i.test(Zo());
}
function Er(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, i = 1;
  t && ft(e) && (o = e.offsetWidth > 0 && xr(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && xr(n.height) / e.offsetHeight || 1);
  var s = lr(e) ? it(e) : window, l = s.visualViewport, c = !al() && r, u = (n.left + (c && l ? l.offsetLeft : 0)) / o, f = (n.top + (c && l ? l.offsetTop : 0)) / i, d = n.width / o, m = n.height / i;
  return {
    width: d,
    height: m,
    top: f,
    right: u + d,
    bottom: f + m,
    left: u,
    x: u,
    y: f
  };
}
function ki(e) {
  var t = Er(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function sl(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Ii(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function zt(e) {
  return it(e).getComputedStyle(e);
}
function _d(e) {
  return ["table", "td", "th"].indexOf(Mt(e)) >= 0;
}
function Kt(e) {
  return ((lr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ao(e) {
  return Mt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ii(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Kt(e)
  );
}
function Ba(e) {
  return !ft(e) || // https://github.com/popperjs/popper-core/issues/837
  zt(e).position === "fixed" ? null : e.offsetParent;
}
function Fd(e) {
  var t = /firefox/i.test(Zo()), r = /Trident/i.test(Zo());
  if (r && ft(e)) {
    var n = zt(e);
    if (n.position === "fixed")
      return null;
  }
  var o = ao(e);
  for (Ii(o) && (o = o.host); ft(o) && ["html", "body"].indexOf(Mt(o)) < 0; ) {
    var i = zt(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function ln(e) {
  for (var t = it(e), r = Ba(e); r && _d(r) && zt(r).position === "static"; )
    r = Ba(r);
  return r && (Mt(r) === "html" || Mt(r) === "body" && zt(r).position === "static") ? t : r || Fd(e) || t;
}
function Ai(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function zr(e, t, r) {
  return ir(e, Fn(t, r));
}
function Vd(e, t, r) {
  var n = zr(e, t, r);
  return n > r ? r : n;
}
function ll() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function cl(e) {
  return Object.assign({}, ll(), e);
}
function ul(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var Ld = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, cl(typeof t != "number" ? t : ul(t, sn));
};
function jd(e) {
  var t, r = e.state, n = e.name, o = e.options, i = r.elements.arrow, s = r.modifiersData.popperOffsets, l = It(r.placement), c = Ai(l), u = [Xe, dt].indexOf(l) >= 0, f = u ? "height" : "width";
  if (!(!i || !s)) {
    var d = Ld(o.padding, r), m = ki(i), h = c === "y" ? Ke : Xe, y = c === "y" ? pt : dt, p = r.rects.reference[f] + r.rects.reference[c] - s[c] - r.rects.popper[f], v = s[c] - r.rects.reference[c], w = ln(i), O = w ? c === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, C = p / 2 - v / 2, b = d[h], S = O - m[f] - d[y], E = O / 2 - m[f] / 2 + C, P = zr(b, E, S), V = c;
    r.modifiersData[n] = (t = {}, t[V] = P, t.centerOffset = P - E, t);
  }
}
function Bd(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || sl(t.elements.popper, o) && (t.elements.arrow = o));
}
const zd = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: jd,
  effect: Bd,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Or(e) {
  return e.split("-")[1];
}
var Wd = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ud(e, t) {
  var r = e.x, n = e.y, o = t.devicePixelRatio || 1;
  return {
    x: xr(r * o) / o || 0,
    y: xr(n * o) / o || 0
  };
}
function za(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, i = e.variation, s = e.offsets, l = e.position, c = e.gpuAcceleration, u = e.adaptive, f = e.roundOffsets, d = e.isFixed, m = s.x, h = m === void 0 ? 0 : m, y = s.y, p = y === void 0 ? 0 : y, v = typeof f == "function" ? f({
    x: h,
    y: p
  }) : {
    x: h,
    y: p
  };
  h = v.x, p = v.y;
  var w = s.hasOwnProperty("x"), O = s.hasOwnProperty("y"), C = Xe, b = Ke, S = window;
  if (u) {
    var E = ln(r), P = "clientHeight", V = "clientWidth";
    if (E === it(r) && (E = Kt(r), zt(E).position !== "static" && l === "absolute" && (P = "scrollHeight", V = "scrollWidth")), E = E, o === Ke || (o === Xe || o === dt) && i === Kr) {
      b = pt;
      var D = d && E === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        E[P]
      );
      p -= D - n.height, p *= c ? 1 : -1;
    }
    if (o === Xe || (o === Ke || o === pt) && i === Kr) {
      C = dt;
      var g = d && E === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        E[V]
      );
      h -= g - n.width, h *= c ? 1 : -1;
    }
  }
  var $ = Object.assign({
    position: l
  }, u && Wd), k = f === !0 ? Ud({
    x: h,
    y: p
  }, it(r)) : {
    x: h,
    y: p
  };
  if (h = k.x, p = k.y, c) {
    var _;
    return Object.assign({}, $, (_ = {}, _[b] = O ? "0" : "", _[C] = w ? "0" : "", _.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + p + "px)" : "translate3d(" + h + "px, " + p + "px, 0)", _));
  }
  return Object.assign({}, $, (t = {}, t[b] = O ? p + "px" : "", t[C] = w ? h + "px" : "", t.transform = "", t));
}
function Hd(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, i = r.adaptive, s = i === void 0 ? !0 : i, l = r.roundOffsets, c = l === void 0 ? !0 : l, u = {
    placement: It(t.placement),
    variation: Or(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, za(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, za(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const qd = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Hd,
  data: {}
};
var Sn = {
  passive: !0
};
function Gd(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, i = o === void 0 ? !0 : o, s = n.resize, l = s === void 0 ? !0 : s, c = it(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(f) {
    f.addEventListener("scroll", r.update, Sn);
  }), l && c.addEventListener("resize", r.update, Sn), function() {
    i && u.forEach(function(f) {
      f.removeEventListener("scroll", r.update, Sn);
    }), l && c.removeEventListener("resize", r.update, Sn);
  };
}
const Yd = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Gd,
  data: {}
};
var Kd = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function In(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Kd[t];
  });
}
var Xd = {
  start: "end",
  end: "start"
};
function Wa(e) {
  return e.replace(/start|end/g, function(t) {
    return Xd[t];
  });
}
function Ni(e) {
  var t = it(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Mi(e) {
  return Er(Kt(e)).left + Ni(e).scrollLeft;
}
function Jd(e, t) {
  var r = it(e), n = Kt(e), o = r.visualViewport, i = n.clientWidth, s = n.clientHeight, l = 0, c = 0;
  if (o) {
    i = o.width, s = o.height;
    var u = al();
    (u || !u && t === "fixed") && (l = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: l + Mi(e),
    y: c
  };
}
function Qd(e) {
  var t, r = Kt(e), n = Ni(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = ir(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = ir(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -n.scrollLeft + Mi(e), c = -n.scrollTop;
  return zt(o || r).direction === "rtl" && (l += ir(r.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function Di(e) {
  var t = zt(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function fl(e) {
  return ["html", "body", "#document"].indexOf(Mt(e)) >= 0 ? e.ownerDocument.body : ft(e) && Di(e) ? e : fl(ao(e));
}
function Wr(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = fl(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = it(n), s = o ? [i].concat(i.visualViewport || [], Di(n) ? n : []) : n, l = t.concat(s);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(Wr(ao(s)))
  );
}
function ei(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Zd(e, t) {
  var r = Er(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Ua(e, t, r) {
  return t === ol ? ei(Jd(e, r)) : lr(t) ? Zd(t, r) : ei(Qd(Kt(e)));
}
function em(e) {
  var t = Wr(ao(e)), r = ["absolute", "fixed"].indexOf(zt(e).position) >= 0, n = r && ft(e) ? ln(e) : e;
  return lr(n) ? t.filter(function(o) {
    return lr(o) && sl(o, n) && Mt(o) !== "body";
  }) : [];
}
function tm(e, t, r, n) {
  var o = t === "clippingParents" ? em(e) : [].concat(t), i = [].concat(o, [r]), s = i[0], l = i.reduce(function(c, u) {
    var f = Ua(e, u, n);
    return c.top = ir(f.top, c.top), c.right = Fn(f.right, c.right), c.bottom = Fn(f.bottom, c.bottom), c.left = ir(f.left, c.left), c;
  }, Ua(e, s, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function pl(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? It(n) : null, i = n ? Or(n) : null, s = t.x + t.width / 2 - r.width / 2, l = t.y + t.height / 2 - r.height / 2, c;
  switch (o) {
    case Ke:
      c = {
        x: s,
        y: t.y - r.height
      };
      break;
    case pt:
      c = {
        x: s,
        y: t.y + t.height
      };
      break;
    case dt:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Xe:
      c = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? Ai(o) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (i) {
      case wr:
        c[u] = c[u] - (t[f] / 2 - r[f] / 2);
        break;
      case Kr:
        c[u] = c[u] + (t[f] / 2 - r[f] / 2);
        break;
    }
  }
  return c;
}
function Xr(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, i = r.strategy, s = i === void 0 ? e.strategy : i, l = r.boundary, c = l === void 0 ? Sd : l, u = r.rootBoundary, f = u === void 0 ? ol : u, d = r.elementContext, m = d === void 0 ? _r : d, h = r.altBoundary, y = h === void 0 ? !1 : h, p = r.padding, v = p === void 0 ? 0 : p, w = cl(typeof v != "number" ? v : ul(v, sn)), O = m === _r ? wd : _r, C = e.rects.popper, b = e.elements[y ? O : m], S = tm(lr(b) ? b : b.contextElement || Kt(e.elements.popper), c, f, s), E = Er(e.elements.reference), P = pl({
    reference: E,
    element: C,
    placement: o
  }), V = ei(Object.assign({}, C, P)), D = m === _r ? V : E, g = {
    top: S.top - D.top + w.top,
    bottom: D.bottom - S.bottom + w.bottom,
    left: S.left - D.left + w.left,
    right: D.right - S.right + w.right
  }, $ = e.modifiersData.offset;
  if (m === _r && $) {
    var k = $[o];
    Object.keys(g).forEach(function(_) {
      var G = [dt, pt].indexOf(_) >= 0 ? 1 : -1, te = [Ke, pt].indexOf(_) >= 0 ? "y" : "x";
      g[_] += k[te] * G;
    });
  }
  return g;
}
function rm(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, i = r.rootBoundary, s = r.padding, l = r.flipVariations, c = r.allowedAutoPlacements, u = c === void 0 ? il : c, f = Or(n), d = f ? l ? ja : ja.filter(function(y) {
    return Or(y) === f;
  }) : sn, m = d.filter(function(y) {
    return u.indexOf(y) >= 0;
  });
  m.length === 0 && (m = d);
  var h = m.reduce(function(y, p) {
    return y[p] = Xr(e, {
      placement: p,
      boundary: o,
      rootBoundary: i,
      padding: s
    })[It(p)], y;
  }, {});
  return Object.keys(h).sort(function(y, p) {
    return h[y] - h[p];
  });
}
function nm(e) {
  if (It(e) === $i)
    return [];
  var t = In(e);
  return [Wa(e), t, Wa(t)];
}
function om(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, i = o === void 0 ? !0 : o, s = r.altAxis, l = s === void 0 ? !0 : s, c = r.fallbackPlacements, u = r.padding, f = r.boundary, d = r.rootBoundary, m = r.altBoundary, h = r.flipVariations, y = h === void 0 ? !0 : h, p = r.allowedAutoPlacements, v = t.options.placement, w = It(v), O = w === v, C = c || (O || !y ? [In(v)] : nm(v)), b = [v].concat(C).reduce(function(j, z) {
      return j.concat(It(z) === $i ? rm(t, {
        placement: z,
        boundary: f,
        rootBoundary: d,
        padding: u,
        flipVariations: y,
        allowedAutoPlacements: p
      }) : z);
    }, []), S = t.rects.reference, E = t.rects.popper, P = /* @__PURE__ */ new Map(), V = !0, D = b[0], g = 0; g < b.length; g++) {
      var $ = b[g], k = It($), _ = Or($) === wr, G = [Ke, pt].indexOf(k) >= 0, te = G ? "width" : "height", Y = Xr(t, {
        placement: $,
        boundary: f,
        rootBoundary: d,
        altBoundary: m,
        padding: u
      }), Z = G ? _ ? dt : Xe : _ ? pt : Ke;
      S[te] > E[te] && (Z = In(Z));
      var pe = In(Z), B = [];
      if (i && B.push(Y[k] <= 0), l && B.push(Y[Z] <= 0, Y[pe] <= 0), B.every(function(j) {
        return j;
      })) {
        D = $, V = !1;
        break;
      }
      P.set($, B);
    }
    if (V)
      for (var A = y ? 3 : 1, M = function(z) {
        var J = b.find(function(X) {
          var L = P.get(X);
          if (L)
            return L.slice(0, z).every(function(q) {
              return q;
            });
        });
        if (J)
          return D = J, "break";
      }, H = A; H > 0; H--) {
        var K = M(H);
        if (K === "break") break;
      }
    t.placement !== D && (t.modifiersData[n]._skip = !0, t.placement = D, t.reset = !0);
  }
}
const im = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: om,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ha(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function qa(e) {
  return [Ke, dt, pt, Xe].some(function(t) {
    return e[t] >= 0;
  });
}
function am(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, s = Xr(t, {
    elementContext: "reference"
  }), l = Xr(t, {
    altBoundary: !0
  }), c = Ha(s, n), u = Ha(l, o, i), f = qa(c), d = qa(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: u,
    isReferenceHidden: f,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": d
  });
}
const sm = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: am
};
function lm(e, t, r) {
  var n = It(e), o = [Xe, Ke].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, s = i[0], l = i[1];
  return s = s || 0, l = (l || 0) * o, [Xe, dt].indexOf(n) >= 0 ? {
    x: l,
    y: s
  } : {
    x: s,
    y: l
  };
}
function cm(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, i = o === void 0 ? [0, 0] : o, s = il.reduce(function(f, d) {
    return f[d] = lm(d, t.rects, i), f;
  }, {}), l = s[t.placement], c = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = s;
}
const um = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: cm
};
function fm(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = pl({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const pm = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: fm,
  data: {}
};
function dm(e) {
  return e === "x" ? "y" : "x";
}
function mm(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, i = o === void 0 ? !0 : o, s = r.altAxis, l = s === void 0 ? !1 : s, c = r.boundary, u = r.rootBoundary, f = r.altBoundary, d = r.padding, m = r.tether, h = m === void 0 ? !0 : m, y = r.tetherOffset, p = y === void 0 ? 0 : y, v = Xr(t, {
    boundary: c,
    rootBoundary: u,
    padding: d,
    altBoundary: f
  }), w = It(t.placement), O = Or(t.placement), C = !O, b = Ai(w), S = dm(b), E = t.modifiersData.popperOffsets, P = t.rects.reference, V = t.rects.popper, D = typeof p == "function" ? p(Object.assign({}, t.rects, {
    placement: t.placement
  })) : p, g = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), $ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, k = {
    x: 0,
    y: 0
  };
  if (E) {
    if (i) {
      var _, G = b === "y" ? Ke : Xe, te = b === "y" ? pt : dt, Y = b === "y" ? "height" : "width", Z = E[b], pe = Z + v[G], B = Z - v[te], A = h ? -V[Y] / 2 : 0, M = O === wr ? P[Y] : V[Y], H = O === wr ? -V[Y] : -P[Y], K = t.elements.arrow, j = h && K ? ki(K) : {
        width: 0,
        height: 0
      }, z = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ll(), J = z[G], X = z[te], L = zr(0, P[Y], j[Y]), q = C ? P[Y] / 2 - A - L - J - g.mainAxis : M - L - J - g.mainAxis, re = C ? -P[Y] / 2 + A + L + X + g.mainAxis : H + L + X + g.mainAxis, Te = t.elements.arrow && ln(t.elements.arrow), N = Te ? b === "y" ? Te.clientTop || 0 : Te.clientLeft || 0 : 0, Re = (_ = $ == null ? void 0 : $[b]) != null ? _ : 0, ae = Z + q - Re - N, ue = Z + re - Re, Qe = zr(h ? Fn(pe, ae) : pe, Z, h ? ir(B, ue) : B);
      E[b] = Qe, k[b] = Qe - Z;
    }
    if (l) {
      var U, Le = b === "x" ? Ke : Xe, fe = b === "x" ? pt : dt, De = E[S], Be = S === "y" ? "height" : "width", ee = De + v[Le], Ze = De - v[fe], $e = [Ke, Xe].indexOf(w) !== -1, Ct = (U = $ == null ? void 0 : $[S]) != null ? U : 0, Dt = $e ? ee : De - P[Be] - V[Be] - Ct + g.altAxis, at = $e ? De + P[Be] + V[Be] - Ct - g.altAxis : Ze, St = h && $e ? Vd(Dt, De, at) : zr(h ? Dt : ee, De, h ? at : Ze);
      E[S] = St, k[S] = St - De;
    }
    t.modifiersData[n] = k;
  }
}
const gm = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: mm,
  requiresIfExists: ["offset"]
};
function hm(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function ym(e) {
  return e === it(e) || !ft(e) ? Ni(e) : hm(e);
}
function bm(e) {
  var t = e.getBoundingClientRect(), r = xr(t.width) / e.offsetWidth || 1, n = xr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function vm(e, t, r) {
  r === void 0 && (r = !1);
  var n = ft(t), o = ft(t) && bm(t), i = Kt(t), s = Er(e, o, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Mt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Di(i)) && (l = ym(t)), ft(t) ? (c = Er(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = Mi(i))), {
    x: s.left + l.scrollLeft - c.x,
    y: s.top + l.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function Cm(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    r.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(l) {
      if (!r.has(l)) {
        var c = t.get(l);
        c && o(c);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || o(i);
  }), n;
}
function Sm(e) {
  var t = Cm(e);
  return Ad.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function wm(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function xm(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Ga = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ya() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Em(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, i = o === void 0 ? Ga : o;
  return function(l, c, u) {
    u === void 0 && (u = i);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ga, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, d = [], m = !1, h = {
      state: f,
      setOptions: function(w) {
        var O = typeof w == "function" ? w(f.options) : w;
        p(), f.options = Object.assign({}, i, f.options, O), f.scrollParents = {
          reference: lr(l) ? Wr(l) : l.contextElement ? Wr(l.contextElement) : [],
          popper: Wr(c)
        };
        var C = Sm(xm([].concat(n, f.options.modifiers)));
        return f.orderedModifiers = C.filter(function(b) {
          return b.enabled;
        }), y(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var w = f.elements, O = w.reference, C = w.popper;
          if (Ya(O, C)) {
            f.rects = {
              reference: vm(O, ln(C), f.options.strategy === "fixed"),
              popper: ki(C)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(g) {
              return f.modifiersData[g.name] = Object.assign({}, g.data);
            });
            for (var b = 0; b < f.orderedModifiers.length; b++) {
              if (f.reset === !0) {
                f.reset = !1, b = -1;
                continue;
              }
              var S = f.orderedModifiers[b], E = S.fn, P = S.options, V = P === void 0 ? {} : P, D = S.name;
              typeof E == "function" && (f = E({
                state: f,
                options: V,
                name: D,
                instance: h
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: wm(function() {
        return new Promise(function(v) {
          h.forceUpdate(), v(f);
        });
      }),
      destroy: function() {
        p(), m = !0;
      }
    };
    if (!Ya(l, c))
      return h;
    h.setOptions(u).then(function(v) {
      !m && u.onFirstUpdate && u.onFirstUpdate(v);
    });
    function y() {
      f.orderedModifiers.forEach(function(v) {
        var w = v.name, O = v.options, C = O === void 0 ? {} : O, b = v.effect;
        if (typeof b == "function") {
          var S = b({
            state: f,
            name: w,
            instance: h,
            options: C
          }), E = function() {
          };
          d.push(S || E);
        }
      });
    }
    function p() {
      d.forEach(function(v) {
        return v();
      }), d = [];
    }
    return h;
  };
}
var Om = [Yd, pm, qd, Dd, um, im, gm, zd, sm], Tm = /* @__PURE__ */ Em({
  defaultModifiers: Om
});
function Rm(e) {
  return typeof e == "function" ? e() : e;
}
const Vn = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    children: n,
    container: o,
    disablePortal: i = !1
  } = t, [s, l] = x.useState(null), c = Nt(/* @__PURE__ */ x.isValidElement(n) ? Vf(n) : null, r);
  if (At(() => {
    i || l(Rm(o) || document.body);
  }, [o, i]), At(() => {
    if (s && !i)
      return Ho(r, s), () => {
        Ho(r, null);
      };
  }, [r, s, i]), i) {
    if (/* @__PURE__ */ x.isValidElement(n)) {
      const u = {
        ref: c
      };
      return /* @__PURE__ */ x.cloneElement(n, u);
    }
    return n;
  }
  return s && /* @__PURE__ */ Kl.createPortal(n, s);
});
process.env.NODE_ENV !== "production" && (Vn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: a.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: a.oneOfType([Yr, a.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: a.bool
});
process.env.NODE_ENV !== "production" && (Vn.propTypes = Rf(Vn.propTypes));
function Pm(e) {
  return He("MuiPopper", e);
}
Ge("MuiPopper", ["root"]);
function $m(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Ln(e) {
  return typeof e == "function" ? e() : e;
}
function so(e) {
  return e.nodeType !== void 0;
}
function Im(e) {
  return !so(e);
}
const km = (e) => {
  const {
    classes: t
  } = e;
  return gt({
    root: ["root"]
  }, Pm, t);
}, Am = {}, Nm = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var te;
  const {
    anchorEl: n,
    children: o,
    direction: i,
    disablePortal: s,
    modifiers: l,
    open: c,
    placement: u,
    popperOptions: f,
    popperRef: d,
    slotProps: m = {},
    slots: h = {},
    TransitionProps: y,
    // @ts-ignore internal logic
    ownerState: p,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...v
  } = t, w = x.useRef(null), O = Nt(w, r), C = x.useRef(null), b = Nt(C, d), S = x.useRef(b);
  At(() => {
    S.current = b;
  }, [b]), x.useImperativeHandle(d, () => C.current, []);
  const E = $m(u, i), [P, V] = x.useState(E), [D, g] = x.useState(Ln(n));
  x.useEffect(() => {
    C.current && C.current.forceUpdate();
  }), x.useEffect(() => {
    n && g(Ln(n));
  }, [n]), At(() => {
    if (!D || !c)
      return;
    const Y = (B) => {
      V(B.placement);
    };
    if (process.env.NODE_ENV !== "production" && D && so(D) && D.nodeType === 1) {
      const B = D.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && B.top === 0 && B.left === 0 && B.right === 0 && B.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let Z = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: B
      }) => {
        Y(B);
      }
    }];
    l != null && (Z = Z.concat(l)), f && f.modifiers != null && (Z = Z.concat(f.modifiers));
    const pe = Tm(D, w.current, {
      placement: E,
      ...f,
      modifiers: Z
    });
    return S.current(pe), () => {
      pe.destroy(), S.current(null);
    };
  }, [D, s, l, c, f, E]);
  const $ = {
    placement: P
  };
  y !== null && ($.TransitionProps = y);
  const k = km(t), _ = (te = h.root) != null ? te : "div", G = Ff({
    elementType: _,
    externalSlotProps: m.root,
    externalForwardedProps: v,
    additionalProps: {
      role: "tooltip",
      ref: O
    },
    ownerState: t,
    className: k.root
  });
  return /* @__PURE__ */ W(_, {
    ...G,
    children: typeof o == "function" ? o($) : o
  });
}), dl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    anchorEl: n,
    children: o,
    container: i,
    direction: s = "ltr",
    disablePortal: l = !1,
    keepMounted: c = !1,
    modifiers: u,
    open: f,
    placement: d = "bottom",
    popperOptions: m = Am,
    popperRef: h,
    style: y,
    transition: p = !1,
    slotProps: v = {},
    slots: w = {},
    ...O
  } = t, [C, b] = x.useState(!0), S = () => {
    b(!1);
  }, E = () => {
    b(!0);
  };
  if (!c && !f && (!p || C))
    return null;
  let P;
  if (i)
    P = i;
  else if (n) {
    const g = Ln(n);
    P = g && so(g) ? Uo(g).body : Uo(null).body;
  }
  const V = !f && c && (!p || C) ? "none" : void 0, D = p ? {
    in: f,
    onEnter: S,
    onExited: E
  } : void 0;
  return /* @__PURE__ */ W(Vn, {
    disablePortal: l,
    container: P,
    children: /* @__PURE__ */ W(Nm, {
      anchorEl: n,
      direction: s,
      disablePortal: l,
      modifiers: u,
      ref: r,
      open: p ? !C : f,
      placement: d,
      popperOptions: m,
      popperRef: h,
      slotProps: v,
      slots: w,
      ...O,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: V,
        ...y
      },
      TransitionProps: D,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (dl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: ar(a.oneOfType([Yr, a.object, a.func]), (e) => {
    if (e.open) {
      const t = Ln(e.anchorEl);
      if (t && so(t) && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || Im(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: a.oneOfType([a.node, a.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: a.oneOfType([Yr, a.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: a.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: a.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: a.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: a.arrayOf(a.shape({
    data: a.object,
    effect: a.func,
    enabled: a.bool,
    fn: a.func,
    name: a.any,
    options: a.object,
    phase: a.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: a.arrayOf(a.string),
    requiresIfExists: a.arrayOf(a.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: a.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: a.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: a.shape({
    modifiers: a.array,
    onFirstUpdate: a.func,
    placement: a.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: a.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: oo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: a.shape({
    root: a.oneOfType([a.func, a.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: a.shape({
    root: a.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: a.bool
});
const Mm = be(dl, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), _i = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var P;
  const n = jf(), o = vt({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: s,
    components: l,
    componentsProps: c,
    container: u,
    disablePortal: f,
    keepMounted: d,
    modifiers: m,
    open: h,
    placement: y,
    popperOptions: p,
    popperRef: v,
    transition: w,
    slots: O,
    slotProps: C,
    ...b
  } = o, S = (P = O == null ? void 0 : O.root) != null ? P : l == null ? void 0 : l.Root, E = {
    anchorEl: i,
    container: u,
    disablePortal: f,
    keepMounted: d,
    modifiers: m,
    open: h,
    placement: y,
    popperOptions: p,
    popperRef: v,
    transition: w,
    ...b
  };
  return /* @__PURE__ */ W(Mm, {
    as: s,
    direction: n ? "rtl" : "ltr",
    slots: {
      root: S
    },
    slotProps: C != null ? C : c,
    ...E,
    ref: r
  });
});
process.env.NODE_ENV !== "production" && (_i.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: a.oneOfType([Yr, a.object, a.func]),
  /**
   * Popper render function or node.
   */
  children: a.oneOfType([a.node, a.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: a.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: a.shape({
    Root: a.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: a.shape({
    root: a.oneOfType([a.func, a.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: a.oneOfType([Yr, a.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: a.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: a.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: a.arrayOf(a.shape({
    data: a.object,
    effect: a.func,
    enabled: a.bool,
    fn: a.func,
    name: a.any,
    options: a.object,
    phase: a.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: a.arrayOf(a.string),
    requiresIfExists: a.arrayOf(a.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: a.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: a.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: a.shape({
    modifiers: a.array,
    onFirstUpdate: a.func,
    placement: a.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: a.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: oo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: a.shape({
    root: a.oneOfType([a.func, a.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: a.shape({
    root: a.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: a.bool
});
function Dm(e) {
  return He("MuiListSubheader", e);
}
Ge("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const _m = (e) => {
  const {
    classes: t,
    color: r,
    disableGutters: n,
    inset: o,
    disableSticky: i
  } = e, s = {
    root: ["root", r !== "default" && `color${Q(r)}`, !n && "gutters", o && "inset", !i && "sticky"]
  };
  return gt(s, Dm, t);
}, Fm = be("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "default" && t[`color${Q(r.color)}`], !r.disableGutters && t.gutters, r.inset && t.inset, !r.disableSticky && t.sticky];
  }
})(Ue(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), jn = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = vt({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: o,
    color: i = "default",
    component: s = "li",
    disableGutters: l = !1,
    disableSticky: c = !1,
    inset: u = !1,
    ...f
  } = n, d = {
    ...n,
    color: i,
    component: s,
    disableGutters: l,
    disableSticky: c,
    inset: u
  }, m = _m(d);
  return /* @__PURE__ */ W(Fm, {
    as: s,
    className: we(m.root, o),
    ref: r,
    ownerState: d,
    ...f
  });
});
jn && (jn.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (jn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: a.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: a.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: a.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: a.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: a.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: a.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object])
});
const Vm = Ei(/* @__PURE__ */ W("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function Lm(e) {
  return He("MuiChip", e);
}
const se = Ge("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), jm = (e) => {
  const {
    classes: t,
    disabled: r,
    size: n,
    color: o,
    iconColor: i,
    onDelete: s,
    clickable: l,
    variant: c
  } = e, u = {
    root: ["root", c, r && "disabled", `size${Q(n)}`, `color${Q(o)}`, l && "clickable", l && `clickableColor${Q(o)}`, s && "deletable", s && `deletableColor${Q(o)}`, `${c}${Q(o)}`],
    label: ["label", `label${Q(n)}`],
    avatar: ["avatar", `avatar${Q(n)}`, `avatarColor${Q(o)}`],
    icon: ["icon", `icon${Q(n)}`, `iconColor${Q(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Q(n)}`, `deleteIconColor${Q(o)}`, `deleteIcon${Q(c)}Color${Q(o)}`]
  };
  return gt(u, Lm, t);
}, Bm = be("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      color: n,
      iconColor: o,
      clickable: i,
      onDelete: s,
      size: l,
      variant: c
    } = r;
    return [{
      [`& .${se.avatar}`]: t.avatar
    }, {
      [`& .${se.avatar}`]: t[`avatar${Q(l)}`]
    }, {
      [`& .${se.avatar}`]: t[`avatarColor${Q(n)}`]
    }, {
      [`& .${se.icon}`]: t.icon
    }, {
      [`& .${se.icon}`]: t[`icon${Q(l)}`]
    }, {
      [`& .${se.icon}`]: t[`iconColor${Q(o)}`]
    }, {
      [`& .${se.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${se.deleteIcon}`]: t[`deleteIcon${Q(l)}`]
    }, {
      [`& .${se.deleteIcon}`]: t[`deleteIconColor${Q(n)}`]
    }, {
      [`& .${se.deleteIcon}`]: t[`deleteIcon${Q(c)}Color${Q(n)}`]
    }, t.root, t[`size${Q(l)}`], t[`color${Q(n)}`], i && t.clickable, i && n !== "default" && t[`clickableColor${Q(n)})`], s && t.deletable, s && n !== "default" && t[`deletableColor${Q(n)}`], t[c], t[`${c}${Q(n)}`]];
  }
})(Ue(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${se.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${se.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${se.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${se.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${se.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${se.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${se.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Ve(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Ve(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${se.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${se.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(or(["contrastText"])).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        backgroundColor: (e.vars || e).palette[r].main,
        color: (e.vars || e).palette[r].contrastText,
        [`& .${se.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].contrastTextChannel} / 0.7)` : Ve(e.palette[r].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].contrastText
          }
        }
      }
    })), {
      props: (r) => r.iconColor === r.color,
      style: {
        [`& .${se.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (r) => r.iconColor === r.color && r.color !== "default",
      style: {
        [`& .${se.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${se.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Ve(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(or(["dark"])).map(([r]) => ({
      props: {
        color: r,
        onDelete: !0
      },
      style: {
        [`&.${se.focusVisible}`]: {
          background: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Ve(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${se.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Ve(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(or(["dark"])).map(([r]) => ({
      props: {
        color: r,
        clickable: !0
      },
      style: {
        [`&:hover, &.${se.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${se.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${se.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${se.avatar}`]: {
          marginLeft: 4
        },
        [`& .${se.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${se.icon}`]: {
          marginLeft: 4
        },
        [`& .${se.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${se.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${se.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(or()).map(([r]) => ({
      props: {
        variant: "outlined",
        color: r
      },
      style: {
        color: (e.vars || e).palette[r].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : Ve(e.palette[r].main, 0.7)}`,
        [`&.${se.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Ve(e.palette[r].main, e.palette.action.hoverOpacity)
        },
        [`&.${se.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Ve(e.palette[r].main, e.palette.action.focusOpacity)
        },
        [`& .${se.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : Ve(e.palette[r].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].main
          }
        }
      }
    }))]
  };
})), zm = be("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      size: n
    } = r;
    return [t.label, t[`label${Q(n)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function Ka(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const ml = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = vt({
    props: t,
    name: "MuiChip"
  }), {
    avatar: o,
    className: i,
    clickable: s,
    color: l = "default",
    component: c,
    deleteIcon: u,
    disabled: f = !1,
    icon: d,
    label: m,
    onClick: h,
    onDelete: y,
    onKeyDown: p,
    onKeyUp: v,
    size: w = "medium",
    variant: O = "filled",
    tabIndex: C,
    skipFocusWhenDisabled: b = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...S
  } = n, E = x.useRef(null), P = Nt(E, r), V = (B) => {
    B.stopPropagation(), y && y(B);
  }, D = (B) => {
    B.currentTarget === B.target && Ka(B) && B.preventDefault(), p && p(B);
  }, g = (B) => {
    B.currentTarget === B.target && y && Ka(B) && y(B), v && v(B);
  }, $ = s !== !1 && h ? !0 : s, k = $ || y ? _n : c || "div", _ = {
    ...n,
    component: k,
    disabled: f,
    size: w,
    color: l,
    iconColor: /* @__PURE__ */ x.isValidElement(d) && d.props.color || l,
    onDelete: !!y,
    clickable: $,
    variant: O
  }, G = jm(_), te = k === _n ? {
    component: c || "div",
    focusVisibleClassName: G.focusVisible,
    ...y && {
      disableRipple: !0
    }
  } : {};
  let Y = null;
  y && (Y = u && /* @__PURE__ */ x.isValidElement(u) ? /* @__PURE__ */ x.cloneElement(u, {
    className: we(u.props.className, G.deleteIcon),
    onClick: V
  }) : /* @__PURE__ */ W(Vm, {
    className: we(G.deleteIcon),
    onClick: V
  }));
  let Z = null;
  o && /* @__PURE__ */ x.isValidElement(o) && (Z = /* @__PURE__ */ x.cloneElement(o, {
    className: we(G.avatar, o.props.className)
  }));
  let pe = null;
  return d && /* @__PURE__ */ x.isValidElement(d) && (pe = /* @__PURE__ */ x.cloneElement(d, {
    className: we(G.icon, d.props.className)
  })), process.env.NODE_ENV !== "production" && Z && pe && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ bt(Bm, {
    as: k,
    className: we(G.root, i),
    disabled: $ && f ? !0 : void 0,
    onClick: h,
    onKeyDown: D,
    onKeyUp: g,
    ref: P,
    tabIndex: b && f ? -1 : C,
    ownerState: _,
    ...te,
    ...S,
    children: [Z || pe, /* @__PURE__ */ W(zm, {
      className: we(G.label),
      ownerState: _,
      children: m
    }), Y]
  });
});
process.env.NODE_ENV !== "production" && (ml.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: a.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: kf,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: a.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: a.oneOfType([a.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), a.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: a.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: a.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * Icon element.
   */
  icon: a.element,
  /**
   * The content of the component.
   */
  label: a.node,
  /**
   * @ignore
   */
  onClick: a.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: a.func,
  /**
   * @ignore
   */
  onKeyDown: a.func,
  /**
   * @ignore
   */
  onKeyUp: a.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: a.oneOfType([a.oneOf(["medium", "small"]), a.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: a.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * @ignore
   */
  tabIndex: a.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: a.oneOfType([a.oneOf(["filled", "outlined"]), a.string])
});
function wn(e) {
  return parseInt(e, 10) || 0;
}
const Wm = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function Um(e) {
  for (const t in e)
    return !1;
  return !0;
}
function Xa(e) {
  return Um(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const gl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    onChange: n,
    maxRows: o,
    minRows: i = 1,
    style: s,
    value: l,
    ...c
  } = t, {
    current: u
  } = x.useRef(l != null), f = x.useRef(null), d = Nt(r, f), m = x.useRef(null), h = x.useRef(null), y = x.useCallback(() => {
    const C = f.current, b = h.current;
    if (!C || !b)
      return;
    const E = Sa(C).getComputedStyle(C);
    if (E.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    b.style.width = E.width, b.value = C.value || t.placeholder || "x", b.value.slice(-1) === `
` && (b.value += " ");
    const P = E.boxSizing, V = wn(E.paddingBottom) + wn(E.paddingTop), D = wn(E.borderBottomWidth) + wn(E.borderTopWidth), g = b.scrollHeight;
    b.value = "x";
    const $ = b.scrollHeight;
    let k = g;
    i && (k = Math.max(Number(i) * $, k)), o && (k = Math.min(Number(o) * $, k)), k = Math.max(k, $);
    const _ = k + (P === "border-box" ? V + D : 0), G = Math.abs(k - g) <= 1;
    return {
      outerHeightStyle: _,
      overflowing: G
    };
  }, [o, i, t.placeholder]), p = Lt(() => {
    const C = f.current, b = y();
    if (!C || !b || Xa(b))
      return !1;
    const S = b.outerHeightStyle;
    return m.current != null && m.current !== S;
  }), v = x.useCallback(() => {
    const C = f.current, b = y();
    if (!C || !b || Xa(b))
      return;
    const S = b.outerHeightStyle;
    m.current !== S && (m.current = S, C.style.height = `${S}px`), C.style.overflow = b.overflowing ? "hidden" : "";
  }, [y]), w = x.useRef(-1);
  At(() => {
    const C = Pf(v), b = f == null ? void 0 : f.current;
    if (!b)
      return;
    const S = Sa(b);
    S.addEventListener("resize", C);
    let E;
    return typeof ResizeObserver != "undefined" && (E = new ResizeObserver(() => {
      p() && (E.unobserve(b), cancelAnimationFrame(w.current), v(), w.current = requestAnimationFrame(() => {
        E.observe(b);
      }));
    }), E.observe(b)), () => {
      C.clear(), cancelAnimationFrame(w.current), S.removeEventListener("resize", C), E && E.disconnect();
    };
  }, [y, v, p]), At(() => {
    v();
  });
  const O = (C) => {
    u || v(), n && n(C);
  };
  return /* @__PURE__ */ bt(x.Fragment, {
    children: [/* @__PURE__ */ W("textarea", {
      value: l,
      onChange: O,
      ref: d,
      rows: i,
      style: s,
      ...c
    }), /* @__PURE__ */ W("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: h,
      tabIndex: -1,
      style: {
        ...Wm.shadow,
        ...s,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (gl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: a.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: a.oneOfType([a.number, a.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: a.oneOfType([a.number, a.string]),
  /**
   * @ignore
   */
  onChange: a.func,
  /**
   * @ignore
   */
  placeholder: a.string,
  /**
   * @ignore
   */
  style: a.object,
  /**
   * @ignore
   */
  value: a.oneOfType([a.arrayOf(a.string), a.number, a.string])
});
function Ja(e) {
  return typeof e == "string";
}
function Hm({
  props: e,
  states: t,
  muiFormControl: r
}) {
  return t.reduce((n, o) => (n[o] = e[o], r && typeof e[o] == "undefined" && (n[o] = r[o]), n), {});
}
const Fi = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fi.displayName = "FormControlContext");
function qm() {
  return x.useContext(Fi);
}
function Qa(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function Gm(e, t = !1) {
  return e && (Qa(e.value) && e.value !== "" || t && Qa(e.defaultValue) && e.defaultValue !== "");
}
function Nh(e) {
  return e.startAdornment;
}
function Ym(e) {
  return He("MuiInputBase", e);
}
const tt = Ge("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var Za;
const Km = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.formControl && t.formControl, r.startAdornment && t.adornedStart, r.endAdornment && t.adornedEnd, r.error && t.error, r.size === "small" && t.sizeSmall, r.multiline && t.multiline, r.color && t[`color${Q(r.color)}`], r.fullWidth && t.fullWidth, r.hiddenLabel && t.hiddenLabel];
}, Xm = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.input, r.size === "small" && t.inputSizeSmall, r.multiline && t.inputMultiline, r.type === "search" && t.inputTypeSearch, r.startAdornment && t.inputAdornedStart, r.endAdornment && t.inputAdornedEnd, r.hiddenLabel && t.inputHiddenLabel];
}, Jm = (e) => {
  const {
    classes: t,
    color: r,
    disabled: n,
    error: o,
    endAdornment: i,
    focused: s,
    formControl: l,
    fullWidth: c,
    hiddenLabel: u,
    multiline: f,
    readOnly: d,
    size: m,
    startAdornment: h,
    type: y
  } = e, p = {
    root: ["root", `color${Q(r)}`, n && "disabled", o && "error", c && "fullWidth", s && "focused", l && "formControl", m && m !== "medium" && `size${Q(m)}`, f && "multiline", h && "adornedStart", i && "adornedEnd", u && "hiddenLabel", d && "readOnly"],
    input: ["input", n && "disabled", y === "search" && "inputTypeSearch", f && "inputMultiline", m === "small" && "inputSizeSmall", u && "inputHiddenLabel", h && "inputAdornedStart", i && "inputAdornedEnd", d && "readOnly"]
  };
  return gt(p, Ym, t);
}, Qm = be("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: Km
})(Ue(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${tt.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: r
    }) => t.multiline && r === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), Zm = be("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Xm
})(Ue(({
  theme: e
}) => {
  const t = e.palette.mode === "light", r = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, n = {
    opacity: "0 !important"
  }, o = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": r,
    "&::-moz-placeholder": r,
    // Firefox 19+
    "&::-ms-input-placeholder": r,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${tt.formControl} &`]: {
      "&::-webkit-input-placeholder": n,
      "&::-moz-placeholder": n,
      // Firefox 19+
      "&::-ms-input-placeholder": n,
      // Edge
      "&:focus::-webkit-input-placeholder": o,
      "&:focus::-moz-placeholder": o,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": o
      // Edge
    },
    [`&.${tt.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: i
      }) => i.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), es = Ip({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), Vi = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var Ye;
  const n = vt({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": o,
    autoComplete: i,
    autoFocus: s,
    className: l,
    color: c,
    components: u = {},
    componentsProps: f = {},
    defaultValue: d,
    disabled: m,
    disableInjectingGlobalStyles: h,
    endAdornment: y,
    error: p,
    fullWidth: v = !1,
    id: w,
    inputComponent: O = "input",
    inputProps: C = {},
    inputRef: b,
    margin: S,
    maxRows: E,
    minRows: P,
    multiline: V = !1,
    name: D,
    onBlur: g,
    onChange: $,
    onClick: k,
    onFocus: _,
    onKeyDown: G,
    onKeyUp: te,
    placeholder: Y,
    readOnly: Z,
    renderSuffix: pe,
    rows: B,
    size: A,
    slotProps: M = {},
    slots: H = {},
    startAdornment: K,
    type: j = "text",
    value: z,
    ...J
  } = n, X = C.value != null ? C.value : z, {
    current: L
  } = x.useRef(X != null), q = x.useRef(), re = x.useCallback((ve) => {
    process.env.NODE_ENV !== "production" && ve && ve.nodeName !== "INPUT" && !ve.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Te = Nt(q, b, C.ref, re), [N, Re] = x.useState(!1), ae = qm();
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (ae)
      return ae.registerEffect();
  }, [ae]);
  const ue = Hm({
    props: n,
    muiFormControl: ae,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  ue.focused = ae ? ae.focused : N, x.useEffect(() => {
    !ae && m && N && (Re(!1), g && g());
  }, [ae, m, N, g]);
  const Qe = ae && ae.onFilled, U = ae && ae.onEmpty, Le = x.useCallback((ve) => {
    Gm(ve) ? Qe && Qe() : U && U();
  }, [Qe, U]);
  At(() => {
    L && Le({
      value: X
    });
  }, [X, Le, L]);
  const fe = (ve) => {
    _ && _(ve), C.onFocus && C.onFocus(ve), ae && ae.onFocus ? ae.onFocus(ve) : Re(!0);
  }, De = (ve) => {
    g && g(ve), C.onBlur && C.onBlur(ve), ae && ae.onBlur ? ae.onBlur(ve) : Re(!1);
  }, Be = (ve, ...wt) => {
    if (!L) {
      const cr = ve.target || q.current;
      if (cr == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : jt(1));
      Le({
        value: cr.value
      });
    }
    C.onChange && C.onChange(ve, ...wt), $ && $(ve, ...wt);
  };
  x.useEffect(() => {
    Le(q.current);
  }, []);
  const ee = (ve) => {
    q.current && ve.currentTarget === ve.target && q.current.focus(), k && k(ve);
  };
  let Ze = O, $e = C;
  V && Ze === "input" && (B ? (process.env.NODE_ENV !== "production" && (P || E) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), $e = {
    type: void 0,
    minRows: B,
    maxRows: B,
    ...$e
  }) : $e = {
    type: void 0,
    maxRows: E,
    minRows: P,
    ...$e
  }, Ze = gl);
  const Ct = (ve) => {
    Le(ve.animationName === "mui-auto-fill-cancel" ? q.current : {
      value: "x"
    });
  };
  x.useEffect(() => {
    ae && ae.setAdornedStart(!!K);
  }, [ae, K]);
  const Dt = {
    ...n,
    color: ue.color || "primary",
    disabled: ue.disabled,
    endAdornment: y,
    error: ue.error,
    focused: ue.focused,
    formControl: ae,
    fullWidth: v,
    hiddenLabel: ue.hiddenLabel,
    multiline: V,
    size: ue.size,
    startAdornment: K,
    type: j
  }, at = Jm(Dt), St = H.root || u.Root || Qm, _e = M.root || f.root || {}, Oe = H.input || u.Input || Zm;
  return $e = {
    ...$e,
    ...(Ye = M.input) != null ? Ye : f.input
  }, /* @__PURE__ */ bt(x.Fragment, {
    children: [!h && typeof es == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (Za || (Za = /* @__PURE__ */ W(es, {}))), /* @__PURE__ */ bt(St, {
      ..._e,
      ref: r,
      onClick: ee,
      ...J,
      ...!Ja(St) && {
        ownerState: {
          ...Dt,
          ..._e.ownerState
        }
      },
      className: we(at.root, _e.className, l, Z && "MuiInputBase-readOnly"),
      children: [K, /* @__PURE__ */ W(Fi.Provider, {
        value: null,
        children: /* @__PURE__ */ W(Oe, {
          "aria-invalid": ue.error,
          "aria-describedby": o,
          autoComplete: i,
          autoFocus: s,
          defaultValue: d,
          disabled: ue.disabled,
          id: w,
          onAnimationStart: Ct,
          name: D,
          placeholder: Y,
          readOnly: Z,
          required: ue.required,
          rows: B,
          value: X,
          onKeyDown: G,
          onKeyUp: te,
          type: j,
          ...$e,
          ...!Ja(Oe) && {
            as: Ze,
            ownerState: {
              ...Dt,
              ...$e.ownerState
            }
          },
          ref: Te,
          className: we(at.input, $e.className, Z && "MuiInputBase-readOnly"),
          onBlur: De,
          onChange: Be,
          onFocus: fe
        })
      }), y, pe ? pe({
        ...ue,
        startAdornment: K
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (Vi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": a.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: a.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: a.oneOfType([a.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), a.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: a.shape({
    Input: a.elementType,
    Root: a.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: a.shape({
    input: a.object,
    root: a.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: a.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: a.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: a.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: a.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: a.bool,
  /**
   * The id of the `input` element.
   */
  id: a.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: zs,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: a.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: oo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: a.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: a.oneOfType([a.number, a.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: a.oneOfType([a.number, a.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: a.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: a.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: a.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: a.func,
  /**
   * @ignore
   */
  onClick: a.func,
  /**
   * @ignore
   */
  onFocus: a.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: a.func,
  /**
   * @ignore
   */
  onKeyDown: a.func,
  /**
   * @ignore
   */
  onKeyUp: a.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: a.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: a.bool,
  /**
   * @ignore
   */
  renderSuffix: a.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: a.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: a.oneOfType([a.number, a.string]),
  /**
   * The size of the component.
   */
  size: a.oneOfType([a.oneOf(["medium", "small"]), a.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: a.shape({
    input: a.object,
    root: a.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: a.shape({
    input: a.elementType,
    root: a.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: a.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: a.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: a.any
});
function Mh(e) {
  return He("MuiInput", e);
}
const Mo = {
  ...tt,
  ...Ge("MuiInput", ["root", "underline", "input"])
};
function Dh(e) {
  return He("MuiOutlinedInput", e);
}
const ts = {
  ...tt,
  ...Ge("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function _h(e) {
  return He("MuiFilledInput", e);
}
const hr = {
  ...tt,
  ...Ge("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, eg = Ei(/* @__PURE__ */ W("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function tg(e) {
  return He("MuiAutocomplete", e);
}
const oe = Ge("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var rs, ns;
const rg = (e) => {
  const {
    classes: t,
    disablePortal: r,
    expanded: n,
    focused: o,
    fullWidth: i,
    hasClearIcon: s,
    hasPopupIcon: l,
    inputFocused: c,
    popupOpen: u,
    size: f
  } = e, d = {
    root: ["root", n && "expanded", o && "focused", i && "fullWidth", s && "hasClearIcon", l && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", c && "inputFocused"],
    tag: ["tag", `tagSize${Q(f)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", u && "popupIndicatorOpen"],
    popper: ["popper", r && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return gt(d, tg, t);
}, ng = be("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      fullWidth: n,
      hasClearIcon: o,
      hasPopupIcon: i,
      inputFocused: s,
      size: l
    } = r;
    return [{
      [`& .${oe.tag}`]: t.tag
    }, {
      [`& .${oe.tag}`]: t[`tagSize${Q(l)}`]
    }, {
      [`& .${oe.inputRoot}`]: t.inputRoot
    }, {
      [`& .${oe.input}`]: t.input
    }, {
      [`& .${oe.input}`]: s && t.inputFocused
    }, t.root, n && t.fullWidth, i && t.hasPopupIcon, o && t.hasClearIcon];
  }
})({
  [`&.${oe.focused} .${oe.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${oe.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${oe.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${oe.inputRoot}`]: {
    [`.${oe.hasPopupIcon}&, .${oe.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${oe.hasPopupIcon}.${oe.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${oe.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Mo.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Mo.root}.${tt.sizeSmall}`]: {
    [`& .${Mo.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${ts.root}`]: {
    padding: 9,
    [`.${oe.hasPopupIcon}&, .${oe.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${oe.hasPopupIcon}.${oe.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${oe.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${oe.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${ts.root}.${tt.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${oe.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${hr.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${oe.hasPopupIcon}&, .${oe.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${oe.hasPopupIcon}.${oe.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${hr.input}`]: {
      padding: "7px 4px"
    },
    [`& .${oe.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${hr.root}.${tt.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${hr.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${tt.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${hr.root}.${tt.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${oe.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${hr.root}.${tt.hiddenLabel}.${tt.sizeSmall}`]: {
    [`& .${oe.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${oe.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${oe.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${oe.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${oe.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), og = be("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), ig = be(Pi, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), ag = be(Pi, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.popupIndicator, r.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), sg = be(_i, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${oe.option}`]: t.option
    }, t.popper, r.disablePortal && t.popperDisablePortal];
  }
})(Ue(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), lg = be(Ri, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(Ue(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), cg = be("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(Ue(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), ug = be("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(Ue(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), fg = be("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(Ue(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${oe.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${oe.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${oe.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Ve(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${oe.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Ve(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${oe.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Ve(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), pg = be(jn, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(Ue(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), dg = be("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${oe.option}`]: {
    paddingLeft: 24
  }
}), hl = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = vt({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: o = !1,
    autoHighlight: i = !1,
    autoSelect: s = !1,
    blurOnSelect: l = !1,
    ChipProps: c,
    className: u,
    clearIcon: f = rs || (rs = /* @__PURE__ */ W(gd, {
      fontSize: "small"
    })),
    clearOnBlur: d = !n.freeSolo,
    clearOnEscape: m = !1,
    clearText: h = "Clear",
    closeText: y = "Close",
    componentsProps: p,
    defaultValue: v = n.multiple ? [] : null,
    disableClearable: w = !1,
    disableCloseOnSelect: O = !1,
    disabled: C = !1,
    disabledItemsFocusable: b = !1,
    disableListWrap: S = !1,
    disablePortal: E = !1,
    filterOptions: P,
    filterSelectedOptions: V = !1,
    forcePopupIcon: D = "auto",
    freeSolo: g = !1,
    fullWidth: $ = !1,
    getLimitTagsText: k = (de) => `+${de}`,
    getOptionDisabled: _,
    getOptionKey: G,
    getOptionLabel: te,
    isOptionEqualToValue: Y,
    groupBy: Z,
    handleHomeEndKeys: pe = !n.freeSolo,
    id: B,
    includeInputInList: A = !1,
    inputValue: M,
    limitTags: H = -1,
    ListboxComponent: K,
    ListboxProps: j,
    loading: z = !1,
    loadingText: J = "Loading…",
    multiple: X = !1,
    noOptionsText: L = "No options",
    onChange: q,
    onClose: re,
    onHighlightChange: Te,
    onInputChange: N,
    onOpen: Re,
    open: ae,
    openOnFocus: ue = !1,
    openText: Qe = "Open",
    options: U,
    PaperComponent: Le,
    PopperComponent: fe,
    popupIcon: De = ns || (ns = /* @__PURE__ */ W(eg, {})),
    readOnly: Be = !1,
    renderGroup: ee,
    renderInput: Ze,
    renderOption: $e,
    renderTags: Ct,
    selectOnFocus: Dt = !n.freeSolo,
    size: at = "medium",
    slots: St = {},
    slotProps: _e = {},
    value: Oe,
    ...Ye
  } = n, {
    getRootProps: ve,
    getInputProps: wt,
    getInputLabelProps: cr,
    getPopupIndicatorProps: _t,
    getClearProps: ht,
    getTagProps: fo,
    getListboxProps: Rr,
    getOptionProps: po,
    value: yt,
    dirty: Jt,
    expanded: Wt,
    id: ur,
    popupOpen: xt,
    focused: un,
    focusedTag: fn,
    anchorEl: Qt,
    setAnchorEl: mo,
    inputValue: go,
    groupedOptions: Zt
  } = Cd({
    ...n,
    componentName: "Autocomplete"
  }), Pr = !w && !C && Jt && !Be, $r = (!g || D === !0) && D !== !1, {
    onMouseDown: ho
  } = wt(), {
    ref: yo,
    ...bo
  } = Rr(), Ir = te || ((de) => {
    var et;
    return (et = de.label) != null ? et : de;
  }), ze = {
    ...n,
    disablePortal: E,
    expanded: Wt,
    focused: un,
    fullWidth: $,
    getOptionLabel: Ir,
    hasClearIcon: Pr,
    hasPopupIcon: $r,
    inputFocused: fn === -1,
    popupOpen: xt,
    size: at
  }, Fe = rg(ze), Et = {
    slots: {
      paper: Le,
      popper: fe,
      ...St
    },
    slotProps: {
      chip: c,
      listbox: j,
      ...p,
      ..._e
    }
  }, [pn, I] = No("listbox", {
    elementType: fg,
    externalForwardedProps: Et,
    ownerState: ze,
    className: Fe.listbox,
    additionalProps: bo,
    ref: yo
  }), [T, F] = No("paper", {
    elementType: Ri,
    externalForwardedProps: Et,
    ownerState: ze,
    className: Fe.paper
  }), [ne, ie] = No("popper", {
    elementType: _i,
    externalForwardedProps: Et,
    ownerState: ze,
    className: Fe.popper,
    additionalProps: {
      disablePortal: E,
      style: {
        width: Qt ? Qt.clientWidth : null
      },
      role: "presentation",
      anchorEl: Qt,
      open: xt
    }
  });
  let le;
  if (X && yt.length > 0) {
    const de = (et) => ({
      className: Fe.tag,
      disabled: C,
      ...fo(et)
    });
    Ct ? le = Ct(yt, de, ze) : le = yt.map((et, Ut) => {
      const {
        key: Ar,
        ...Wl
      } = de({
        index: Ut
      });
      return /* @__PURE__ */ W(ml, {
        label: Ir(et),
        size: at,
        ...Wl,
        ...Et.slotProps.chip
      }, Ar);
    });
  }
  if (H > -1 && Array.isArray(le)) {
    const de = le.length - H;
    !un && de > 0 && (le = le.splice(0, H), le.push(/* @__PURE__ */ W("span", {
      className: Fe.tag,
      children: k(de)
    }, le.length)));
  }
  const qe = ee || ((de) => /* @__PURE__ */ bt("li", {
    children: [/* @__PURE__ */ W(pg, {
      className: Fe.groupLabel,
      ownerState: ze,
      component: "div",
      children: de.group
    }), /* @__PURE__ */ W(dg, {
      className: Fe.groupUl,
      ownerState: ze,
      children: de.children
    })]
  }, de.key)), zl = $e || ((de, et) => {
    const {
      key: Ut,
      ...Ar
    } = de;
    return /* @__PURE__ */ W("li", {
      ...Ar,
      children: Ir(et)
    }, Ut);
  }), zi = (de, et) => {
    const Ut = po({
      option: de,
      index: et
    });
    return zl({
      ...Ut,
      className: Fe.option
    }, de, {
      selected: Ut["aria-selected"],
      index: et,
      inputValue: go
    }, ze);
  }, dn = Et.slotProps.clearIndicator, mn = Et.slotProps.popupIndicator;
  return /* @__PURE__ */ bt(x.Fragment, {
    children: [/* @__PURE__ */ W(ng, {
      ref: r,
      className: we(Fe.root, u),
      ownerState: ze,
      ...ve(Ye),
      children: Ze({
        id: ur,
        disabled: C,
        fullWidth: !0,
        size: at === "small" ? "small" : void 0,
        InputLabelProps: cr(),
        InputProps: {
          ref: mo,
          className: Fe.inputRoot,
          startAdornment: le,
          onMouseDown: (de) => {
            de.target === de.currentTarget && ho(de);
          },
          ...(Pr || $r) && {
            endAdornment: /* @__PURE__ */ bt(og, {
              className: Fe.endAdornment,
              ownerState: ze,
              children: [Pr ? /* @__PURE__ */ W(ig, {
                ...ht(),
                "aria-label": h,
                title: h,
                ownerState: ze,
                ...dn,
                className: we(Fe.clearIndicator, dn == null ? void 0 : dn.className),
                children: f
              }) : null, $r ? /* @__PURE__ */ W(ag, {
                ..._t(),
                disabled: C,
                "aria-label": xt ? y : Qe,
                title: xt ? y : Qe,
                ownerState: ze,
                ...mn,
                className: we(Fe.popupIndicator, mn == null ? void 0 : mn.className),
                children: De
              }) : null]
            })
          }
        },
        inputProps: {
          className: Fe.input,
          disabled: C,
          readOnly: Be,
          ...wt()
        }
      })
    }), Qt ? /* @__PURE__ */ W(sg, {
      as: ne,
      ...ie,
      children: /* @__PURE__ */ bt(lg, {
        as: T,
        ...F,
        children: [z && Zt.length === 0 ? /* @__PURE__ */ W(cg, {
          className: Fe.loading,
          ownerState: ze,
          children: J
        }) : null, Zt.length === 0 && !g && !z ? /* @__PURE__ */ W(ug, {
          className: Fe.noOptions,
          ownerState: ze,
          role: "presentation",
          onMouseDown: (de) => {
            de.preventDefault();
          },
          children: L
        }) : null, Zt.length > 0 ? /* @__PURE__ */ W(pn, {
          as: K,
          ...I,
          children: Zt.map((de, et) => Z ? qe({
            key: de.key,
            group: de.group,
            children: de.options.map((Ut, Ar) => zi(Ut, de.index + Ar))
          }) : zi(de, et))
        }) : null]
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (hl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: a.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: a.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: a.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: a.oneOfType([a.oneOf(["mouse", "touch"]), a.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: a.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * @ignore
   */
  className: a.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: a.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: a.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: a.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: a.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: a.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: a.shape({
    clearIndicator: a.object,
    paper: a.object,
    popper: a.object,
    popupIndicator: a.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: ar(a.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: a.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: a.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: a.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: a.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: a.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: a.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: a.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: a.oneOfType([a.oneOf(["auto"]), a.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: a.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: a.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: a.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: a.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: a.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: a.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: a.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: a.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: a.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: a.bool,
  /**
   * The input value.
   */
  inputValue: a.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: a.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Hs,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: a.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: a.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: a.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: a.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: a.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: a.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: a.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: a.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: a.func,
  /**
   * @ignore
   */
  onKeyDown: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: a.func,
  /**
   * If `true`, the component is shown.
   */
  open: a.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: a.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: a.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: a.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: a.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: a.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: a.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: a.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: a.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: a.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: a.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: a.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: a.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: a.oneOfType([a.oneOf(["small", "medium"]), a.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: a.shape({
    chip: a.oneOfType([a.func, a.object]),
    clearIndicator: a.oneOfType([a.func, a.object]),
    listbox: a.oneOfType([a.func, a.object]),
    paper: a.oneOfType([a.func, a.object]),
    popper: a.oneOfType([a.func, a.object]),
    popupIndicator: a.oneOfType([a.func, a.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: a.shape({
    listbox: a.elementType,
    paper: a.elementType,
    popper: a.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: ar(a.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const mg = Object.is;
function gg(e, t) {
  if (e === t)
    return !0;
  if (!(e instanceof Object) || !(t instanceof Object))
    return !1;
  let r = 0, n = 0;
  for (const o in e)
    if (r += 1, !mg(e[o], t[o]) || !(o in t))
      return !1;
  for (const o in t)
    n += 1;
  return r === n;
}
const yl = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (yl.displayName = "GridRootPropsContext");
const cn = () => {
  const e = x.useContext(yl);
  if (!e)
    throw new Error("MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.");
  return e;
};
function bl(e) {
  return He("MuiDataGrid", e);
}
const Fh = Ge("MuiDataGrid", ["actionsCell", "aggregationColumnHeader", "aggregationColumnHeader--alignLeft", "aggregationColumnHeader--alignCenter", "aggregationColumnHeader--alignRight", "aggregationColumnHeaderLabel", "autoHeight", "autosizing", "booleanCell", "cell--editable", "cell--editing", "cell--flex", "cell--textCenter", "cell--textLeft", "cell--textRight", "cell--rangeTop", "cell--rangeBottom", "cell--rangeLeft", "cell--rangeRight", "cell--pinnedLeft", "cell--pinnedRight", "cell--selectionMode", "cell", "cellCheckbox", "cellEmpty", "cellSkeleton", "cellOffsetLeft", "checkboxInput", "columnHeader", "columnHeader--alignCenter", "columnHeader--alignLeft", "columnHeader--alignRight", "columnHeader--dragging", "columnHeader--moving", "columnHeader--numeric", "columnHeader--sortable", "columnHeader--sorted", "columnHeader--filtered", "columnHeader--pinnedLeft", "columnHeader--pinnedRight", "columnHeader--last", "columnHeader--lastUnpinned", "columnHeader--siblingFocused", "columnHeaderCheckbox", "columnHeaderDraggableContainer", "columnHeaderTitle", "columnHeaderTitleContainer", "columnHeaderTitleContainerContent", "columnHeader--filledGroup", "columnHeader--emptyGroup", "columnHeaders", "columnSeparator--resizable", "columnSeparator--resizing", "columnSeparator--sideLeft", "columnSeparator--sideRight", "columnSeparator", "columnsManagement", "columnsManagementRow", "columnsManagementHeader", "columnsManagementSearchInput", "columnsManagementFooter", "container--top", "container--bottom", "detailPanel", "detailPanels", "detailPanelToggleCell", "detailPanelToggleCell--expanded", "footerCell", "panel", "panelHeader", "panelWrapper", "panelContent", "panelFooter", "paper", "editBooleanCell", "editInputCell", "filler", "filler--borderBottom", "filler--pinnedLeft", "filler--pinnedRight", "filterForm", "filterFormDeleteIcon", "filterFormLogicOperatorInput", "filterFormColumnInput", "filterFormOperatorInput", "filterFormValueInput", "filterIcon", "footerContainer", "headerFilterRow", "iconButtonContainer", "iconSeparator", "main", "main--hasPinnedRight", "main--hasSkeletonLoadingOverlay", "menu", "menuIcon", "menuIconButton", "menuOpen", "menuList", "overlay", "overlayWrapper", "overlayWrapperInner", "root", "root--densityStandard", "root--densityComfortable", "root--densityCompact", "root--disableUserSelection", "root--noToolbar", "row", "row--editable", "row--editing", "row--firstVisible", "row--lastVisible", "row--dragging", "row--dynamicHeight", "row--detailPanelExpanded", "row--borderBottom", "rowReorderCellPlaceholder", "rowCount", "rowReorderCellContainer", "rowReorderCell", "rowReorderCell--draggable", "rowSkeleton", "scrollArea--left", "scrollArea--right", "scrollArea", "scrollbar", "scrollbar--vertical", "scrollbar--horizontal", "scrollbarFiller", "scrollbarFiller--header", "scrollbarFiller--borderTop", "scrollbarFiller--borderBottom", "scrollbarFiller--pinnedRight", "selectedRowCount", "sortIcon", "toolbarContainer", "toolbarFilterList", "virtualScroller", "virtualScroller--hasScrollX", "virtualScrollerContent", "virtualScrollerContent--overflowed", "virtualScrollerRenderZone", "pinnedColumns", "withVerticalBorder", "withBorderColor", "cell--withRightBorder", "cell--withLeftBorder", "columnHeader--withRightBorder", "columnHeader--withLeftBorder", "treeDataGroupingCell", "treeDataGroupingCellToggle", "treeDataGroupingCellLoadingContainer", "groupingCriteriaCell", "groupingCriteriaCellToggle", "groupingCriteriaCellLoadingContainer", "pinnedRows", "pinnedRows--top", "pinnedRows--bottom", "pinnedRowsRenderZone"]), vl = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (vl.displayName = "GridApiContext");
function Cl() {
  const e = x.useContext(vl);
  if (e === void 0)
    throw new Error(["MUI X: Could not find the Data Grid context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return e;
}
const os = /* @__PURE__ */ new Set();
function kt(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const r = Array.isArray(e) ? e.join(`
`) : e;
  os.has(r) || (os.add(r), t === "error" ? console.error(r) : console.warn(r));
}
function Sl(e) {
  return e.acceptsApiRef;
}
function is(e, t) {
  return Sl(t) ? t(e) : t(e.current.state);
}
function Do(e, t, r, n) {
  return Sl(t) ? t(e, r) : t(e.current.state, n);
}
const wl = Object.is, hg = gg, yg = (e, t) => e === t ? !0 : e.length === t.length && e.every((r, n) => r === t[n]), xl = (e, t) => {
  let r = Object.is;
  return t instanceof Array ? r = yg : t instanceof Object && (r = hg), r(e, t);
}, El = () => ({
  state: null,
  equals: null,
  selector: null,
  args: null
}), Vh = (e, t, r = wl) => {
  process.env.NODE_ENV !== "production" && (e.current.state || kt(["MUI X: `useGridSelector` has been called before the initialization of the state.", "This hook can only be used inside the context of the grid."]));
  const n = io(El), o = n.current.selector !== null, [i, s] = x.useState(
    // We don't use an initialization function to avoid allocations
    o ? null : is(e, t)
  );
  return n.current.state = i, n.current.equals = r, n.current.selector = t, vi(() => e.current.store.subscribe(() => {
    const l = is(e, n.current.selector);
    n.current.equals(n.current.state, l) || (n.current.state = l, s(l));
  })), i;
}, Lh = (e, t, r = void 0, n = wl) => {
  process.env.NODE_ENV !== "production" && (e.current.state || kt(["MUI X: `useGridSelector` has been called before the initialization of the state.", "This hook can only be used inside the context of the grid."]));
  const o = io(El), i = o.current.selector !== null, [s, l] = x.useState(
    // We don't use an initialization function to avoid allocations
    i ? null : Do(e, t, r, e.current.instanceId)
  );
  o.current.state = s, o.current.equals = n, o.current.selector = t;
  const c = o.current.args;
  if (o.current.args = r, i && !xl(c, r)) {
    const u = Do(e, o.current.selector, o.current.args, e.current.instanceId);
    o.current.equals(o.current.state, u) || (o.current.state = u, l(u));
  }
  return vi(() => e.current.store.subscribe(() => {
    const u = Do(e, o.current.selector, o.current.args, e.current.instanceId);
    o.current.equals(o.current.state, u) || (o.current.state = u, l(u));
  })), s;
};
var bg = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let n = !1;
    try {
      const o = {};
      e(o) === o && (n = !0);
    } catch {
    }
    if (n) {
      let o;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: o } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: o }
      );
    }
  }
}, vg = (e, t, r) => {
  const { memoize: n, memoizeOptions: o } = t, { inputSelectorResults: i, inputSelectorResultsCopy: s } = e, l = n(() => ({}), ...o);
  if (!(l.apply(null, i) === l.apply(null, s))) {
    let u;
    try {
      throw new Error();
    } catch (f) {
      ({ stack: u } = f);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: i,
        secondInputs: s,
        stack: u
      }
    );
  }
}, Cg = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, Bn = /* @__PURE__ */ Symbol("NOT_FOUND");
function Sg(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function wg(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var as = (e) => Array.isArray(e) ? e : [e];
function xg(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return wg(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function ss(e, t) {
  const r = [], { length: n } = e;
  for (let o = 0; o < n; o++)
    r.push(e[o].apply(null, t));
  return r;
}
var Eg = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...Cg,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: bg
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: vg
    }
  };
};
function Og(e) {
  let t;
  return {
    get(r) {
      return t && e(t.key, r) ? t.value : Bn;
    },
    put(r, n) {
      t = { key: r, value: n };
    },
    getEntries() {
      return t ? [t] : [];
    },
    clear() {
      t = void 0;
    }
  };
}
function Tg(e, t) {
  let r = [];
  function n(l) {
    const c = r.findIndex((u) => t(l, u.key));
    if (c > -1) {
      const u = r[c];
      return c > 0 && (r.splice(c, 1), r.unshift(u)), u.value;
    }
    return Bn;
  }
  function o(l, c) {
    n(l) === Bn && (r.unshift({ key: l, value: c }), r.length > e && r.pop());
  }
  function i() {
    return r;
  }
  function s() {
    r = [];
  }
  return { get: n, put: o, getEntries: i, clear: s };
}
var Rg = (e, t) => e === t;
function Pg(e) {
  return function(r, n) {
    if (r === null || n === null || r.length !== n.length)
      return !1;
    const { length: o } = r;
    for (let i = 0; i < o; i++)
      if (!e(r[i], n[i]))
        return !1;
    return !0;
  };
}
function $g(e, t) {
  const r = typeof t == "object" ? t : { equalityCheck: t }, {
    equalityCheck: n = Rg,
    maxSize: o = 1,
    resultEqualityCheck: i
  } = r, s = Pg(n);
  let l = 0;
  const c = o <= 1 ? Og(s) : Tg(o, s);
  function u() {
    let f = c.get(arguments);
    if (f === Bn) {
      if (f = e.apply(null, arguments), l++, i) {
        const m = c.getEntries().find(
          (h) => i(h.value, f)
        );
        m && (f = m.value, l !== 0 && l--);
      }
      c.put(arguments, f);
    }
    return f;
  }
  return u.clearCache = () => {
    c.clear(), u.resetResultsCount();
  }, u.resultsCount = () => l, u.resetResultsCount = () => {
    l = 0;
  }, u;
}
var Ig = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, kg = () => typeof WeakRef == "undefined" ? Ig : WeakRef, Ol = /* @__PURE__ */ kg(), Ag = 0, ls = 1;
function xn() {
  return {
    s: Ag,
    v: void 0,
    o: null,
    p: null
  };
}
function Ng(e) {
  return e instanceof Ol ? e.deref() : e;
}
function Mg(e, t = {}) {
  let r = xn();
  const { resultEqualityCheck: n } = t;
  let o, i = 0;
  function s() {
    let l = r;
    const { length: c } = arguments;
    for (let d = 0, m = c; d < m; d++) {
      const h = arguments[d];
      if (typeof h == "function" || typeof h == "object" && h !== null) {
        let y = l.o;
        y === null && (l.o = y = /* @__PURE__ */ new WeakMap());
        const p = y.get(h);
        p === void 0 ? (l = xn(), y.set(h, l)) : l = p;
      } else {
        let y = l.p;
        y === null && (l.p = y = /* @__PURE__ */ new Map());
        const p = y.get(h);
        p === void 0 ? (l = xn(), y.set(h, l)) : l = p;
      }
    }
    const u = l;
    let f;
    if (l.s === ls)
      f = l.v;
    else if (f = e.apply(null, arguments), i++, n) {
      const d = Ng(o);
      d != null && n(d, f) && (f = d, i !== 0 && i--), o = typeof f == "object" && f !== null || typeof f == "function" ? /* @__PURE__ */ new Ol(f) : f;
    }
    return u.s = ls, u.v = f, f;
  }
  return s.clearCache = () => {
    r = xn(), s.resetResultsCount();
  }, s.resultsCount = () => i, s.resetResultsCount = () => {
    i = 0;
  }, s;
}
function Dg(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...o) => {
    let i = 0, s = 0, l, c = {}, u = o.pop();
    typeof u == "object" && (c = u, u = o.pop()), Sg(
      u,
      `createSelector expects an output function after the inputs, but received: [${typeof u}]`
    );
    const f = {
      ...r,
      ...c
    }, {
      memoize: d,
      memoizeOptions: m = [],
      argsMemoize: h = Mg,
      argsMemoizeOptions: y = []
    } = f, p = as(m), v = as(y), w = xg(o), O = d(function() {
      return i++, u.apply(
        null,
        arguments
      );
    }, ...p);
    let C = !0;
    const b = h(function() {
      s++;
      const E = ss(
        w,
        arguments
      );
      if (l = O.apply(null, E), process.env.NODE_ENV !== "production") {
        const { devModeChecks: P = {} } = f, { identityFunctionCheck: V, inputStabilityCheck: D } = Eg(C, P);
        if (V.shouldRun && V.run(
          u,
          E,
          l
        ), D.shouldRun) {
          const g = ss(
            w,
            arguments
          );
          D.run(
            { inputSelectorResults: E, inputSelectorResultsCopy: g },
            { memoize: d, memoizeOptions: p },
            arguments
          );
        }
        C && (C = !1);
      }
      return l;
    }, ...v);
    return Object.assign(b, {
      resultFunc: u,
      memoizedResultFunc: O,
      dependencies: w,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => l,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: d,
      argsMemoize: h
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
const ti = Dg({
  memoize: $g,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), zn = /* @__PURE__ */ new WeakMap();
function ct(e) {
  return "current" in e && "instanceId" in e.current;
}
const ut = {
  id: "default"
}, lo = (e, t, r, n, o, i, ...s) => {
  if (s.length > 0)
    throw new Error("Unsupported number of selectors");
  let l;
  if (e && t && r && n && o && i)
    l = (c, u) => {
      const f = ct(c), d = u != null ? u : f ? c.current.instanceId : ut, m = f ? c.current.state : c, h = e(m, d), y = t(m, d), p = r(m, d), v = n(m, d), w = o(m, d);
      return i(h, y, p, v, w);
    };
  else if (e && t && r && n && o)
    l = (c, u) => {
      const f = ct(c), d = u != null ? u : f ? c.current.instanceId : ut, m = f ? c.current.state : c, h = e(m, d), y = t(m, d), p = r(m, d), v = n(m, d);
      return o(h, y, p, v);
    };
  else if (e && t && r && n)
    l = (c, u) => {
      const f = ct(c), d = u != null ? u : f ? c.current.instanceId : ut, m = f ? c.current.state : c, h = e(m, d), y = t(m, d), p = r(m, d);
      return n(h, y, p);
    };
  else if (e && t && r)
    l = (c, u) => {
      const f = ct(c), d = u != null ? u : f ? c.current.instanceId : ut, m = f ? c.current.state : c, h = e(m, d), y = t(m, d);
      return r(h, y);
    };
  else if (e && t)
    l = (c, u) => {
      const f = ct(c), d = u != null ? u : f ? c.current.instanceId : ut, m = f ? c.current.state : c, h = e(m, d);
      return t(h);
    };
  else
    throw new Error("Missing arguments");
  return l.acceptsApiRef = !0, l;
}, jh = (e, t, r, n, o, i, ...s) => {
  if (s.length > 0)
    throw new Error("Unsupported number of selectors");
  let l;
  if (e && t && r && n && o && i)
    l = (c, u, f) => {
      const d = ct(c), m = f != null ? f : d ? c.current.instanceId : ut, h = d ? c.current.state : c, y = e(h, u, m), p = t(h, u, m), v = r(h, u, m), w = n(h, u, m), O = o(h, u, m);
      return i(y, p, v, w, O, u);
    };
  else if (e && t && r && n && o)
    l = (c, u, f) => {
      const d = ct(c), m = f != null ? f : d ? c.current.instanceId : ut, h = d ? c.current.state : c, y = e(h, u, m), p = t(h, u, m), v = r(h, u, m), w = n(h, u, m);
      return o(y, p, v, w, u);
    };
  else if (e && t && r && n)
    l = (c, u, f) => {
      const d = ct(c), m = f != null ? f : d ? c.current.instanceId : ut, h = d ? c.current.state : c, y = e(h, u, m), p = t(h, u, m), v = r(h, u, m);
      return n(y, p, v, u);
    };
  else if (e && t && r)
    l = (c, u, f) => {
      const d = ct(c), m = f != null ? f : d ? c.current.instanceId : ut, h = d ? c.current.state : c, y = e(h, u, m), p = t(h, u, m);
      return r(y, p, u);
    };
  else if (e && t)
    l = (c, u, f) => {
      const d = ct(c), m = f != null ? f : d ? c.current.instanceId : ut, h = d ? c.current.state : c, y = e(h, u, m);
      return t(y, u);
    };
  else
    throw new Error("Missing arguments");
  return l.acceptsApiRef = !0, l;
}, Xt = (...e) => {
  const t = (r, n) => {
    const o = ct(r), i = o ? r.current.instanceId : n != null ? n : ut, s = o ? r.current.state : r;
    process.env.NODE_ENV !== "production" && i.id === "default" && kt(["MUI X: A selector was called without passing the instance ID, which may impact the performance of the grid.", "To fix, call it with `apiRef`, for example `mySelector(apiRef)`, or pass the instance ID explicitly, for example `mySelector(state, apiRef.current.instanceId)`."]);
    const l = zn.get(i), c = l != null ? l : /* @__PURE__ */ new Map(), u = c == null ? void 0 : c.get(e);
    if (c && u)
      return u(s, i);
    const f = ti(...e);
    return l || zn.set(i, c), c.set(e, f), f(s, i);
  };
  return t.acceptsApiRef = !0, t;
}, Bh = (...e) => {
  const t = (r, n, o) => {
    const i = ct(r), s = i ? r.current.instanceId : o != null ? o : ut, l = i ? r.current.state : r;
    process.env.NODE_ENV !== "production" && s.id === "default" && kt(["MUI X: A selector was called without passing the instance ID, which may impact the performance of the grid.", "To fix, call it with `apiRef`, for example `mySelector(apiRef)`, or pass the instance ID explicitly, for example `mySelector(state, apiRef.current.instanceId)`."]);
    const c = zn.get(s), u = c != null ? c : /* @__PURE__ */ new Map(), f = u == null ? void 0 : u.get(e);
    if (u && f) {
      if (!xl(f.selectorArgs, n)) {
        const h = n !== void 0 ? [...e.slice(0, e.length - 1), () => n, e[e.length - 1]] : e, y = ti(...h);
        return y.selectorArgs = n, u.set(e, y), y(l, n, s);
      }
      return f(l, n, s);
    }
    const d = n !== void 0 ? [...e.slice(0, e.length - 1), () => n, e[e.length - 1]] : e, m = ti(...d);
    return m.selectorArgs = n, c || zn.set(s, u), u.set(e, m), m(l, n, s);
  };
  return t.acceptsApiRef = !0, t;
};
let zh = /* @__PURE__ */ (function(e) {
  return e.LEFT = "left", e.RIGHT = "right", e;
})({});
const cs = {
  left: [],
  right: []
}, _g = (e) => e.isRtl, co = (e) => e.columns, Tl = lo(co, (e) => e.orderedFields), Rl = lo(co, (e) => e.lookup), uo = Xt(Tl, Rl, (e, t) => e.map((r) => t[r])), Fg = lo(co, (e) => e.columnVisibilityModel), Li = Xt(uo, Fg, (e, t) => e.filter((r) => t[r.field] !== !1)), Pl = Xt(Li, (e) => e.map((t) => t.field)), Vg = (e) => e.pinnedColumns, Wh = Xt(co, Vg, Pl, _g, (e, t, r, n) => {
  const o = Lg(t, r, n);
  return {
    left: o.left.map((s) => e.lookup[s]),
    right: o.right.map((s) => e.lookup[s])
  };
});
function Lg(e, t, r) {
  var l, c;
  if (!Array.isArray(e.left) && !Array.isArray(e.right) || ((l = e.left) == null ? void 0 : l.length) === 0 && ((c = e.right) == null ? void 0 : c.length) === 0)
    return cs;
  const n = (u, f) => Array.isArray(u) ? u.filter((d) => f.includes(d)) : [], o = n(e.left, t), i = t.filter(
    // Filter out from the remaining columns those columns already pinned to the left
    (u) => !o.includes(u)
  ), s = n(e.right, i);
  return r ? {
    left: s,
    right: o
  } : {
    left: o,
    right: s
  };
}
const jg = Xt(Li, (e) => {
  const t = [];
  let r = 0;
  for (let n = 0; n < e.length; n += 1)
    t.push(r), r += e[n].computedWidth;
  return t;
}), Uh = lo(Li, jg, (e, t) => {
  const r = e.length;
  return r === 0 ? 0 : t[r - 1] + e[r - 1].computedWidth;
}), Hh = Xt(uo, (e) => e.filter((t) => t.filterable)), qh = Xt(uo, (e) => e.reduce((t, r) => (r.filterable && (t[r.field] = r), t), {})), Bg = Xt(uo, (e) => e.some((t) => t.colSpan !== void 0)), zg = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "isValidating", "debounceMs", "isProcessingProps", "onValueChange"], Wg = (e) => {
  const {
    classes: t
  } = e;
  return gt({
    root: ["editInputCell"]
  }, bl, t);
}, Ug = be(Vi, {
  name: "MuiDataGrid",
  slot: "EditInputCell",
  overridesResolver: (e, t) => t.editInputCell
})(({
  theme: e
}) => ce({}, e.typography.body2, {
  padding: "1px 0",
  "& input": {
    padding: "0 16px",
    height: "100%"
  }
})), Hg = /* @__PURE__ */ x.forwardRef((e, t) => {
  const r = cn(), {
    id: n,
    value: o,
    field: i,
    colDef: s,
    hasFocus: l,
    debounceMs: c = 200,
    isProcessingProps: u,
    onValueChange: f
  } = e, d = sr(e, zg), m = Cl(), h = x.useRef(), [y, p] = x.useState(o), v = Wg(r), w = x.useCallback(async (C) => {
    const b = C.target.value;
    f && await f(C, b);
    const S = m.current.getColumn(i);
    let E = b;
    S.valueParser && (E = S.valueParser(b, m.current.getRow(n), S, m)), p(E), m.current.setEditCellValue({
      id: n,
      field: i,
      value: E,
      debounceMs: c,
      unstable_skipValueParser: !0
    }, C);
  }, [m, c, i, n, f]), O = m.current.unstable_getEditCellMeta(n, i);
  return x.useEffect(() => {
    (O == null ? void 0 : O.changeReason) !== "debouncedSetEditCellValue" && p(o);
  }, [O, o]), At(() => {
    l && h.current.focus();
  }, [l]), /* @__PURE__ */ W(Ug, ce({
    ref: t,
    inputRef: h,
    className: v.root,
    ownerState: r,
    fullWidth: !0,
    type: s.type === "number" ? s.type : "text",
    value: y != null ? y : "",
    onChange: w,
    endAdornment: u ? /* @__PURE__ */ W(r.slots.loadIcon, {
      fontSize: "small",
      color: "action"
    }) : void 0
  }, d));
}), qg = (e) => /* @__PURE__ */ W(Hg, ce({}, e)), Gg = (e, t) => t && e.length > 1 ? (process.env.NODE_ENV !== "production" && kt(["MUI X: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.", "If you are using the community version of the Data Grid, this prop is always `true`."], "error"), [e[0]]) : e, Gh = (e, t) => (r) => ce({}, r, {
  sorting: ce({}, r.sorting, {
    sortModel: Gg(e, t)
  })
}), Yg = (e) => e === "desc", Kg = (e, t) => {
  const r = t.current.getColumn(e.field);
  if (!r || e.sort === null)
    return null;
  let n;
  return r.getSortComparator ? n = r.getSortComparator(e.sort) : n = Yg(e.sort) ? (...i) => -1 * r.sortComparator(...i) : r.sortComparator, n ? {
    getSortCellParams: (i) => ({
      id: i,
      field: r.field,
      rowNode: t.current.getRowNode(i),
      value: t.current.getCellValue(i, r.field),
      api: t.current
    }),
    comparator: n
  } : null;
}, Xg = (e, t, r) => e.reduce((n, o, i) => {
  if (n !== 0)
    return n;
  const s = t.params[i], l = r.params[i];
  return n = o.comparator(s.value, l.value, s, l), n;
}, 0), Yh = (e, t) => {
  const r = e.map((n) => Kg(n, t)).filter((n) => !!n);
  return r.length === 0 ? null : (n) => n.map((o) => ({
    node: o,
    params: r.map((i) => i.getSortCellParams(o.id))
  })).sort((o, i) => Xg(r, o, i)).map((o) => o.node.id);
}, Kh = (e, t) => {
  const r = e.indexOf(t);
  return !t || r === -1 || r + 1 === e.length ? e[0] : e[r + 1];
}, ji = (e, t) => e == null && t != null ? -1 : t == null && e != null ? 1 : e == null && t == null ? 0 : null, Jg = new Intl.Collator(), Qg = (e, t) => {
  const r = ji(e, t);
  return r !== null ? r : typeof e == "string" ? Jg.compare(e.toString(), t.toString()) : e - t;
}, Xh = (e, t) => {
  const r = ji(e, t);
  return r !== null ? r : Number(e) - Number(t);
}, $l = (e, t) => {
  const r = ji(e, t);
  return r !== null ? r : e > t ? 1 : e < t ? -1 : 0;
}, Zg = ["item", "applyValue", "type", "apiRef", "focusElementRef", "tabIndex", "disabled", "isFilterActive", "clearButton", "InputProps", "variant"];
function er(e) {
  var b, S;
  const {
    item: t,
    applyValue: r,
    type: n,
    apiRef: o,
    focusElementRef: i,
    tabIndex: s,
    disabled: l,
    clearButton: c,
    InputProps: u,
    variant: f = "standard"
  } = e, d = sr(e, Zg), m = Si(), [h, y] = x.useState((b = t.value) != null ? b : ""), [p, v] = x.useState(!1), w = an(), O = cn(), C = x.useCallback((E) => {
    const {
      value: P
    } = E.target;
    y(String(P)), v(!0), m.start(O.filterDebounceMs, () => {
      const V = ce({}, t, {
        value: n === "number" ? Number(P) : P,
        fromInput: w
      });
      r(V), v(!1);
    });
  }, [m, O.filterDebounceMs, t, n, w, r]);
  return x.useEffect(() => {
    var P;
    (t.fromInput !== w || t.value === void 0) && y(String((P = t.value) != null ? P : ""));
  }, [w, t]), /* @__PURE__ */ W(O.slots.baseTextField, ce({
    id: w,
    label: o.current.getLocaleText("filterPanelInputLabel"),
    placeholder: o.current.getLocaleText("filterPanelInputPlaceholder"),
    value: h,
    onChange: C,
    variant: f,
    type: n || "text",
    InputProps: ce({}, p || c ? {
      endAdornment: p ? /* @__PURE__ */ W(O.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : c
    } : {}, {
      disabled: l
    }, u, {
      inputProps: ce({
        tabIndex: s
      }, u == null ? void 0 : u.inputProps)
    }),
    InputLabelProps: {
      shrink: !0
    },
    inputRef: i
  }, d, (S = O.slotProps) == null ? void 0 : S.baseTextField));
}
process.env.NODE_ENV !== "production" && (er.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: a.shape({
    current: a.object.isRequired
  }).isRequired,
  applyValue: a.func.isRequired,
  clearButton: a.node,
  focusElementRef: a.oneOfType([a.func, a.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: a.bool,
  item: a.shape({
    field: a.string.isRequired,
    id: a.oneOfType([a.number, a.string]),
    operator: a.string.isRequired,
    value: a.any
  }).isRequired
});
function Jh(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function Qh(e) {
  return typeof e == "function";
}
function eh(e) {
  return typeof e == "object" && e !== null;
}
function Zh() {
  try {
    const e = "__some_random_key_you_are_not_going_to_use__";
    return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
}
function Wn(e) {
  return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
const ey = (e, t, r) => Math.max(t, Math.min(r, e));
function ty(e, t) {
  return Array.from({
    length: t - e
  }).map((r, n) => e + n);
}
function _o(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e)) {
      const o = e.length;
      if (o !== t.length)
        return !1;
      for (let i = 0; i < o; i += 1)
        if (!_o(e[i], t[i]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      const o = Array.from(e.entries());
      for (let i = 0; i < o.length; i += 1)
        if (!t.has(o[i][0]))
          return !1;
      for (let i = 0; i < o.length; i += 1) {
        const s = o[i];
        if (!_o(s[1], t.get(s[0])))
          return !1;
      }
      return !0;
    }
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      const o = Array.from(e.entries());
      for (let i = 0; i < o.length; i += 1)
        if (!t.has(o[i][0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      const o = e.length;
      if (o !== t.length)
        return !1;
      for (let i = 0; i < o; i += 1)
        if (e[i] !== t[i])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const r = Object.keys(e), n = r.length;
    if (n !== Object.keys(t).length)
      return !1;
    for (let o = 0; o < n; o += 1)
      if (!Object.prototype.hasOwnProperty.call(t, r[o]))
        return !1;
    for (let o = 0; o < n; o += 1) {
      const i = r[o];
      if (!_o(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function th(e) {
  return () => {
    let t = e += 1831565813;
    return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}
function ry(e) {
  const t = th(e);
  return (r, n) => r + (n - r) * t();
}
function ny(e) {
  return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
function oy(e) {
}
const rh = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"], nh = ["key"];
function Il(e) {
  const {
    item: t,
    applyValue: r,
    type: n,
    apiRef: o,
    focusElementRef: i,
    color: s,
    error: l,
    helperText: c,
    size: u,
    variant: f = "standard"
  } = e, d = sr(e, rh), m = {
    color: s,
    error: l,
    helperText: c,
    size: u,
    variant: f
  }, [h, y] = x.useState(t.value || []), p = an(), v = cn();
  x.useEffect(() => {
    var C;
    const O = (C = t.value) != null ? C : [];
    y(O.map(String));
  }, [t.value]);
  const w = x.useCallback((O, C) => {
    y(C.map(String)), r(ce({}, t, {
      value: [...C.map((b) => n === "number" ? Number(b) : b)]
    }));
  }, [r, t, n]);
  return /* @__PURE__ */ W(hl, ce({
    multiple: !0,
    freeSolo: !0,
    options: [],
    filterOptions: (O, C) => {
      const {
        inputValue: b
      } = C;
      return b == null || b === "" ? [] : [b];
    },
    id: p,
    value: h,
    onChange: w,
    renderTags: (O, C) => O.map((b, S) => {
      const E = C({
        index: S
      }), {
        key: P
      } = E, V = sr(E, nh);
      return /* @__PURE__ */ W(v.slots.baseChip, ce({
        variant: "outlined",
        size: "small",
        label: b
      }, V), P);
    }),
    renderInput: (O) => {
      var C;
      return /* @__PURE__ */ W(v.slots.baseTextField, ce({}, O, {
        label: o.current.getLocaleText("filterPanelInputLabel"),
        placeholder: o.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: ce({}, O.InputLabelProps, {
          shrink: !0
        }),
        inputRef: i,
        type: n || "text"
      }, m, (C = v.slotProps) == null ? void 0 : C.baseTextField));
    }
  }, d));
}
process.env.NODE_ENV !== "production" && (Il.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: a.shape({
    current: a.object.isRequired
  }).isRequired,
  applyValue: a.func.isRequired,
  focusElementRef: a.oneOfType([a.func, a.object]),
  item: a.shape({
    field: a.string.isRequired,
    id: a.oneOfType([a.number, a.string]),
    operator: a.string.isRequired,
    value: a.any
  }).isRequired,
  type: a.oneOf(["date", "datetime-local", "number", "text"])
});
var Jr = /* @__PURE__ */ (function(e) {
  return e.And = "and", e.Or = "or", e;
})(Jr || {});
const us = () => ({
  items: [],
  logicOperator: Jr.And,
  quickFilterValues: [],
  quickFilterLogicOperator: Jr.And
});
function kl(e) {
  return {
    current: e.current.getPublicApi()
  };
}
let Fr;
function oh() {
  if (Fr !== void 0)
    return Fr;
  try {
    Fr = new Function("return true")();
  } catch {
    Fr = !1;
  }
  return Fr;
}
const ih = (e, t) => {
  const r = ce({}, e);
  if (r.id == null && (r.id = Math.round(Math.random() * 1e5)), r.operator == null) {
    const n = Rl(t)[r.field];
    r.operator = n && n.filterOperators[0].value;
  }
  return r;
}, ah = (e, t, r) => {
  const n = e.items.length > 1;
  let o;
  n && t ? (process.env.NODE_ENV !== "production" && kt(["MUI X: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.", "If you are using the community version of the Data Grid, this prop is always `true`."], "error"), o = [e.items[0]]) : o = e.items;
  const i = n && o.some((l) => l.id == null), s = o.some((l) => l.operator == null);
  return process.env.NODE_ENV !== "production" && i && kt("MUI X: The `id` field is required on `filterModel.items` when you use multiple filters.", "error"), process.env.NODE_ENV !== "production" && s && kt("MUI X: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.", "error"), s || i ? ce({}, e, {
    items: o.map((l) => ih(l, r))
  }) : e.items !== o ? ce({}, e, {
    items: o
  }) : e;
}, iy = (e, t, r) => (n) => ce({}, n, {
  filterModel: ah(e, t, r)
}), Qr = (e) => typeof e == "string" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e, Al = (e, t) => {
  var f;
  if (!e.field || !e.operator)
    return null;
  const r = t.current.getColumn(e.field);
  if (!r)
    return null;
  let n;
  if (r.valueParser) {
    const d = r.valueParser;
    n = Array.isArray(e.value) ? (f = e.value) == null ? void 0 : f.map((m) => d(m, void 0, r, t)) : d(e.value, void 0, r, t);
  } else
    n = e.value;
  const {
    ignoreDiacritics: o
  } = t.current.rootProps;
  o && (n = Qr(n));
  const i = ce({}, e, {
    value: n
  }), s = r.filterOperators;
  if (!(s != null && s.length))
    throw new Error(`MUI X: No filter operators found for column '${r.field}'.`);
  const l = s.find((d) => d.value === i.operator);
  if (!l)
    throw new Error(`MUI X: No filter operator found for column '${r.field}' and operator value '${i.operator}'.`);
  const c = kl(t), u = l.getApplyFilterFn(i, r);
  return typeof u != "function" ? null : {
    item: i,
    fn: (d) => {
      let m = t.current.getRowValue(d, r);
      return o && (m = Qr(m)), u(m, d, r, c);
    }
  };
};
let fs = 1;
const sh = (e, t, r) => {
  const {
    items: n
  } = e, o = n.map((l) => Al(l, t)).filter((l) => !!l);
  if (o.length === 0)
    return null;
  if (r || !oh())
    return (l, c) => {
      const u = {};
      for (let f = 0; f < o.length; f += 1) {
        const d = o[f];
        (!c || c(d.item.field)) && (u[d.item.id] = d.fn(l));
      }
      return u;
    };
  const i = new Function("appliers", "row", "shouldApplyFilter", `"use strict";
${o.map((l, c) => `const shouldApply${c} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(l.item.field)});`).join(`
`)}

const result$$ = {
${o.map((l, c) => `  ${JSON.stringify(String(l.item.id))}: !shouldApply${c} ? false : appliers[${c}].fn(row),`).join(`
`)}
};

return result$$;`.replaceAll("$$", String(fs)));
  return fs += 1, (l, c) => i(o, l, c);
}, lh = (e) => {
  var t;
  return (t = e.quickFilterExcludeHiddenColumns) != null ? t : !0;
}, ch = (e, t) => {
  var l, c;
  const r = (c = (l = e.quickFilterValues) == null ? void 0 : l.filter(Boolean)) != null ? c : [];
  if (r.length === 0)
    return null;
  const n = lh(e) ? Pl(t) : Tl(t), o = [], {
    ignoreDiacritics: i
  } = t.current.rootProps, s = kl(t);
  return n.forEach((u) => {
    const f = t.current.getColumn(u), d = f == null ? void 0 : f.getApplyQuickFilterFn;
    d && o.push({
      column: f,
      appliers: r.map((m) => {
        const h = i ? Qr(m) : m;
        return {
          fn: d(h, f, s)
        };
      })
    });
  }), function(f, d) {
    const m = {};
    e: for (let h = 0; h < r.length; h += 1) {
      const y = r[h];
      for (let p = 0; p < o.length; p += 1) {
        const {
          column: v,
          appliers: w
        } = o[p], {
          field: O
        } = v;
        if (d && !d(O))
          continue;
        const C = w[h];
        let b = t.current.getRowValue(f, v);
        if (C.fn === null)
          continue;
        if (i && (b = Qr(b)), C.fn(b, f, v, s)) {
          m[y] = !0;
          continue e;
        }
      }
      m[y] = !1;
    }
    return m;
  };
}, ay = (e, t, r) => {
  const n = sh(e, t, r), o = ch(e, t);
  return function(s, l, c) {
    var u, f;
    c.passingFilterItems = (u = n == null ? void 0 : n(s, l)) != null ? u : null, c.passingQuickFilterValues = (f = o == null ? void 0 : o(s, l)) != null ? f : null;
  };
}, ps = (e) => e != null, uh = (e, t, r) => (e.cleanedFilterItems || (e.cleanedFilterItems = r.filter((n) => Al(n, t) !== null)), e.cleanedFilterItems), sy = (e, t, r, n, o) => {
  var c, u;
  const i = uh(o, n, r.items), s = e.filter(ps), l = t.filter(ps);
  if (s.length > 0) {
    const f = (m) => s.some((h) => h[m.id]);
    if (((c = r.logicOperator) != null ? c : us().logicOperator) === Jr.And) {
      if (!i.every(f))
        return !1;
    } else if (!i.some(f))
      return !1;
  }
  if (l.length > 0 && r.quickFilterValues != null) {
    const f = (m) => l.some((h) => h[m]);
    if (((u = r.quickFilterLogicOperator) != null ? u : us().quickFilterLogicOperator) === Jr.And) {
      if (!r.quickFilterValues.every(f))
        return !1;
    } else if (!r.quickFilterValues.some(f))
      return !1;
  }
  return !0;
}, fh = (e) => {
  if (!e)
    return null;
  const t = new RegExp(Wn(e), "i");
  return (r, n, o, i) => {
    let s = i.current.getRowFormattedValue(n, o);
    return i.current.ignoreDiacritics && (s = Qr(s)), s != null ? t.test(s.toString()) : !1;
  };
}, ds = (e, t) => (r) => {
  if (!r.value)
    return null;
  const n = e ? r.value : r.value.trim(), o = new RegExp(Wn(n), "i");
  return (i) => {
    if (i == null)
      return t;
    const s = o.test(String(i));
    return t ? !s : s;
  };
}, ms = (e, t) => (r) => {
  if (!r.value)
    return null;
  const n = e ? r.value : r.value.trim(), o = new Intl.Collator(void 0, {
    sensitivity: "base",
    usage: "search"
  });
  return (i) => {
    if (i == null)
      return t;
    const s = o.compare(n, i.toString()) === 0;
    return t ? !s : s;
  };
}, gs = (e) => () => (t) => {
  const r = t === "" || t == null;
  return e ? !r : r;
}, ph = (e = !1) => [{
  value: "contains",
  getApplyFilterFn: ds(e, !1),
  InputComponent: er
}, {
  value: "doesNotContain",
  getApplyFilterFn: ds(e, !0),
  InputComponent: er
}, {
  value: "equals",
  getApplyFilterFn: ms(e, !1),
  InputComponent: er
}, {
  value: "doesNotEqual",
  getApplyFilterFn: ms(e, !0),
  InputComponent: er
}, {
  value: "startsWith",
  getApplyFilterFn: (t) => {
    if (!t.value)
      return null;
    const r = e ? t.value : t.value.trim(), n = new RegExp(`^${Wn(r)}.*$`, "i");
    return (o) => o != null ? n.test(o.toString()) : !1;
  },
  InputComponent: er
}, {
  value: "endsWith",
  getApplyFilterFn: (t) => {
    if (!t.value)
      return null;
    const r = e ? t.value : t.value.trim(), n = new RegExp(`.*${Wn(r)}$`, "i");
    return (o) => o != null ? n.test(o.toString()) : !1;
  },
  InputComponent: er
}, {
  value: "isEmpty",
  getApplyFilterFn: gs(!1),
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: gs(!0),
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFn: (t) => {
    if (!Array.isArray(t.value) || t.value.length === 0)
      return null;
    const r = e ? t.value : t.value.map((o) => o.trim()), n = new Intl.Collator(void 0, {
      sensitivity: "base",
      usage: "search"
    });
    return (o) => o != null ? r.some((i) => n.compare(i, o.toString() || "") === 0) : !1;
  },
  InputComponent: Il
}], Nl = {
  width: 100,
  minWidth: 50,
  maxWidth: 1 / 0,
  hideable: !0,
  sortable: !0,
  resizable: !0,
  filterable: !0,
  groupable: !0,
  pinnable: !0,
  // @ts-ignore
  aggregable: !0,
  editable: !1,
  sortComparator: Qg,
  type: "string",
  align: "left",
  filterOperators: ph(),
  renderEditCell: qg,
  getApplyQuickFilterFn: fh
}, dh = ["item", "applyValue", "type", "apiRef", "focusElementRef", "InputProps", "isFilterActive", "clearButton", "tabIndex", "disabled"];
function hs(e, t) {
  if (e == null)
    return "";
  const r = new Date(e);
  return Number.isNaN(r.getTime()) ? "" : t === "date" ? r.toISOString().substring(0, 10) : t === "datetime-local" ? (r.setMinutes(r.getMinutes() - r.getTimezoneOffset()), r.toISOString().substring(0, 19)) : r.toISOString().substring(0, 10);
}
function tr(e) {
  var C;
  const {
    item: t,
    applyValue: r,
    type: n,
    apiRef: o,
    focusElementRef: i,
    InputProps: s,
    clearButton: l,
    tabIndex: c,
    disabled: u
  } = e, f = sr(e, dh), d = Si(), [m, h] = x.useState(() => hs(t.value, n)), [y, p] = x.useState(!1), v = an(), w = cn(), O = x.useCallback((b) => {
    d.clear();
    const S = b.target.value;
    h(S), p(!0), d.start(w.filterDebounceMs, () => {
      const E = new Date(S);
      r(ce({}, t, {
        value: Number.isNaN(E.getTime()) ? void 0 : E
      })), p(!1);
    });
  }, [r, t, w.filterDebounceMs, d]);
  return x.useEffect(() => {
    const b = hs(t.value, n);
    h(b);
  }, [t.value, n]), /* @__PURE__ */ W(w.slots.baseTextField, ce({
    fullWidth: !0,
    id: v,
    label: o.current.getLocaleText("filterPanelInputLabel"),
    placeholder: o.current.getLocaleText("filterPanelInputPlaceholder"),
    value: m,
    onChange: O,
    variant: "standard",
    type: n || "text",
    InputLabelProps: {
      shrink: !0
    },
    inputRef: i,
    InputProps: ce({}, y || l ? {
      endAdornment: y ? /* @__PURE__ */ W(w.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : l
    } : {}, {
      disabled: u
    }, s, {
      inputProps: ce({
        max: n === "datetime-local" ? "9999-12-31T23:59" : "9999-12-31",
        tabIndex: c
      }, s == null ? void 0 : s.inputProps)
    })
  }, f, (C = w.slotProps) == null ? void 0 : C.baseTextField));
}
process.env.NODE_ENV !== "production" && (tr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: a.shape({
    current: a.object.isRequired
  }).isRequired,
  applyValue: a.func.isRequired,
  clearButton: a.node,
  focusElementRef: a.oneOfType([a.func, a.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: a.bool,
  item: a.shape({
    field: a.string.isRequired,
    id: a.oneOfType([a.number, a.string]),
    operator: a.string.isRequired,
    value: a.any
  }).isRequired
});
function yr(e, t, r, n) {
  if (!e.value)
    return null;
  const o = new Date(e.value);
  r ? o.setSeconds(0, 0) : (o.setMinutes(o.getMinutes() + o.getTimezoneOffset()), o.setHours(0, 0, 0, 0));
  const i = o.getTime();
  return (s) => {
    if (!s)
      return !1;
    if (n)
      return t(s.getTime(), i);
    const l = new Date(s);
    return r ? l.setSeconds(0, 0) : l.setHours(0, 0, 0, 0), t(l.getTime(), i);
  };
}
const Ml = (e) => [{
  value: "is",
  getApplyFilterFn: (t) => yr(t, (r, n) => r === n, e),
  InputComponent: tr,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "not",
  getApplyFilterFn: (t) => yr(t, (r, n) => r !== n, e),
  InputComponent: tr,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "after",
  getApplyFilterFn: (t) => yr(t, (r, n) => r > n, e),
  InputComponent: tr,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "onOrAfter",
  getApplyFilterFn: (t) => yr(t, (r, n) => r >= n, e),
  InputComponent: tr,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "before",
  getApplyFilterFn: (t) => yr(t, (r, n) => r < n, e, !e),
  InputComponent: tr,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "onOrBefore",
  getApplyFilterFn: (t) => yr(t, (r, n) => r <= n, e),
  InputComponent: tr,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "isEmpty",
  getApplyFilterFn: () => (t) => t == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: () => (t) => t != null,
  requiresFilterValue: !1
}], mh = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "inputProps", "isValidating", "isProcessingProps", "onValueChange"], gh = be(Vi)({
  fontSize: "inherit"
}), hh = (e) => {
  const {
    classes: t
  } = e;
  return gt({
    root: ["editInputCell"]
  }, bl, t);
};
function Dl(e) {
  const {
    id: t,
    value: r,
    field: n,
    colDef: o,
    hasFocus: i,
    inputProps: s,
    onValueChange: l
  } = e, c = sr(e, mh), u = o.type === "dateTime", f = Cl(), d = x.useRef(), m = x.useMemo(() => {
    let b;
    r == null ? b = null : r instanceof Date ? b = r : b = new Date((r != null ? r : "").toString());
    let S;
    return b == null || Number.isNaN(b.getTime()) ? S = "" : S = new Date(b.getTime() - b.getTimezoneOffset() * 60 * 1e3).toISOString().substr(0, u ? 16 : 10), {
      parsed: b,
      formatted: S
    };
  }, [r, u]), [h, y] = x.useState(m), v = {
    classes: cn().classes
  }, w = hh(v), O = x.useCallback((b) => {
    if (b === "")
      return null;
    const [S, E] = b.split("T"), [P, V, D] = S.split("-"), g = /* @__PURE__ */ new Date();
    if (g.setFullYear(Number(P), Number(V) - 1, Number(D)), g.setHours(0, 0, 0, 0), E) {
      const [$, k] = E.split(":");
      g.setHours(Number($), Number(k), 0, 0);
    }
    return g;
  }, []), C = x.useCallback(async (b) => {
    const S = b.target.value, E = O(S);
    l && await l(b, E), y({
      parsed: E,
      formatted: S
    }), f.current.setEditCellValue({
      id: t,
      field: n,
      value: E
    }, b);
  }, [f, n, t, l, O]);
  return x.useEffect(() => {
    y((b) => {
      var S, E;
      return m.parsed !== b.parsed && ((S = m.parsed) == null ? void 0 : S.getTime()) !== ((E = b.parsed) == null ? void 0 : E.getTime()) ? m : b;
    });
  }, [m]), At(() => {
    i && d.current.focus();
  }, [i]), /* @__PURE__ */ W(gh, ce({
    inputRef: d,
    fullWidth: !0,
    className: w.root,
    type: u ? "datetime-local" : "date",
    inputProps: ce({
      max: u ? "9999-12-31T23:59" : "9999-12-31"
    }, s),
    value: h.formatted,
    onChange: C
  }, c));
}
process.env.NODE_ENV !== "production" && (Dl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: a.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: a.oneOf(["edit", "view"]).isRequired,
  changeReason: a.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: a.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: a.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: a.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: a.bool.isRequired,
  /**
   * The grid row id.
   */
  id: a.oneOfType([a.number, a.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: a.bool,
  isProcessingProps: a.bool,
  isValidating: a.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: a.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: a.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: a.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: a.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: a.any
});
const _l = (e) => /* @__PURE__ */ W(Dl, ce({}, e));
function Fl({
  value: e,
  columnType: t,
  rowId: r,
  field: n
}) {
  if (!(e instanceof Date))
    throw new Error([`MUI X: \`${t}\` column type only accepts \`Date\` objects as values.`, "Use `valueGetter` to transform the value into a `Date` object.", `Row ID: ${r}, field: "${n}".`].join(`
`));
}
const yh = (e, t, r, n) => {
  if (!e)
    return "";
  const o = n.current.getRowId(t);
  return Fl({
    value: e,
    columnType: "date",
    rowId: o,
    field: r.field
  }), e.toLocaleDateString();
}, bh = (e, t, r, n) => {
  if (!e)
    return "";
  const o = n.current.getRowId(t);
  return Fl({
    value: e,
    columnType: "dateTime",
    rowId: o,
    field: r.field
  }), e.toLocaleString();
}, vh = ce({}, Nl, {
  type: "date",
  sortComparator: $l,
  valueFormatter: yh,
  filterOperators: Ml(),
  renderEditCell: _l,
  // @ts-ignore
  pastedValueParser: (e) => new Date(e)
}), Ch = ce({}, Nl, {
  type: "dateTime",
  sortComparator: $l,
  valueFormatter: bh,
  filterOperators: Ml(!0),
  renderEditCell: _l,
  // @ts-ignore
  pastedValueParser: (e) => new Date(e)
});
function Sh(e) {
  return (e == null ? void 0 : e.type) === "singleSelect";
}
function ly(e, t) {
  if (e)
    return typeof e.valueOptions == "function" ? e.valueOptions(ce({
      field: e.field
    }, t)) : e.valueOptions;
}
function cy(e, t, r) {
  if (t === void 0)
    return;
  const n = t.find((o) => {
    const i = r(o);
    return String(i) === String(e);
  });
  return r(n);
}
const Bi = async () => {
  var t;
  const e = await import("./exceljs.min-DOfKj0eC.js").then((r) => r.e);
  return (t = e.default) != null ? t : e;
}, Vl = (e, t, r, n) => {
  if (!e.valueOptions)
    return [];
  let o = r;
  return e.valueFormatter && (o = o.map((i) => typeof i == "object" ? i : String(e.valueFormatter(i, t, e, {
    current: n
  })))), o.map((i) => typeof i == "object" ? i.label : i);
}, wh = (e, t, r, n, o) => {
  const i = {}, s = {}, l = [], u = r.current.getCellParams(e, t[0].field).rowNode.depth, f = Bg(r);
  return f && r.current.calculateColSpan({
    rowId: e,
    minFirstColumn: 0,
    maxLastColumn: t.length,
    columns: t
  }), t.forEach((d, m) => {
    const h = f ? r.current.unstable_getCellColSpanInfo(e, m) : void 0;
    if (h && h.spannedByColSpan)
      return;
    h && h.cellProps.colSpan > 1 && l.push({
      leftIndex: m + 1,
      rightIndex: m + h.cellProps.colSpan
    });
    const y = r.current.getCellParams(e, d.field);
    let p;
    switch (y.colDef.type) {
      case "singleSelect": {
        const v = y.colDef;
        if (typeof v.valueOptions == "function") {
          const O = v.valueOptions({
            id: e,
            row: i,
            field: y.field
          }), C = Vl(v, i, O, r.current);
          s[v.field] = {
            type: "list",
            allowBlank: !0,
            formulae: [`"${C.map((b) => b.toString().replaceAll(",", "CHAR(44)")).join(",")}"`]
          };
        } else {
          const O = n[d.field].address;
          s[v.field] = {
            type: "list",
            allowBlank: !0,
            formulae: [O]
          };
        }
        const w = r.current.getCellParams(e, v.field).formattedValue;
        process.env.NODE_ENV !== "production" && String(y.formattedValue) === "[object Object]" && kt(["MUI X: When the value of a field is an object or a `renderCell` is provided, the Excel export might not display the value correctly.", "You can provide a `valueFormatter` with a string representation to be used."]), eh(w) ? i[v.field] = w == null ? void 0 : w.label : i[v.field] = w;
        break;
      }
      case "boolean":
      case "number":
        p = r.current.getCellParams(e, d.field).value;
        break;
      case "date":
      case "dateTime": {
        const v = r.current.getCellParams(e, d.field).value;
        if (!v)
          break;
        const w = new Date(Date.UTC(v.getFullYear(), v.getMonth(), v.getDate(), v.getHours(), v.getMinutes(), v.getSeconds()));
        i[d.field] = w;
        break;
      }
      case "actions":
        break;
      default:
        p = r.current.getCellParams(e, d.field).formattedValue, process.env.NODE_ENV !== "production" && String(y.formattedValue) === "[object Object]" && kt(["MUI X: When the value of a field is an object or a `renderCell` is provided, the Excel export might not display the value correctly.", "You can provide a `valueFormatter` with a string representation to be used."]);
        break;
    }
    typeof p == "string" && o.escapeFormulas && ["=", "+", "-", "@", "	", "\r"].includes(p[0]) && (p = `'${p}`), typeof p != "undefined" && (i[d.field] = p);
  }), {
    row: i,
    dataValidation: s,
    outlineLevel: u,
    mergedCells: l
  };
}, Fo = {
  [vh.type]: {
    numFmt: "dd.mm.yyyy"
  },
  [Ch.type]: {
    numFmt: "dd.mm.yyyy hh:mm"
  }
}, xh = (e, t) => {
  var o;
  const {
    field: r,
    type: n
  } = e;
  return {
    key: r,
    headerText: (o = e.headerName) != null ? o : e.field,
    // Excel width must stay between 0 and 255 (https://support.microsoft.com/en-us/office/change-the-column-width-and-row-height-72f5e3cc-994d-43e8-ae58-9774a0905f46)
    // From the example of column width behavior (https://docs.microsoft.com/en-US/office/troubleshoot/excel/determine-column-widths#example-of-column-width-behavior)
    // a value of 10 corresponds to 75px. This is an approximation, because column width depends on the font-size
    width: Math.min(255, e.width ? e.width / 7.5 : 8.43),
    style: ce({}, n && (Fo == null ? void 0 : Fo[n]), t == null ? void 0 : t[r])
  };
}, Ll = (e, t, r, n) => {
  const o = Math.max(...t.map(({
    key: i
  }) => {
    var s, l;
    return (l = (s = r[i]) == null ? void 0 : s.length) != null ? l : 0;
  }));
  if (o !== 0)
    for (let i = 0; i < o; i += 1) {
      const s = t.map(({
        key: d
      }) => {
        const m = r[d];
        return m.length <= i ? {
          groupId: null,
          parents: m
        } : ce({}, n[m[i]], {
          parents: m.slice(0, i)
        });
      }), c = e.addRow(s.map((d) => {
        var m;
        return d.groupId === null ? null : (m = d == null ? void 0 : d.headerName) != null ? m : d.groupId;
      })).worksheet.rowCount;
      let u = 0, f = 1;
      for (; f < t.length; ) {
        const {
          groupId: d,
          parents: m
        } = s[u], {
          groupId: h,
          parents: y
        } = s[f];
        d === h && m.length === y.length && m.every((v, w) => y[w] === v) || (f - u > 1 && e.mergeCells(c, u + 1, c, f), u = f), f += 1;
      }
      f - u > 1 && e.mergeCells(c, u + 1, c, f);
    }
};
function Eh(e, t) {
  return e.map((r) => xh(r, t));
}
async function Oh(e, t, r) {
  const n = e.filter((l) => Sh(l) && Array.isArray(l.valueOptions)), o = await Bi(), s = new o.Workbook().addWorksheet("Sheet1");
  return s.columns = n.map((l) => ({
    key: l.field
  })), n.reduce((l, c) => {
    var p;
    const u = c, f = Vl(u, {}, u.valueOptions, r), m = [(p = c.headerName) != null ? p : c.field, ...f], h = s.getColumn(c.field).letter, y = `${t}!$${h}$2:$${h}$${m.length}`;
    return l[c.field] = {
      values: m,
      address: y
    }, l;
  }, {});
}
function jl(e, t) {
  const {
    row: r,
    dataValidation: n,
    outlineLevel: o,
    mergedCells: i
  } = e, s = t.addRow(r);
  Object.keys(n).forEach((c) => {
    s.getCell(c).dataValidation = ce({}, n[c]);
  }), o && (s.outlineLevel = o);
  const l = s.worksheet.rowCount;
  i.forEach((c) => {
    t.mergeCells(l, c.leftIndex, l, c.rightIndex);
  });
}
async function Bl(e, t, r) {
  if (Object.keys(e).length === 0)
    return;
  const n = r.addWorksheet(t);
  n.columns = Object.keys(e).map((o) => ({
    key: o
  })), Object.entries(e).forEach(([o, {
    values: i
  }]) => {
    n.getColumn(o).values = i;
  });
}
async function uy(e, t) {
  const {
    columns: r,
    rowIds: n,
    includeHeaders: o,
    includeColumnGroupsHeaders: i,
    valueOptionsSheetName: s = "Options",
    exceljsPreProcess: l,
    exceljsPostProcess: c,
    columnsStyles: u = {}
  } = e, f = await Bi(), d = new f.Workbook(), m = d.addWorksheet("Sheet1"), h = Eh(r, u);
  if (m.columns = h, l && await l({
    workbook: d,
    worksheet: m
  }), i) {
    const p = r.reduce((v, w) => (v[w.field] = t.current.getColumnGroupPath(w.field), v), {});
    Ll(m, h, p, t.current.getAllGroupDetails());
  }
  o && m.addRow(r.map((p) => {
    var v;
    return (v = p.headerName) != null ? v : p.field;
  }));
  const y = await Oh(r, s, t.current);
  return Bl(y, s, d), t.current.resetColSpan(), n.forEach((p) => {
    const v = wh(p, r, t, y, e);
    jl(v, m);
  }), t.current.resetColSpan(), c && await c({
    workbook: d,
    worksheet: m
  }), d;
}
function fy(e = {}) {
  addEventListener("message", async (t) => {
    var p;
    const {
      serializedColumns: r,
      serializedRows: n,
      options: o,
      valueOptionsSheetName: i,
      valueOptionsData: s,
      columnGroupDetails: l,
      columnGroupPaths: c
    } = t.data, {
      exceljsPostProcess: u,
      exceljsPreProcess: f
    } = e, d = await Bi(), m = new d.Workbook(), h = m.addWorksheet("Sheet1");
    h.columns = r, f && await f({
      workbook: m,
      worksheet: h
    }), o.includeColumnGroupsHeaders && Ll(h, r, c, l), ((p = o.includeHeaders) == null || p) && h.addRow(r.map((v) => v.headerText)), Bl(s, i, m), n.forEach((v) => {
      jl(v, h);
    }), u && await u({
      workbook: m,
      worksheet: h
    }), postMessage(await m.xlsx.writeBuffer());
  });
}
export {
  hr as $,
  Nf as A,
  Tp as B,
  cf as C,
  an as D,
  _n as E,
  $p as F,
  Ve as G,
  nl as H,
  Io as I,
  qm as J,
  oo as K,
  Ei as L,
  Lt as M,
  Uo as N,
  Rf as O,
  a as P,
  Sa as Q,
  _f as R,
  Vn as S,
  ri as T,
  Yr as U,
  ot as V,
  Vi as W,
  _h as X,
  Qm as Y,
  Km as Z,
  Mp as _,
  ru as a,
  jg as a$,
  Zm as a0,
  Xm as a1,
  Nh as a2,
  Gm as a3,
  Fi as a4,
  Hm as a5,
  Si as a6,
  Mh as a7,
  Mo as a8,
  jf as a9,
  bl as aA,
  Fh as aB,
  Nl as aC,
  Xt as aD,
  Vh as aE,
  Xh as aF,
  Rl as aG,
  Qh as aH,
  er as aI,
  Il as aJ,
  Jh as aK,
  Sh as aL,
  ly as aM,
  cy as aN,
  hl as aO,
  hd as aP,
  eh as aQ,
  Ch as aR,
  vh as aS,
  co as aT,
  Fg as aU,
  ey as aV,
  Uh as aW,
  Li as aX,
  Wh as aY,
  Bg as aZ,
  io as a_,
  bi as aa,
  yi as ab,
  fi as ac,
  tn as ad,
  At as ae,
  An as af,
  Ri as ag,
  Pf as ah,
  Ja as ai,
  Hs as aj,
  zs as ak,
  Ff as al,
  Dh as am,
  ts as an,
  jt as ao,
  Pp as ap,
  eg as aq,
  Ci as ar,
  _i as as,
  Oa as at,
  Pi as au,
  ce as av,
  gg as aw,
  lo as ax,
  Cl as ay,
  cn as az,
  Sr as b,
  ty as b0,
  vi as b1,
  zh as b2,
  hg as b3,
  ry as b4,
  Gt as b5,
  no as b6,
  Jr as b7,
  Hh as b8,
  qh as b9,
  Wn as bA,
  oy as bB,
  kl as bC,
  Vg as bD,
  Lh as bE,
  tr as bF,
  uy as bG,
  Oh as bH,
  Eh as bI,
  wh as bJ,
  kh as bK,
  Dl as bL,
  Hg as bM,
  Ml as bN,
  ph as bO,
  fh as bP,
  $l as bQ,
  yh as bR,
  bh as bS,
  Qg as bT,
  _l as bU,
  qg as bV,
  uo as ba,
  tt as bb,
  _o as bc,
  yl as bd,
  vl as be,
  Zh as bf,
  kt as bg,
  Tl as bh,
  cs as bi,
  ih as bj,
  iy as bk,
  ah as bl,
  ay as bm,
  us as bn,
  sy as bo,
  lh as bp,
  $g as bq,
  Pl as br,
  ny as bs,
  Kh as bt,
  Yh as bu,
  Gh as bv,
  Gg as bw,
  ml as bx,
  Bh as by,
  jh as bz,
  Ih as c,
  gf as d,
  sf as e,
  ar as f,
  Tc as g,
  xi as h,
  sr as i,
  Da as j,
  He as k,
  Ge as l,
  vt as m,
  Ah as n,
  Q as o,
  gt as p,
  be as q,
  zo as r,
  fy as s,
  Ue as t,
  Ds as u,
  or as v,
  Rp as w,
  Nt as x,
  Vf as y,
  No as z
};
//# sourceMappingURL=excelSerializer-CMwln0Na.js.map
